webpackJsonp([0],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return demandCollectionValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return demandValidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jjv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demandSchema_json__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demandSchema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__demandSchema_json__);
/**
 * Created by Greg on 5/9/2016.
 * Works with demand objects of the form:

 Example:
 {   "id": "DemandsNet1",
     "desc": "Example demands for network 1",
     "demandList": [
         {"source": "H1", "target": "H2", "demand": 51.3},
         {"source": "H2", "target": "S3", "demand": 21.0}]
 }
 */



/**
 * Demand validator checks for valid JSON, schema compliance, and
 * the for compatibility of the demands with the current network.
 *
 * @param demandString The JSON string of paths to validate
 * @returns object
 */
function demandCollectionValidate(demandString) {
    var demandObj = null,
        errors = null;
    try {
        demandObj = JSON.parse(demandString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (demandObj) {
        var env = __WEBPACK_IMPORTED_MODULE_0_jjv___default()();
        env.checkRequired = true;
        errors = env.validate(__WEBPACK_IMPORTED_MODULE_1__demandSchema_json__, demandObj);
    }
    return { errors: errors, demandObj: demandObj };
}

function demandValidate(demand, net) {
    var nodes = net.nodes;
    var srcNode = nodes.find(function (n) {
        return n.id === demand.source;
    });
    if (!srcNode) {
        return false;
    }
    var trgNode = nodes.find(function (n) {
        return n.id === demand.target;
    });
    if (!trgNode) {
        return false;
    }
    return true;
}



/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NET_ACTION; });
/* unused harmony export NetDraw */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetDrawContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_d3_wrap__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_d3_wrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_d3_wrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_demandValid__ = __webpack_require__(108);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/**
 Used to draw the node shapes for different types of
 network nodes. Also adds class attributes for styling
 including layer information.
 @method nodeShape
 @param d Node information object.
 */
function nodeShape(d) {
    var r = 15;
    var layer = "";
    if ('layer' in d) {
        layer = " " + d['layer'];
    }
    var type = "switch";
    if (d.type !== undefined) {
        type = d.type;
    }
    switch (type) {
        case "switch":
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).append("circle").classed("node_shape switch" + layer, true).attr("r", r);
            break;
        case "host":
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).append("rect").classed("node_shape host" + layer, true).attr("width", 30).attr("height", 30).attr("x", -15).attr("y", -15);
            break;
        case "data_center":
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).append("rect").classed("node_shape data_center" + layer, true).attr("width", 30).attr("height", 30).attr("x", -15).attr("y", -15);
            break;
        case "user_region":
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).append("ellipse").classed("node_shape user_region" + layer, true).attr("rx", 30).attr("ry", 15);
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).append("circle").attr("class", "node_shape unknown").attr("r", r);
    }
}

var NET_ACTION = {
    NONE: "None",
    NEW: "New",
    SHOW_DEMANDS: "ShowDemands",
    SHOW_CAPACITY: "ShowCapacity",
    MODE_CHANGE: "ModeChange",
    NET_CHANGE: "NetChange",
    NODE_SELECT: "NodeSelect",
    LINK_SELECT: "LinkSelect",
    NODE_LINK_SELECT: "NodeLinkSelect",
    NET_RESIZE: "Net_Resize"

};
// Try some network drawing
var NetDraw = __WEBPACK_IMPORTED_MODULE_2_react_d3_wrap___default()({
    propTypes: {
        net: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired,
        netVisInteract: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired,
        demands: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
        netAction: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,
        linkClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,
        nodeClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,
        panelClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,
        linkDblClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,
        nodeDblClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func

    },
    getInitialState: function getInitialState() {
        return { width: null, height: null };
    },
    initialize: function initialize(svg, data, options) {
        // We keep track of size to see if we really need to re-scale.
        this.oldWidth = this.props.width;
        this.oldHeight = this.props.height;
    },


    oldWidth: null,
    oldHeight: null,

    update: function update(svg, data, options) {
        var that = this;
        var net = this.props.net;
        var action = this.props.netAction;
        var demands = this.props.demands.demandList.filter(function (d) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validation_demandValid__["b" /* demandValidate */])(d, net);
        });
        var netVisInteract = this.props.netVisInteract;
        // console.log("NetDraw update called, action: " + action.type);
        // console.log("netdraw size width:" + this.props.width + " height: " + this.props.height);
        // console.log("old size width: " + this.oldWidth + " height: " + this.oldHeight);
        var clickFuncs = {
            nodeClick: genNodeClick.bind(this),
            linkClick: this.props.linkClick,
            panelClick: genPanelClick.bind(this),
            nodeDblClick: genNodeDblClick.bind(this),
            linkDblClick: genLinkDblClick.bind(this)
        };

        switch (action.type) {
            case NET_ACTION.NEW:
                drawNet(svg, net, demands, netVisInteract, clickFuncs, true);
                scaleAndCenter(svg);
                break;
            case NET_ACTION.NET_CHANGE:
            case NET_ACTION.MODE_CHANGE:
                drawNet(svg, net, demands, netVisInteract, clickFuncs, false);
                nodeHighlighter(svg, netVisInteract);
                linkHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NONE:
                // Yup we don't do anything yet.
                break;
            case NET_ACTION.SHOW_CAPACITY:
                vizCapacity(svg, net, netVisInteract);
                break;
            case NET_ACTION.LINK_SELECT:
                linkHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NODE_SELECT:
                nodeHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NODE_LINK_SELECT:
                linkHighlighter(svg, netVisInteract);
                nodeHighlighter(svg, netVisInteract);
                break;
            case NET_ACTION.NET_RESIZE:
                if (this.props.width !== this.oldWidth || this.props.height !== this.oldHeight) {
                    scaleAndCenter(svg);
                }
                break;
            case NET_ACTION.SHOW_DEMANDS:
                vizDemands(svg, netVisInteract);
                break;
        }
        this.oldWidth = this.props.width;
        this.oldHeight = this.props.height;
    }
});

function drawNet(svg, net, demands, netVisInteract, clickFuncs, newNet) {
    var self = this;

    var netNodes = net.nodes,
        netLinks = net.links,
        nodeLinkMap = [],
        // Used to enable the dragging of nodes with links
    nodeDemandMap = [],
        // Use to enable the dragging of nodes with demands
    strNodeIndex = {},
        // goes from string node id to nodes position in node array. Used with dragmove; Could be set outside
    netGroup = void 0; // Used to hold drawing for easy pan/zoom

    var netSVG = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg);
    switch (netVisInteract.mouseMode) {
        case "view":
            netSVG.style('cursor', 'default');
            break;
        case "edit":
            netSVG.style('cursor', 'crosshair');
            break;
        default:
            netSVG.style('cursor', 'default');
    }
    if (newNet) {
        netSVG.selectAll("*").remove();
        netGroup = netSVG.append("svg:g");
        // Set up click listener, pan and zoom. Note that we listen for
        // pan & zoom events on the netSVG and then transform the *netGroup*!
        netSVG.on('click', function () {
            var curCoords = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.mouse(netGroup[0][0]);
            clickFuncs.panelClick({ x: curCoords[0], y: curCoords[1] });
        }).call(__WEBPACK_IMPORTED_MODULE_1_d3___default.a.behavior.zoom().on('zoom', function () {
            netGroup.attr('transform', "translate(" + __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.translate + ")" + " scale(" + __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.scale + ")");
        }).scaleExtent([0.1, 10.0])).on("mousedown", function () {
            __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation();
        }).on("dblclick.zoom", null);
    } else {
        netGroup = netSVG.select("g");
    }

    var i = void 0;
    // Set up the node string to index map
    for (i = 0; i < netNodes.length; i++) {
        strNodeIndex[netNodes[i].id] = i;
    }
    for (i = 0; i < netNodes.length; i++) {
        nodeLinkMap.push({
            "start": [],
            "end": []
        });
        nodeDemandMap.push({
            "start": [],
            "end": []
        });
    }

    // Draw the links in first, then the demands, and then the nodes on top of them.
    // link class attribute includes information on layer or adaptation.

    var linkKey = function linkKey(d) {
        return d.source + "-" + d.target;
    };
    var allLinks = netGroup.selectAll("line.netLink").data(netLinks, linkKey);
    allLinks.exit().remove();
    // Add a line element for each new link, put them before the first network node if any
    allLinks.enter().insert("line", "g.netNode");
    // Adjust classes and attributes
    var linkWidth = 3; // TODO: bring in as a property
    allLinks.attr("class", function (d) {
        var cstring = 'netLink';
        var srcNode = netNodes[strNodeIndex[d.source]];
        var dstNode = netNodes[strNodeIndex[d.target]];
        var layer = srcNode.layer === dstNode.layer ? srcNode.layer : "adaptation";
        if (layer) {
            cstring += ' ' + layer;
        }
        return cstring;
    }).attr("x1", function (d) {
        return netNodes[strNodeIndex[d.source]].x;
    }).attr("y1", function (d) {
        return netNodes[strNodeIndex[d.source]].y;
    }).attr("x2", function (d) {
        return netNodes[strNodeIndex[d.target]].x;
    }).attr("y2", function (d) {
        return netNodes[strNodeIndex[d.target]].y;
    }).style("stroke-width", linkWidth).on('click', function (d) {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation();
        clickFuncs.linkClick(d);
    }).style('cursor', 'pointer').on('dblclick', function (d) {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation();
        clickFuncs.linkDblClick(d);
    });
    // Populate the map of nodes to links objects
    allLinks.each(function (d) {
        nodeLinkMap[strNodeIndex[d.source]].start.push(this);
        nodeLinkMap[strNodeIndex[d.target]].end.push(this);
    });

    // Draw in the demands if any
    var demandKey = function demandKey(d) {
        return d.source + "-" + d.target;
    };
    var allDemands = netGroup.selectAll("line.netDemand").data(demands, demandKey);
    allDemands.exit().remove();
    // Add a line element for each new link, put them before the first network node if any
    allDemands.enter().insert("line", "g.netNode");
    // Adjust classes and attributes
    var demandWidth = netVisInteract.demandWidth,
        showDemand = netVisInteract.showDemands;
    allDemands.classed({ 'netDemand': true, 'hidden': !showDemand }).attr("x1", function (d) {
        return netNodes[strNodeIndex[d.source]].x;
    }).attr("y1", function (d) {
        return netNodes[strNodeIndex[d.source]].y;
    }).attr("x2", function (d) {
        return netNodes[strNodeIndex[d.target]].x;
    }).attr("y2", function (d) {
        return netNodes[strNodeIndex[d.target]].y;
    }).style("stroke-width", demandWidth);
    // Populate the map of nodes to links objects
    allDemands.each(function (d) {
        nodeDemandMap[strNodeIndex[d.source]].start.push(this);
        nodeDemandMap[strNodeIndex[d.target]].end.push(this);
    });

    var nodeKey = function nodeKey(d) {
        return d.id + d.layer + d.type;
    };

    var nodeGroups = netGroup.selectAll("g.netNode").data(netNodes, nodeKey);

    nodeGroups.exit().remove();
    nodeGroups.enter().append("g").attr("class", "netNode").attr("transform", function (d) {
        var x = d.x;
        var y = d.y;
        return "translate(" + x + "," + y + ")";
    }).on("mousedown", function () {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation(); // Trying to stop the event propagation...
    }).on('click', function (d) {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation();
        clickFuncs.nodeClick(d);
    }).on('dblclick', function (d) {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.stopPropagation();
        clickFuncs.nodeDblClick(d);
        // console.log("You Doubleclick node: " + d.id);
        // console.log(d3.event);
    }).style('cursor', 'pointer').each(nodeShape).append("text").attr("class", "node_label").attr("dy", ".35em") // vertical-align: middle
    .attr("text-anchor", "middle") // text-align: right
    .text(function (d) {
        return d.id;
    });

    // To make sure nodes are still draggable on any addition or removal of links we
    // update the drag functionality on all nodes.
    var drag = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.behavior.drag().on("drag", dragMove); //.on("dragend", dragEnd);
    if (netVisInteract.mouseMode === 'edit') {
        nodeGroups.call(drag);
    } else {
        nodeGroups.on('.drag', null);
    }
    /**
     * Helper function used to drag graph nodes along with their connected links
     * @method dragmove
     */
    function dragMove() {
        __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(this).attr("transform", function (d) {
            var y = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.y;
            var x = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.x;
            d.x = x;
            d.y = y; // Update data
            // Trying to see how we can track position updates
            var nindex = netNodes.findIndex(function (n) {
                return n.id === d.id;
            });
            // console.log("You are trying to drag node: " + netNodes[nindex].id);
            var i2 = strNodeIndex[d.id];
            var j = void 0;
            // Update all links starting or ending on the node
            for (j = 0; j < nodeLinkMap[i2].start.length; j++) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(nodeLinkMap[i2].start[j]).attr("x1", x).attr("y1", y);
            }
            for (j = 0; j < nodeLinkMap[i2].end.length; j++) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(nodeLinkMap[i2].end[j]).attr("x2", x).attr("y2", y);
            }
            // Update all demands starting or ending on the node
            for (j = 0; j < nodeDemandMap[i2].start.length; j++) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(nodeDemandMap[i2].start[j]).attr("x1", x).attr("y1", y);
            }
            for (j = 0; j < nodeDemandMap[i2].end.length; j++) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(nodeDemandMap[i2].end[j]).attr("x2", x).attr("y2", y);
            }
            return "translate(" + x + "," + y + ")";
        });
    }

    // function dragEnd() {
    //     var data = d3.select(this).datum();
    //     console.log("drag end called on " + data.id + "new position: " +
    //                "(" + data.x.toString() + ", " + data.y.toString() + ")");
    // }
    vizCapacity(svg, net, netVisInteract);
}

function scaleAndCenter(svg) {
    // console.log("Scale and center called");
    var svgBounds = svg.getBoundingClientRect();
    var width = svgBounds.width;
    var height = svgBounds.height;
    var avgSize = 30;
    // let svgMatrix = svg.getScreenCTM();
    // console.log(svgBounds);
    // console.log(svgMatrix);
    var netSVG = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg);
    var netGroup = netSVG.select("g");
    // Get all the nodes and their coordinates
    var nodeGroups = netGroup.selectAll("g.netNode");
    if (nodeGroups[0].length === 0) {
        // In case network is empty
        return;
    }
    var minX = Infinity,
        maxX = 0,
        minY = Infinity,
        maxY = 0;
    nodeGroups.each(function (d, i) {
        // May want to just get these values from the network nodes directly
        var myx = this.transform.baseVal.getItem(0).matrix.e;
        var myy = this.transform.baseVal.getItem(0).matrix.f;
        minX = Math.min(minX, myx);
        maxX = Math.max(maxX, myx);
        minY = Math.min(minY, myy);
        maxY = Math.max(maxY, myy);
    });
    //console.log("Min x: " + minX + " max x: " + maxX + " min y: " + minY + " max y: " + maxY);
    var xrange = maxX - minX + 2 * avgSize;
    var yrange = maxY - minY + 2 * avgSize;
    var scale = Math.min(width / xrange, height / yrange);
    var xoff = -scale * minX + avgSize / 2 + Math.max(0, (width - scale * xrange) / 2);
    var yoff = -scale * minY + avgSize / 2 + Math.max(0, (height - scale * yrange) / 2);
    netGroup.attr('transform', "translate(" + xoff + "," + yoff + ")" + " scale(" + scale + ")");
}

function vizCapacity(svg, net, netVisInteract) {
    var netGroup = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg).select("g");
    if (netVisInteract.capVis.showCap) {
        var linkCaps = net.links.map(function (l) {
            return l.capacity;
        });
        var minCap = Math.min.apply(Math, _toConsumableArray(linkCaps));
        var maxCap = Math.max.apply(Math, _toConsumableArray(linkCaps));
        var minWidth = netVisInteract.capVis.minWidth;
        var maxWidth = netVisInteract.capVis.maxWidth;
        var scale = 0.0;
        if (maxCap > minCap) {
            scale = (maxWidth - minWidth) / (maxCap - minCap);
        }
        netGroup.selectAll("line.netLink").style("stroke-width", function (d) {
            return minWidth + (d.capacity - minCap) * scale;
        });
        netGroup.selectAll("line.netDemand").style("stroke-width", function (d) {
            return minWidth + Math.max(d.demand - minCap, 0.0) * scale;
        });
    } else {
        var linkWidth = netVisInteract.linkWidth;
        var demandWidth = netVisInteract.demandWidth;
        netGroup.selectAll("line.netLink").style("stroke-width", linkWidth);
        netGroup.selectAll("line.netDemand").style("stroke-width", demandWidth);
    }
}

function vizDemands(svg, netVisInteract) {
    var netGroup = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg).select("g");
    netGroup.selectAll("line.netDemand").classed('hidden', !netVisInteract.showDemands);
}

/**
 *  Highlights selected nodes. Observes the selected nodes array.
 *  @method nodeHighlighter
 */
function nodeHighlighter(svg, netVisInteract) {
    var selectedNodes = netVisInteract.selectedNodes;
    var netGroup = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg).select("g");
    netGroup.selectAll("g.netNode").classed('highlight', function (d) {
        return selectedNodes.indexOf(d.id) !== -1;
    });
}

/**
 *  Highlights selected links. Observes the selected links array.
 *  @method linkHighlighter
 */
function linkHighlighter(svg, netVisInteract) {
    var selectedLinks = netVisInteract.selectedLinks;
    var netGroup = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select(svg).select("g");
    netGroup.selectAll("line.netLink").classed('highlight', function (d) {
        return selectedLinks.find(function (sl) {
            return sl[0] === d.source && sl[1] === d.target;
        });
    });
}

/* Can't put logic that uses state information into dispactch functions
    so we'll put it in a separate function
 */
function genPanelClick(coords) {
    if (this.props.netVisInteract.mouseMode === 'edit') {
        this.props.nodeAddClick(coords);
    } else {
        this.props.panelClick(coords);
    }
}

/* Understands the different conditions and actions to be taken for node
   clicks, i.e., whether we are in "edit" or "view" or some other future mode
   of operation.
*/
function genNodeClick(node) {
    var selectedNodes = this.props.netVisInteract.selectedNodes;
    if (this.props.netVisInteract.mouseMode !== 'edit' || selectedNodes.length < 1) {
        this.props.nodeClick(node);
        return;
    }
    // check if node already selected
    if (selectedNodes.find(function (n) {
        return n === node.id;
    })) {
        // this will unselected it
        this.props.nodeClick(node);
        return;
    }
    if (selectedNodes.length === 1) {
        var nodes = this.props.net.nodes;
        var srcId = selectedNodes[0];
        var dstId = node.id;
        var srcNode = nodes.find(function (n) {
            return n.id === srcId;
        });
        var dstNode = nodes.find(function (n) {
            return n.id === dstId;
        });
        var links = this.props.net.links;
        if (links.find(function (l) {
            return l.source === srcId && l.target === dstId;
        }) || links.find(function (l) {
            return l.source === dstId && l.target === srcId;
        })) {
            alert('Link ' + srcId + '-' + dstId + ' is already in the network, Parallel links not currently supported.');
            this.props.nodeClick(node);
            return;
        } else {
            var layer = srcNode.layer === dstNode.layer ? srcNode.layer : "adaptation";
            var linkInfo = {};
            linkInfo.source = srcId;
            linkInfo.target = dstId;
            linkInfo.layer = layer;
            this.props.linkAdd(linkInfo);
        }
    }
}

/* Understands the different conditions and actions to be taken for node
   double clicks, i.e., whether we are in "edit" or "view" or some other future mode
   of operation.
*/
function genNodeDblClick(node) {
    // console.log("in genNodeDblClick");
    if (this.props.netVisInteract.mouseMode !== 'edit') {
        this.props.nodeClick(node);
        return;
    }
    // Otherwise clear out all other selected nodes and links and send message
    // to bring up node edit dialog
    this.props.nodeEdit(node);
}

function genLinkDblClick(link) {
    if (this.props.netVisInteract.mouseMode == 'edit') {
        this.props.linkEdit(link);
    }
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        net: state.net,
        demands: state.demands,
        netAction: state.netAction,
        netVisInteract: state.netVisInteract,
        data: []
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        nodeClick: function nodeClick(node) {
            dispatch({ type: 'NODE_CLICK', node: node });
        },
        linkClick: function linkClick(link) {
            dispatch({ type: 'LINK_CLICK', link: link });
        },
        panelClick: function panelClick(coords) {
            dispatch({ type: 'PANEL_CLICK', coords: coords });
        },
        nodeAddClick: function nodeAddClick(coords) {
            dispatch({ type: 'PRE_NET_NODE_ADD', coords: coords });
        },
        linkAdd: function linkAdd(linkInfo) {
            dispatch({ type: 'PRE_NET_LINK_ADD', linkInfo: linkInfo });
        },

        nodeEdit: function nodeEdit(node) {
            dispatch({ type: 'PRE_NODE_EDIT', node: node });
        },

        linkEdit: function linkEdit(link) {
            dispatch({ type: 'PRE_LINK_EDIT', link: link });
        }

    };
};

var NetDrawContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(NetDraw);

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_ModalDialog__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_ModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_ModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_draggable__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_draggable__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Created by Greg on 4/8/2016.
 * Based on code from https://gist.github.com/burgalon/870a68de68c5ed15c416fab63589d503
 * 
 */





var DraggableModalDialog = function (_React$Component) {
    _inherits(DraggableModalDialog, _React$Component);

    function DraggableModalDialog() {
        _classCallCheck(this, DraggableModalDialog);

        return _possibleConstructorReturn(this, (DraggableModalDialog.__proto__ || Object.getPrototypeOf(DraggableModalDialog)).apply(this, arguments));
    }

    _createClass(DraggableModalDialog, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_draggable___default.a,
                { handle: '.modal-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_lib_ModalDialog___default.a, this.props)
            );
        }
    }]);

    return DraggableModalDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* Example usage: (note that the enforceFocus={false} is important here).

            <Modal dialogComponent={DraggableModalDialog}
           enforceFocus={false} backdrop="static" show={this.props.open} onHide={this.props.close}
                   dialogClassName="add-node-net-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add a Network Node</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                ... Just the usual stuff here.
  */


/* harmony default export */ __webpack_exports__["a"] = (DraggableModalDialog);

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(364);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(70)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./myStyle.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./myStyle.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrapcss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrapcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrapcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_react_grid_layout_css_styles_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_react_grid_layout_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__node_modules_react_grid_layout_css_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_react_resizable_css_styles_css__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_modules_react_resizable_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__node_modules_react_resizable_css_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_react_bootstrap_table_css_react_bootstrap_table_css__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_react_bootstrap_table_css_react_bootstrap_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_react_bootstrap_table_css_react_bootstrap_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__myStyle_css__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__myStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__myStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_reducers__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(315);
/* global $, document */
// Third party














/*
    Instead of this line to create the store:
let store = createStore(netVizApp);

    I'm using the following to enable Redux chrome tools
 */
function configureStore(initialState) {
    var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_10__reducers_reducers__["a" /* default */], initialState, window.devToolsExtension ? window.devToolsExtension() : undefined);
    return store;
}

__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],
    { store: configureStore() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__App__["a" /* AppContainer */], null)
), document.getElementById('PageContent'));

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

module.exports = { "directed": false, "multigraph": false, "graph": { "name": "ExNetwithLoops1B", "desc": "A Mininet network generation example network" }, "nodes": [{ "ipv4": "10.0.0.2", "mac": "00:00:00:00:00:02", "y": 358, "x": 456, "type": "host", "id": "H8" }, { "ipv4": "10.0.0.3", "mac": "00:00:00:00:00:03", "y": 211, "x": 607, "type": "host", "id": "H9" }, { "ipv4": "10.0.0.4", "mac": "00:00:00:00:00:04", "y": 123, "x": 125, "type": "host", "id": "H2" }, { "ipv4": "10.0.0.5", "mac": "00:00:00:00:00:05", "y": 176, "x": 171, "type": "host", "id": "H3" }, { "y": 142, "x": 209, "type": "switch", "id": "S1" }, { "ipv4": "10.0.0.6", "mac": "00:00:00:00:00:06", "y": 61, "x": 204, "type": "host", "id": "H1" }, { "ipv4": "10.0.0.7", "mac": "00:00:00:00:00:07", "y": 267, "x": 399, "type": "host", "id": "H6" }, { "ipv4": "10.0.0.8", "mac": "00:00:00:00:00:08", "y": 378, "x": 373, "type": "host", "id": "H7" }, { "y": 157, "x": 593, "type": "switch", "id": "S5" }, { "y": 323, "x": 419, "type": "switch", "id": "S4" }, { "y": 107, "x": 408, "type": "switch", "id": "S3" }, { "ipv4": "10.0.0.9", "mac": "00:00:00:00:00:09", "y": 273, "x": 155, "type": "host", "id": "H4" }, { "y": 247, "x": 230, "type": "switch", "id": "S2" }, { "ipv4": "10.0.0.10", "mac": "00:00:00:00:00:10", "y": 67, "x": 364, "type": "host", "id": "H11" }, { "ipv4": "10.0.0.11", "mac": "00:00:00:00:00:11", "y": 325, "x": 209, "type": "host", "id": "H5" }, { "ipv4": "10.0.0.12", "mac": "00:00:00:00:00:12", "y": 120, "x": 632, "type": "host", "id": "H10" }, { "ipv4": "10.0.0.13", "mac": "00:00:00:00:00:13", "y": 68, "x": 425, "type": "host", "id": "H12" }], "links": [{ "source": "H8", "capacity": 40, "weight": 2, "target": "S4", "ports": { "H8": 1, "S4": 1 } }, { "source": "H9", "capacity": 40, "weight": 2, "target": "S5", "ports": { "H9": 1, "S5": 1 } }, { "source": "H2", "capacity": 40, "weight": 2, "target": "S1", "ports": { "H2": 1, "S1": 1 } }, { "source": "H3", "capacity": 40, "weight": 2, "target": "S1", "ports": { "H3": 1, "S1": 2 } }, { "source": "S1", "capacity": 11, "weight": 20, "target": "S3", "ports": { "S1": 3, "S3": 1 } }, { "source": "S1", "capacity": 20, "weight": 7, "target": "S2", "ports": { "S1": 4, "S2": 1 } }, { "source": "S1", "capacity": 40, "weight": 2, "target": "H1", "ports": { "S1": 5, "H1": 1 } }, { "source": "H6", "capacity": 40, "weight": 2, "target": "S4", "ports": { "H6": 1, "S4": 2 } }, { "source": "H7", "capacity": 40, "weight": 2, "target": "S4", "ports": { "H7": 1, "S4": 3 } }, { "source": "S5", "capacity": 16, "weight": 10, "target": "S3", "ports": { "S5": 2, "S3": 2 } }, { "source": "S5", "capacity": 40, "weight": 2, "target": "H10", "ports": { "S5": 3, "H10": 1 } }, { "source": "S5", "capacity": 19, "weight": 27, "target": "S4", "ports": { "S5": 4, "S4": 4 } }, { "source": "S4", "capacity": 15, "weight": 17, "target": "S2", "ports": { "S4": 5, "S2": 2 } }, { "source": "S3", "capacity": 40, "weight": 2, "target": "H11", "ports": { "S3": 3, "H11": 1 } }, { "source": "S3", "capacity": 40, "weight": 2, "target": "H12", "ports": { "S3": 4, "H12": 1 } }, { "source": "S3", "capacity": 22, "weight": 23, "target": "S2", "ports": { "S3": 5, "S2": 3 } }, { "source": "H4", "capacity": 40, "weight": 2, "target": "S2", "ports": { "H4": 1, "S2": 4 } }, { "source": "S2", "capacity": 40, "weight": 2, "target": "H5", "ports": { "S2": 5, "H5": 1 } }] };

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports = { "directed": false, "multigraph": false, "graph": { "name": "KShortTest2Net", "desc": "A larger network for testing K-shortest path algorithms" }, "nodes": [{ "id": "B9", "y": 282, "x": 323 }, { "id": "A17", "y": 128, "x": 226 }, { "id": "B3", "y": 336, "x": 290 }, { "id": "C12", "y": 123, "x": 624 }, { "id": "E20", "y": 522, "x": 88 }, { "id": "D6", "y": 377, "x": 531 }, { "id": "B22", "y": 113, "x": 440 }, { "id": "D30", "y": 583, "x": 408 }, { "id": "B16", "y": 231, "x": 381 }, { "id": "D20", "y": 512, "x": 361 }, { "id": "B28", "y": 47, "x": 368 }, { "id": "A28", "y": 205, "x": 237 }, { "id": "E5", "y": 358, "x": 164 }, { "id": "C17", "y": 181, "x": 505 }, { "id": "D14", "y": 456, "x": 526 }, { "id": "E17", "y": 486, "x": 209 }, { "id": "C29", "y": 321, "x": 583 }, { "id": "E8", "y": 412, "x": 64 }, { "id": "A23", "y": 252, "x": 128 }, { "id": "E28", "y": 614, "x": 178 }, { "id": "E15", "y": 409, "x": 318 }, { "id": "A4", "y": 79, "x": 70 }, { "id": "D16", "y": 480, "x": 440 }, { "id": "D4", "y": 376, "x": 442 }, { "id": "A14", "y": 41, "x": 162 }, { "id": "A9", "y": 153, "x": 76 }, { "id": "C8", "y": 196, "x": 617 }, { "id": "B4", "y": 287, "x": 249 }, { "id": "C6", "y": 194, "x": 691 }, { "id": "C24", "y": 308, "x": 492 }], "links": [{ "weight": 102, "source": "A28", "target": "B16", "capacity": 81.875 }, { "weight": 224, "source": "E28", "target": "D30", "capacity": 64.019 }, { "weight": 142, "source": "D4", "target": "D6", "capacity": 40.516 }, { "weight": 110, "source": "B3", "target": "E5", "capacity": 32.121 }, { "weight": 81, "source": "C24", "target": "D6", "capacity": 45.521 }, { "weight": 133, "source": "C8", "target": "C29", "capacity": 44.795 }, { "weight": 197, "source": "E17", "target": "E8", "capacity": 34.939 }, { "weight": 142, "source": "A4", "target": "A9", "capacity": 21.05 }, { "weight": 156, "source": "D4", "target": "E15", "capacity": 74.775 }, { "weight": 176, "source": "A4", "target": "A17", "capacity": 76.029 }, { "weight": 133, "source": "C12", "target": "C17", "capacity": 65.197 }, { "weight": 101, "source": "B28", "target": "B22", "capacity": 38.503 }, { "weight": 119, "source": "D14", "target": "D16", "capacity": 74.763 }, { "weight": 130, "source": "D16", "target": "D20", "capacity": 80.619 }, { "weight": 156, "source": "E15", "target": "E5", "capacity": 42.848 }, { "weight": 138, "source": "D4", "target": "B3", "capacity": 78.704 }, { "weight": 142, "source": "C17", "target": "B22", "capacity": 22.645 }, { "weight": 89, "source": "B3", "target": "B9", "capacity": 53.296 }, { "weight": 92, "source": "E15", "target": "D20", "capacity": 16.62 }, { "weight": 52, "source": "B4", "target": "B3", "capacity": 57.382 }, { "weight": 145, "source": "C12", "target": "C8", "capacity": 70.503 }, { "weight": 99, "source": "B9", "target": "B4", "capacity": 93.207 }, { "weight": 154, "source": "B22", "target": "C12", "capacity": 44.809 }, { "weight": 214, "source": "C12", "target": "C6", "capacity": 48.257 }, { "weight": 129, "source": "C24", "target": "D4", "capacity": 85.166 }, { "weight": 313, "source": "A14", "target": "B28", "capacity": 18.417 }, { "weight": 141, "source": "D16", "target": "D30", "capacity": 45.135 }, { "weight": 157, "source": "A23", "target": "A9", "capacity": 57.32 }, { "weight": 129, "source": "E20", "target": "E28", "capacity": 31.495 }, { "weight": 137, "source": "D14", "target": "D4", "capacity": 84.585 }, { "weight": 107, "source": "B9", "target": "B16", "capacity": 26.604 }, { "weight": 84, "source": "C8", "target": "C6", "capacity": 20.719 }, { "weight": 223, "source": "E17", "target": "E5", "capacity": 35.543 }, { "weight": 155, "source": "E8", "target": "E20", "capacity": 32.725 }, { "weight": 114, "source": "D20", "target": "E17", "capacity": 79.061 }, { "weight": 125, "source": "E17", "target": "E20", "capacity": 73.693 }, { "weight": 152, "source": "D30", "target": "D20", "capacity": 34.417 }, { "weight": 129, "source": "C17", "target": "C29", "capacity": 78.542 }, { "weight": 152, "source": "A17", "target": "A28", "capacity": 34.216 }, { "weight": 154, "source": "C29", "target": "D6", "capacity": 95.105 }, { "weight": 263, "source": "A23", "target": "E8", "capacity": 42.133 }, { "weight": 140, "source": "C24", "target": "C29", "capacity": 69.947 }, { "weight": 193, "source": "C6", "target": "C29", "capacity": 23.699 }, { "weight": 143, "source": "B4", "target": "A23", "capacity": 30.159 }, { "weight": 114, "source": "B22", "target": "B16", "capacity": 37.919 }, { "weight": 267, "source": "A9", "target": "A28", "capacity": 94.589 }, { "weight": 110, "source": "A23", "target": "E5", "capacity": 92.007 }, { "weight": 156, "source": "E17", "target": "E28", "capacity": 86.578 }, { "weight": 194, "source": "C24", "target": "B9", "capacity": 26.079 }, { "weight": 126, "source": "C17", "target": "B16", "capacity": 24.695 }, { "weight": 111, "source": "B28", "target": "A28", "capacity": 60.894 }, { "weight": 114, "source": "B9", "target": "A28", "capacity": 68.263 }, { "weight": 135, "source": "A4", "target": "A14", "capacity": 48.704 }, { "weight": 102, "source": "D6", "target": "D14", "capacity": 59.254 }, { "weight": 176, "source": "A14", "target": "A17", "capacity": 81.505 }, { "weight": 226, "source": "E5", "target": "E8", "capacity": 33.08 }] };

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

module.exports = { "directed": false, "multigraph": false, "graph": { "name": "MultiLayer2", "desc": "A very simple multi-layer network with links" }, "nodes": [{ "id": "H1", "x": 136, "y": 52, "type": "host", "layer": "ether" }, { "id": "H2", "x": 310, "y": 56, "type": "host", "layer": "ether" }, { "id": "H3", "x": 424, "y": 49, "type": "host", "layer": "ether" }, { "id": "H4", "x": 582, "y": 58, "type": "host", "layer": "ether" }, { "id": "E1", "x": 238, "y": 106, "type": "switch", "layer": "ether" }, { "id": "E2", "x": 494, "y": 112, "type": "switch", "layer": "ether" }, { "id": "W1", "x": 212, "y": 212, "type": "switch", "layer": "wavelength" }, { "id": "W2", "x": 474, "y": 209, "type": "switch", "layer": "wavelength" }], "links": [{ "source": "H1", "target": "E1", "capacity": 10, "weight": 20 }, { "source": "H2", "target": "E1", "capacity": 10, "weight": 20 }, { "source": "H3", "target": "E2", "capacity": 10, "weight": 20 }, { "source": "H4", "target": "E2", "capacity": 10, "weight": 20 }, { "source": "E1", "target": "W1", "capacity": 10, "weight": 20 }, { "source": "E2", "target": "W2", "capacity": 10, "weight": 20 }, { "source": "W1", "target": "W2", "capacity": 100, "weight": 10 }] };

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

module.exports = { "name": "ComNetViz", "version": "1.1.0", "description": "A Web based Communications Network Visualization Tool", "main": "index.js", "scripts": { "test": "echo \"Error: no test specified\" && exit 1", "dev": "webpack-dev-server --progress --colors --content-base build/", "prod": "webpack --optimize-minimize --define process.env.NODE_ENV='\"production\"' --progress --colors --json > stats.json" }, "author": "Dr. Greg M. Bernstein", "license": "ISC", "dependencies": { "bootstrap": "^3.3.6", "d3": "^3.5.16", "jjv": "^1.0.2", "jquery": "^3.6.0", "react": "^0.14.7", "react-bootstrap": "^0.29.2", "react-bootstrap-table": "^2.1.3", "react-d3-wrap": "^2.0.0", "react-dom": "^0.14.7", "react-draggable": "^1.3.4", "react-grid-layout": "^0.11.3", "react-redux": "^4.4.1", "redux": "^3.3.1" }, "devDependencies": { "babel-core": "^6.7.2", "babel-loader": "^6.2.4", "babel-preset-es2015": "^6.22.0", "babel-preset-react": "^6.5.0", "babel-preset-stage-2": "^6.5.0", "css-loader": "^0.23.1", "file-loader": "^0.8.5", "html-loader": "^0.4.3", "html-webpack-plugin": "^2.17.0", "json-loader": "^0.5.4", "style-loader": "^0.13.0", "url-loader": "^0.5.7", "webpack": "^2.2.0", "webpack-dev-server": "^2.4.0" } };

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

module.exports = { "$schema": "http://json-schema.org/draft-04/schema#", "id": "http://grotto-networking.com/schemas/basicDemand", "title": "Demand collection format base", "descriptions": "Demand format for import and export. By Dr. Greg M. Bernstein", "type": "object", "properties": { "id": { "type": "string" }, "desc": { "type": "string" }, "demandList": { "type": "array", "items": { "type": "object", "properties": { "source": { "type": "string" }, "target": { "type": "string" }, "demand": { "type": "number", "minimum": 0 } }, "required": ["source", "target", "demand"] } } }, "required": ["demandList"] };

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

module.exports = { "$schema": "http://json-schema.org/schema#", "title": "Network Visualization Format", "descriptions": "Network Visualization format compatible with NetworkX JSON graph", "definitions": { "node": { "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "type": { "type": "string" }, "x": { "type": "number" }, "y": { "type": "number" }, "layer": { "type": "string" }, "ipv4": { "type": "string" }, "mac": { "type": "string" } }, "required": ["id", "x", "y"] }, "link": { "type": "object", "properties": { "source": { "type": "string" }, "target": { "type": "string" }, "capacity": { "type": "number", "minimum": 0 }, "weight": { "type": "number", "minimum": 0 }, "ports": { "type": "object" } }, "required": ["source", "target"] } }, "type": "object", "properties": { "nodes": { "type": "array", "items": { "$ref": "#/definitions/node" } }, "links": { "type": "array", "items": { "$ref": "#/definitions/link" } }, "graph": { "type": "object", "properties": { "name": { "type": "string" }, "desc": { "type": "string" } } }, "directed": { "type": "boolean" }, "multigraph": { "type": "boolean" } }, "required": ["nodes"] };

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

module.exports = { "$schema": "http://json-schema.org/draft-04/schema#", "id": "http://grotto-networking.com/schemas/basicpath", "title": "Path collection format base", "descriptions": "Path collection format for import and export. By Dr. Greg M. Bernstein", "type": "object", "properties": { "id": { "type": "string" }, "desc": { "type": "string" }, "pathList": { "type": "array", "items": { "type": "object", "properties": { "nodeList": { "type": "array", "items": { "type": "string" } } }, "required": ["nodeList"], "additionalProperties": true } } }, "required": ["pathList"] };

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrapcss__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrapcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrapcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__myStyle_css__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__myStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__myStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__netSamples_ExNetwithLoops1B_json__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__netSamples_ExNetwithLoops1B_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__netSamples_ExNetwithLoops1B_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__netSamples_KShortTest2Net_json__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__netSamples_KShortTest2Net_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__netSamples_KShortTest2Net_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__netSamples_MultiLayer2_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__netSamples_MultiLayer2_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__netSamples_MultiLayer2_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComputeServeDialog__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__io_LoadNetDialog__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__io_ExportNetDialog__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__netDraw_NodeAddDialog__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__netDraw_NodeEditDialog__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__netDraw_LinkAddDialog__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__netDraw_LinkEditDialog__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__netManip_IPAddressDialog__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__netManip_PortNumberDialog__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__netManip_DistanceWeightsDialog__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__netManip_RandomCapsDialog__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__validation_netValid__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validation_pathValid__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AppPanels__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pathComp_MinSpanTreeDialog__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pathComp_ShortestPathDialog__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pathComp_WidestPathDialog__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__io_LoadPathDialog__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__io_LoadDemandsDialog__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pathComp_KShortestPathsDialog__ = __webpack_require__(334);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* global $, document */
// Third party







// React-Bootstrap

//import ReactGridLayout from 'react-grid-layout';
// The import approach wasn't working when trying to use the width provider so
// I used the "require" syntax per their basic example.
var WidthProvider = __webpack_require__(106).WidthProvider;
var ReactGridLayout = __webpack_require__(106);
ReactGridLayout = WidthProvider(ReactGridLayout);
// My "compoments" defined in separate files

























var App = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'App',
    getInitialState: function getInitialState() {
        return {
            layout: []
        };
    },

    exampleNetLoad: function exampleNetLoad(ekey) {
        switch (ekey) {
            case 'loadSmNet':
                this.props.netLoad(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__validation_netValid__["a" /* netValidate */])(JSON.stringify(__WEBPACK_IMPORTED_MODULE_6__netSamples_ExNetwithLoops1B_json__)).netObj);
                return;
            case 'loadMedNet':
                this.props.netLoad(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__validation_netValid__["a" /* netValidate */])(JSON.stringify(__WEBPACK_IMPORTED_MODULE_7__netSamples_KShortTest2Net_json__)).netObj);
                return;
            case 'loadMultiNet':
                this.props.netLoad(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__validation_netValid__["a" /* netValidate */])(JSON.stringify(__WEBPACK_IMPORTED_MODULE_8__netSamples_MultiLayer2_json__)).netObj);
                return;
            default:
                this.props.netLoad(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__validation_netValid__["a" /* netValidate */])(JSON.stringify(__WEBPACK_IMPORTED_MODULE_6__netSamples_ExNetwithLoops1B_json__)).netObj);
        }
    },

    // Save the state of ReactGridLayout after drags and resizing events.
    layoutChangeHandler: function layoutChangeHandler(currLayout) {
        this.props.netDrawResize();
        this.setState(Object.assign({}, this.state, {
            layout: currLayout
        }));
    },


    componentWillMount: function componentWillMount() {
        document.addEventListener("keydown", this.myKeyPress);
    },

    myKeyPress: function myKeyPress(e) {
        var DEL_KEY = 46;
        // If we are in edit mode delete selected nodes and links
        if (e.which === DEL_KEY && this.props.netVisInteract.mouseMode === 'edit') {
            var newNet = void 0,
                newDemands = void 0,
                newNetVis = void 0;

            var _deleteSelectedNodesL = deleteSelectedNodesLinks(this.props.net, this.props.demands, this.props.netVisInteract);

            var _deleteSelectedNodesL2 = _slicedToArray(_deleteSelectedNodesL, 3);

            newNet = _deleteSelectedNodesL2[0];
            newDemands = _deleteSelectedNodesL2[1];
            newNetVis = _deleteSelectedNodesL2[2];

            this.props.nodeLinkDelete(newNet, newDemands, newNetVis);
        }
    },
    openFile: function openFile() {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#fileInput").click();
    },
    openPathFile: function openPathFile() {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#pathFileInput").click();
    },
    netfileLoad: function netfileLoad() {
        //console.log("Someone selected a file...");
        // Good explanation of file inputs: https://developer.mozilla.org/en-US/docs/Using_files_from_web_applications
        var file = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#fileInput').get(0).files[0];
        // console.log(file.name, file.type, file.size);
        var reader = new FileReader();
        var that = this;
        reader.onload = function () {
            //console.log(reader.result);
            var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__validation_netValid__["a" /* netValidate */])(reader.result);
            if (!result.errors) {
                // console.log(result.netObj);
                that.props.netLoad(result.netObj);
            } else {
                alert("Problem loading network: " + JSON.stringify(result.errors));
            }
        };
        reader.readAsText(file);
        file = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#fileInput').get(0).value = null;
    },
    pathfileLoad: function pathfileLoad() {
        //console.log("Someone selected a file...");
        // Good explanation of file inputs: https://developer.mozilla.org/en-US/docs/Using_files_from_web_applications
        var file = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pathFileInput').get(0).files[0];
        // console.log(file.name, file.type, file.size);
        var reader = new FileReader();
        var that = this;
        reader.onload = function () {
            //console.log(reader.result);
            var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__validation_pathValid__["a" /* pathCollectionValidate */])(reader.result);
            if (!result.errors) {
                // console.log(result.pathObj);
                that.props.pathCollectionAdd(result.pathObj);
            } else {
                alert("Problem loading path: " + JSON.stringify(result.errors));
            }
        };
        reader.readAsText(file);
        file = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#pathFileInput').get(0).value = null;
    },
    helpSelect: function helpSelect() {
        this.props.dispatchHelp(true);
    },
    netInfoSelect: function netInfoSelect() {
        this.props.dispatchNetInfo(true);
    },


    render: function render() {
        var gridItems = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22__AppPanels__["a" /* Wrapper */],
            { key: 'drawPanel', _grid: { i: 'drawPanel', x: 0, y: 0, w: 5, h: 8, minW: 4 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AppPanels__["b" /* NetDrawPanel */], { net: this.props.net })
        )];
        if (this.props.showNetInfo) {
            gridItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22__AppPanels__["a" /* Wrapper */],
                { key: 'infoPanel', _grid: { i: 'infoPanel', x: 6, y: 0, w: 5, h: 8 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AppPanels__["c" /* NetInfoPanel */], { net: this.props.net, mode: this.props.netVisInteract.mouseMode,
                    demands: this.props.demands,
                    nameDescChange: this.props.nameDescChange,
                    closeFunc: this.props.dispatchNetInfo.bind(this, false) })
            ));
        }
        if (this.props.showPathInfo) {
            gridItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22__AppPanels__["a" /* Wrapper */],
                { key: 'pathPanel', _grid: { i: 'pathPanel', x: 6, y: 0, w: 5, h: 8 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AppPanels__["d" /* PathInfoPanel */], { closeFunc: this.props.dispatchPathInfo.bind(this, false) })
            ));
        }
        if (this.props.showHelp) {
            // console.log("You want help");
            gridItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_22__AppPanels__["a" /* Wrapper */],
                { key: 'helpPanel', _grid: { i: 'helpPanel', x: 6, y: 0, w: 5, h: 8 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AppPanels__["e" /* HelpPanel */], { closeFunc: this.props.dispatchHelp.bind(this, false) })
            ));
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onKeyDown: this.myKeyPress, onKeyUp: this.myKeyPress, onKeyPress: this.myKeyPress },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Navbar"],
                { staticTop: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Navbar"].Header,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Navbar"].Brand,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { href: '#' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(744), alt: 'Grotto Networking' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Navbar"].Toggle, null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Navbar"].Collapse,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Nav"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                            { eventKey: 1, title: 'Net',
                                id: 'Net-dropdown' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.1, onSelect: this.props.dispatchNetInfo.bind(this, true) },
                                'Info'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.2, onSelect: this.openFile },
                                'Open Net File'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                                { eventKey: "loadEx", title: 'Example Networks', id: 'Net-Examples' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                    { onSelect: this.exampleNetLoad, eventKey: "loadSmNet" },
                                    'Small Net'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                    { onSelect: this.exampleNetLoad, eventKey: "loadMedNet" },
                                    'Medium Net'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                    { onSelect: this.exampleNetLoad, eventKey: "loadMultiNet" },
                                    'Multi-Layer Net'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { onSelect: this.props.newNetwork, eventKey: 1.3 },
                                'New Network'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { onSelect: this.props.showNetLoadModal,
                                    eventKey: 1.4 },
                                'Load Network'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { onSelect: this.props.showNetExportModal, eventKey: 1.5 },
                                'Export Network'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.6, onSelect: this.props.showLoadDemandModal },
                                'Load Demands'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.65, onSelect: this.props.clearDemands },
                                'Clear Demands'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.7, onSelect: this.props.showIPAddressModal },
                                'IP/MAC Addresses'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.8, onSelect: this.props.showPortNumberModal },
                                'Port Numbers'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.9, onSelect: this.props.showDistanceWeightsModal },
                                'Distance Based Weights'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 1.10, onSelect: this.props.showRandomCapsModal },
                                'Randomize Capacities'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                            { eventKey: 2, title: 'Path',
                                id: 'Path-dropdown' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.1, onSelect: this.props.dispatchPathInfo.bind(this, true) },
                                'Path Info'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.2, onSelect: this.openPathFile },
                                'Open Path File'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.3, onSelect: this.props.showLoadPathModal },
                                'Load Paths'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.4, onSelect: this.props.showShortPathModal },
                                'Shortest Paths'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.5, onSelect: this.props.showMinTreeModal },
                                'Minimum Spanning Tree'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 2.6, onSelect: this.props.showWidePathModal },
                                'Widest Paths'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                            { eventKey: 3, title: 'View',
                                id: 'View-dropdown' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Checkbox"],
                                        { checked: this.props.netVisInteract.showDemands,
                                            onChange: this.props.showDemandChange },
                                        'Show Demands'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Checkbox"],
                                        { checked: this.props.netVisInteract.capVis.showCap,
                                            onChange: this.props.showCapChange },
                                        'Show Link Capacity'
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                            { eventKey: 4, title: 'Mode',
                                id: 'Mode-dropdown' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Radio"],
                                        { value: 'edit', name: 'editMode',
                                            onChange: this.props.modeChange,
                                            checked: this.props.netVisInteract.mouseMode === "edit" },
                                        'Edit'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Radio"],
                                        { value: 'view', name: 'editMode',
                                            onChange: this.props.modeChange,
                                            checked: this.props.netVisInteract.mouseMode === "view" },
                                        'View'
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavDropdown"],
                            { eventKey: 5, title: 'Computations',
                                id: 'Comp-dropdown' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 5.1,
                                    onClick: this.props.showComputeServeDialog },
                                'Configure Compute Server'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 5.5, onSelect: this.props.showKShortestPathsModal },
                                'K-shortest Paths'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"], { divider: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 5.6, disabled: true },
                                'Future Computation #1'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["MenuItem"],
                                { eventKey: 5.7, disabled: true },
                                'Your computation here...'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["NavItem"],
                            { eventKey: 6, onSelect: this.helpSelect },
                            'Help'
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                ReactGridLayout,
                { className: 'layout', layout: this.state.layout, draggableHandle: '.panel-heading',
                    onLayoutChange: this.layoutChangeHandler, cols: 12,
                    rowHeight: 30 },
                gridItems
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ComputeServeDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__io_LoadNetDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__netDraw_NodeAddDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__netDraw_NodeEditDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__io_ExportNetDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__netDraw_LinkAddDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__netDraw_LinkEditDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__netManip_IPAddressDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__netManip_PortNumberDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__netManip_DistanceWeightsDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__netManip_RandomCapsDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pathComp_MinSpanTreeDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pathComp_ShortestPathDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pathComp_WidestPathDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__io_LoadPathDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__io_LoadDemandsDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__pathComp_KShortestPathsDialog__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', id: 'fileInput', accept: '.json', onChange: this.netfileLoad }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', id: 'pathFileInput', accept: '.json', onChange: this.pathfileLoad })
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        net: state.net,
        demands: state.demands,
        paths: state.paths,
        netAction: state.netAction,
        netVisInteract: state.netVisInteract,
        showComputeServeModal: state.uiState.showComputeServeModal,
        showHelp: state.uiState.showHelp,
        showNetInfo: state.uiState.showNetInfo,
        showPathInfo: state.uiState.showPathInfo
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        newNetwork: function newNetwork() {
            dispatch({ type: 'NEW_NET' });
        },
        showDemandChange: function showDemandChange() {
            dispatch({ type: 'SHOW_DEMAND_CHANGE' });
        },
        showCapChange: function showCapChange() {
            dispatch({ type: 'SHOW_CAP_CHANGE' });
        },
        showComputeServeDialog: function showComputeServeDialog() {
            dispatch({ type: 'SHOW_COMPUTE_SERVE_DIALOG' });
        },
        showNetLoadModal: function showNetLoadModal() {
            dispatch({ type: 'SHOW_NET_LOAD_DIALOG' });
        },
        showNetExportModal: function showNetExportModal() {
            dispatch({ type: 'SHOW_NET_EXPORT_DIALOG' });
        },
        modeChange: function modeChange(e) {
            dispatch({ type: 'MODE_CHANGE', mouseMode: e.currentTarget.value });
        },

        netDrawResize: function netDrawResize() {
            dispatch({ type: 'NET_DRAW_RESIZE' });
        },
        nodeLinkDelete: function nodeLinkDelete(net, demands, visInteract) {
            dispatch({ type: 'NODE_LINK_DEL', net: net, demands: demands, netVisInteract: visInteract });
        },
        showIPAddressModal: function showIPAddressModal() {
            dispatch({ type: 'SHOW_IP_ADDRESS_DIALOG' });
        },
        showPortNumberModal: function showPortNumberModal() {
            dispatch({ type: 'SHOW_PORT_NUMBER_DIALOG' });
        },
        showDistanceWeightsModal: function showDistanceWeightsModal() {
            dispatch({ type: 'SHOW_DIST_WEIGHT_DIALOG' });
        },
        showRandomCapsModal: function showRandomCapsModal() {
            dispatch({ type: 'SHOW_RAND_CAP_DIALOG' });
        },
        netLoad: function netLoad(net) {
            dispatch({ type: 'LOAD_NET', net: net });
        },
        dispatchHelp: function dispatchHelp(flag) {
            dispatch({ type: 'SHOW_HELP', flag: flag });
        },
        dispatchNetInfo: function dispatchNetInfo(flag) {
            dispatch({ type: 'SHOW_NET_INFO', flag: flag });
        },
        dispatchPathInfo: function dispatchPathInfo(flag) {
            dispatch({ type: 'SHOW_PATH_INFO', flag: flag });
        },
        nameDescChange: function nameDescChange(name, desc) {
            dispatch({ type: 'NAME_DESC_CHANGE', name: name, desc: desc });
        },
        pathCollectionAdd: function pathCollectionAdd(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
        },
        showMinTreeModal: function showMinTreeModal() {
            dispatch({ type: 'SHOW_MIN_TREE_DIALOG' });
        },
        showShortPathModal: function showShortPathModal() {
            dispatch({ type: 'SHOW_SHORT_PATH_DIALOG' });
        },
        showWidePathModal: function showWidePathModal() {
            dispatch({ type: 'SHOW_WIDE_PATH_DIALOG' });
        },
        showLoadPathModal: function showLoadPathModal() {
            dispatch({ type: 'SHOW_PATH_LOAD_DIALOG' });
        },
        showLoadDemandModal: function showLoadDemandModal() {
            dispatch({ type: 'SHOW_DEMAND_LOAD_DIALOG' });
        },
        clearDemands: function clearDemands() {
            dispatch({ type: 'DEMANDS_CLEAR' });
        },
        showKShortestPathsModal: function showKShortestPathsModal() {
            dispatch({ type: 'SHOW_KSHORT_PATHS_DIALOG' });
        }
    };
};

var AppContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(App);

/**
 *  Deletes selected nodes and links. Handles the issue of deleting all
 *  links attached to a deleted node. Currently handles some tricky stuff
 *  since links refer to nodes by their order in the nodes array.
 *
 *  @method deleteSelectedNodesLinks
 */
function deleteSelectedNodesLinks(net, demands, netVisInteract) {
    var delLinks = [];
    var delNodes = [];
    var delDemands = [];
    var links = net.links;
    var nodes = net.nodes;
    var selLinks = netVisInteract.selectedLinks;
    var selNodes = netVisInteract.selectedNodes;
    var demandList = demands.demandList;
    // Add all the links to be deleted to the delete link array
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var slink = _step.value;

            delLinks.push(links.find(function (d) {
                return d.source === slink[0] && d.target === slink[1];
            }));
        };

        for (var _iterator = selLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        var _loop2 = function _loop2() {
            var snode = _step2.value;

            delNodes.push(nodes.find(function (d) {
                return d.id === snode;
            }));
        };

        for (var _iterator2 = selNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop2();
        }
        // Clear the selected nodes and links by updating n
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var newNetVisInteract = Object.assign({}, netVisInteract, {
        selectedNodes: [],
        selectedLinks: []
    });
    // Add all the links connected to nodes to be deleted to the delete link array
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = delNodes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var node = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = links[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var link = _step4.value;

                    if (link.source === node.id || link.target === node.id) {
                        delLinks.push(link);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = demandList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var demand = _step5.value;

                    if (demand.source === node.id || demand.target === node.id) {
                        delDemands.push(demand);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var newLinks = links.filter(function (l) {
        return !delLinks.includes(l);
    });
    var newDemandList = demandList.filter(function (d) {
        return !delDemands.includes(d);
    });
    var newDemands = Object.assign({}, demands, { demandList: newDemandList });
    var newNodes = nodes.filter(function (n) {
        return !delNodes.includes(n);
    });
    var newNet = Object.assign({}, net, { nodes: newNodes, links: newLinks });
    return [newNet, newDemands, newNetVisInteract];
}

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NetDrawPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NetInfoPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HelpPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PathInfoPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__netDraw_NetDraw__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_NetInfo__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_PathInfo__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_loader_Help_html__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_loader_Help_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html_loader_Help_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__package_json__);
/**
 * Created by Greg on 4/22/2016.
 */








var NetDrawPanel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NetDrawPanel',

    render: function render() {
        var width = parseFloat(this.props.width);
        var height = parseFloat(this.props.height);
        var drawPad = 5;
        var headerHeight = 40;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel panel-default', style: { width: width, height: height } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    this.props.net.graph.name
                ),
                ' Network Visualization'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body', style: { width: width, height: height - headerHeight, padding: drawPad, overflow: "hidden" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__netDraw_NetDraw__["a" /* NetDrawContainer */], { width: width - 2 * drawPad, height: height - headerHeight - 2 * drawPad })
            )
        );
    }
});

var NetInfoPanel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NetInfoPanel',

    // This stops event propagation on the panel so mouse drags and such will
    // not cause panel moves and one can interact normally with text.
    mouseDown: function mouseDown(e) {
        e.stopPropagation();
    },


    render: function render() {
        var width = parseFloat(this.props.width);
        var height = parseFloat(this.props.height);
        var pad = 10;
        var headerHeight = 40;
        var headerStyle = { cursor: "move" };
        var closeStyle = { float: "right", cursor: "pointer" };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel panel-default', style: { width: width, height: height } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading', style: headerStyle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    this.props.net.graph.name
                ),
                ' Network Info',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Glyphicon"], { style: closeStyle, onClick: this.props.closeFunc, glyph: 'remove' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body', style: { width: width,
                        height: height - headerHeight, padding: pad, overflow: "hidden" },
                    onMouseDown: this.mouseDown },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__info_NetInfo__["a" /* NetInfo */], { net: this.props.net, mode: this.props.mode, nameDescChange: this.props.nameDescChange,
                    demands: this.props.demands, width: width, height: height })
            )
        );
    }
});

var HelpPanel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'HelpPanel',

    render: function render() {
        var width = parseFloat(this.props.width);
        var height = parseFloat(this.props.height);
        var pad = 10;
        var headerHeight = 55;
        var headerStyle = { cursor: "move" };
        var closeStyle = { cursor: "pointer" };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel panel-default', style: { width: width, height: height } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading', style: headerStyle },
                'Help',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { float: "right" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'em',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'strong',
                            null,
                            'ComNetViz'
                        ),
                        ' Version ',
                        __WEBPACK_IMPORTED_MODULE_6__package_json__["version"],
                        '  \xA0\xA0'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Glyphicon"], { style: closeStyle, onClick: this.props.closeFunc, glyph: 'remove' })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'HelpContents', className: 'panel-body', style: { width: width, height: height - headerHeight,
                    padding: pad, overflowY: "scroll" }, dangerouslySetInnerHTML: { __html: __WEBPACK_IMPORTED_MODULE_5_html_loader_Help_html__ } })
        );
    }
});

var PathInfoPanel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'PathInfoPanel',

    // This stops event propagation on the panel so mouse drags and such will
    // not cause panel moves and one can interact normally with text.
    mouseDown: function mouseDown(e) {
        e.stopPropagation();
    },


    render: function render() {
        var width = parseFloat(this.props.width);
        var height = parseFloat(this.props.height);
        var pad = 10;
        var headerHeight = 40;
        var headerStyle = { cursor: "move" };
        var closeStyle = { float: "right", cursor: "pointer" };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel panel-default', style: { width: width, height: height } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading', style: headerStyle },
                ' Path Info',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Glyphicon"], { style: closeStyle, onClick: this.props.closeFunc, glyph: 'remove' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body', style: { width: width,
                        height: height - headerHeight, padding: pad, overflow: "hidden" },
                    onMouseDown: this.mouseDown },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__info_PathInfo__["a" /* PathInfoContainer */], { width: width, height: height })
            )
        );
    }
});

var Wrapper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'Wrapper',

    render: function render() {
        var that = this;
        var newChildren = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { width: that.props.style.width,
                height: that.props.style.height });
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            this.props,
            newChildren
        );
    }
});



/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */




var ComputeServeDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'ComputeServeDialog',
    getInitialState: function getInitialState() {
        return {
            namePort: this.props.namePort,
            testResult: "Not Tested",
            serveError: false
        };
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'ComputeServerHelpPopover', title: 'Compute ServerHelp' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Use this dialog to set the name/address and optional port number for a remote computation server. '
            )
        );
    },
    testHandler: function testHandler() {
        // Send test request to server here
        var that = this;
        this.setState(Object.assign({}, this.state, { testResult: "Sending Test Request" }));
        fetch("http://" + this.state.namePort + "/test").then(function (response) {
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return response.json().then(function (json) {
                    that.setState(Object.assign({}, that.state, { testResult: JSON.stringify(json) }));
                });
            } else {
                that.setState(Object.assign({}, that.state, { testResult: "No JSON sent by server", serveError: true }));
            }
        }).catch(function (error) {
            that.setState(Object.assign({}, that.state, { testResult: error, serveError: true }));
        });
    },
    namePortChange: function namePortChange(e) {
        var namePort = e.target.value;
        this.setState(Object.assign({}, this.state, {
            namePort: namePort,
            testResult: "Not Tested",
            serveError: false
        }));
        this.props.assignServer(namePort);
    },
    getValidationState: function getValidationState() {
        if (!this.state.serveError) {
            if (this.state.testResult === "Not Tested" || this.state.testResult === "Sending Test Request") {
                return 'warning';
            } else {
                return 'success';
            }
        } else {
            if (this.state.testResult === "Sending Test Request") {
                return "warning;";
            }
            return 'error';
        }
    },
    render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close,
                dialogClassName: 'comp-serve-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Compute Server Configuration'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        { validationState: this.getValidationState() },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["ControlLabel"],
                            null,
                            'Server Name/Address and optional port number'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { type: 'text',
                            onChange: this.namePortChange,
                            value: this.state.namePort
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"].Feedback, null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["ControlLabel"],
                            null,
                            'Test Results'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea',

                            value: this.state.testResult, readOnly: true,
                            rows: 4 })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.testHandler },
                    'Test '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showComputeServeModal,
        namePort: state.compServe.namePort
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        assignServer: function assignServer(namePort) {
            dispatch({ type: 'ASSIGN_SERVER', namePort: namePort });
        },
        close: function close() {
            dispatch({ type: 'CLOSE_COMPUTE_SERVE_DIALOG' });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ComputeServeDialog));

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




var LinkTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LinkTable',

    render: function render() {
        var attrs = void 0,
            attrMap = void 0;

        var _linkAttr = linkAttr(this.props.links);

        var _linkAttr2 = _slicedToArray(_linkAttr, 2);

        attrs = _linkAttr2[0];
        attrMap = _linkAttr2[1];

        var data = prepData(this.props.links, attrs, attrMap);
        var headings = linkHeadings(attrs);
        var columns = [];
        for (var i = 0; i < attrs.length; i++) {
            //TODO: The width setting isn't working...
            columns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: attrs[i], key: attrs[i], dataSort: true,
                    dataFormat: cellFormater, width: colSize(attrs[i]) },
                headings[i]
            ));
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["BootstrapTable"],
            { data: data, striped: true, keyField: 'id',
                condensed: true,
                height: this.props.height.toString() },
            columns
        );
    }
});

function cellFormater(cell, row) {
    if (typeof cell === 'number') {
        return cell.toPrecision(4);
    } else {
        return cell;
    }
}

/*
 Extracts the link attributes in addition to source, target, weight, and capacity.
 */
function linkAttr(links) {
    var linkAttr = ["source", "target", "weight", "capacity"];
    var attrMap = new Map(); // Set up a map to take us from attribute to formating type.
    attrMap.set("source", "string");
    attrMap.set("target", "string");
    attrMap.set("weight", "number");
    attrMap.set("capacity", "number");
    attrMap.set("ports", "ports"); // special processing given to port object.
    // Get all the link attributes used on nodes other than source, target, weight, and capacity
    var link = void 0,
        attr = void 0;
    for (var i = 0; i < links.length; i++) {
        link = links[i];
        for (attr in link) {
            if (link.hasOwnProperty(attr)) {
                if (linkAttr.indexOf(attr) === -1) {
                    // not already in the attribute list
                    linkAttr.push(attr);
                    if (!attrMap.has(attr)) {
                        attrMap.set(attr, _typeof(link[attr]));
                    }
                }
            }
        }
    }
    return [linkAttr, attrMap];
}

function linkHeadings(linkAttr) {
    return linkAttr.map(capitalize);
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function prepData(links, attrs, attrMap) {
    var data = links.map(function (l) {
        var linkData = { id: l.source + "-" + l.target };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = attrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var attr = _step.value;

                if (!l[attr]) {
                    linkData[attr] = null;
                    continue;
                }
                switch (attrMap.get(attr)) {
                    case 'object':
                        linkData[attr] = JSON.stringify(l[attr]);
                        break;
                    case 'ports':
                        linkData[attr] = l.source + ": " + l.ports[l.source] + ", " + l.target + ": " + l.ports[l.target];
                        break;
                    case 'number':
                    case 'string':
                    default:
                        linkData[attr] = l[attr];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return linkData;
    });
    return data;
}

function colSize(attr) {
    switch (attr) {
        case "source":
            return "60";
        case "target":
            return "60";
        case "capacity":
            return "70";
        case "weight":
            return "70";
        case "ports":
            return "80";
        default:
            return "80";
    }
}

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkTable_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NodeTable_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_demandValid__ = __webpack_require__(108);
/**
 * Created by Greg on 3/30/2016.
 */






var NetInfo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NetInfo',
    getInitialState: function getInitialState() {
        return { name: this.props.net.graph.name, desc: this.props.net.graph.desc };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var nameChange = nextProps.net.graph.name !== this.props.net.graph.name;
        var descChange = nextProps.net.graph.desc !== this.props.net.graph.desc;
        if (nameChange || descChange) {
            this.setState(Object.assign({}, this.state, {
                name: nextProps.net.graph.name,
                desc: nextProps.net.graph.desc
            }));
        }
    },
    nameChange: function nameChange(e) {
        this.setState(Object.assign({}, this.state, { name: e.target.value }));
    },
    descChange: function descChange(e) {
        this.setState(Object.assign({}, this.state, { desc: e.target.value }));
    },
    canEdit: function canEdit() {
        return this.props.mode === 'edit';
    },
    hasChanged: function hasChanged() {
        var nameChange = this.state.name !== this.props.net.graph.name;
        var descChange = this.state.desc !== this.props.net.graph.desc;
        return nameChange || descChange;
    },
    applyHandler: function applyHandler() {
        this.props.nameDescChange(this.state.name, this.state.desc);
    },


    render: function render() {
        var hOffset = 110; // Approximate height
        var pad = 5;
        var rowStyle = { marginTop: 10 };
        var applyChangeButton = null;
        if (this.hasChanged()) {
            applyChangeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                { style: rowStyle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                    { xsOffset: 4, xs: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info',
                            onClick: this.applyHandler },
                        'Apply Changes'
                    )
                )
            );
        }
        var demandTab = null;
        var demandDescToolTip = null;
        if (this.props.demands.id) {
            demandDescToolTip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tooltip"],
                { id: 'DemandDescription' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'Description: '
                ),
                this.props.demands.desc
            );
            demandTab = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tab"],
                { eventKey: 4, title: 'Demands' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { id: 'DemandIdLabel' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                        { placement: 'bottom', overlay: demandDescToolTip },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Label"],
                            { bsStyle: 'info' },
                            this.props.demands.id,
                            ':'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemandTable, { demands: this.props.demands, net: this.props.net, height: this.props.height - hOffset - 30 })
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tabs"],
            { id: 'NetInfoTab', defaultActiveKey: 1 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tab"],
                { eventKey: 1, title: 'Links' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LinkTable_js__["a" /* LinkTable */], { links: this.props.net.links, width: this.props.width - pad, height: this.props.height - hOffset })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tab"],
                { eventKey: 2, title: 'Nodes' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NodeTable_js__["a" /* NodeTable */], { nodes: this.props.net.nodes, width: this.props.width - pad, height: this.props.height - hOffset })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Tab"],
                { eventKey: 3, title: 'General Info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                    { style: rowStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xs: 3, xsOffset: 1 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'control-label' },
                            'Name'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xs: 7 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.name,
                            readOnly: !this.canEdit(),
                            onChange: this.nameChange,
                            className: 'form-control' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                    { style: rowStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xs: 3, xsOffset: 1 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'control-label' },
                            'Description'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xs: 7 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.desc, rows: '4',
                            readOnly: !this.canEdit(),
                            onChange: this.descChange,
                            className: 'form-control' })
                    )
                ),
                applyChangeButton,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                    { style: rowStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xsOffset: 1, xs: 5 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'em',
                            null,
                            'Number of Nodes:'
                        ),
                        ' ',
                        this.props.net.nodes.length,
                        ','
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                        { xs: 6 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'em',
                            null,
                            'Number of Links:'
                        ),
                        ' ',
                        this.props.net.links.length
                    )
                )
            ),
            demandTab
        );
    }
});

var DemandTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'DemandTable',

    // Create the data to show in the table.
    createData: function createData(demands, net) {
        var data = [];
        var index = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = demands.demandList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var demand = _step.value;

                var p = { id: index, src: demand.source, trg: demand.target,
                    demand: demand.demand,
                    compat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validation_demandValid__["b" /* demandValidate */])(demand, net) };
                data.push(p);
                index++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return data;
    },


    render: function render() {
        var data = this.createData(this.props.demands, this.props.net);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            BootstrapTable,
            { data: data, striped: true, keyField: 'id',
                condensed: true,
                trClassName: function trClassName(row) {
                    if (!row.compat) return "nonCompatible";
                },
                height: this.props.height.toString() },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                TableHeaderColumn,
                { dataField: 'src', key: "src", dataSort: true,
                    width: '80' },
                'Start'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                TableHeaderColumn,
                { dataField: 'trg', key: "trg", dataSort: true,
                    width: '80' },
                'End'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                TableHeaderColumn,
                { dataField: 'demand', key: "demand",
                    dataSort: true,
                    width: '80' },
                'Demand'
            )
        );
    }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NodeTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var NodeTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NodeTable',

    render: function render() {
        var attrs = void 0,
            attrMap = void 0;

        var _nodeAttr = nodeAttr(this.props.nodes);

        var _nodeAttr2 = _slicedToArray(_nodeAttr, 2);

        attrs = _nodeAttr2[0];
        attrMap = _nodeAttr2[1];

        var data = prepData(this.props.nodes, attrs, attrMap);
        var headings = nodeHeadings(attrs);
        var columns = [];
        for (var i = 0; i < attrs.length; i++) {
            columns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: attrs[i], key: attrs[i],
                    dataSort: true, sortFunc: sortFuncs(attrs[i]), width: colSize(attrs[i]) },
                headings[i]
            ));
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["BootstrapTable"],
            { data: data, striped: true, hover: true, condensed: true,
                keyField: 'id', height: this.props.height.toString() },
            columns
        );
    }
});

function nodeAttr(nodes) {
    // Get all the node attributes used on nodes other than x, y, id, and type
    var nodeAttr = ["id", "type"];
    var attrMap = new Map(); // Set up a map to take us from attribute to formating type.
    attrMap.set("id", "string");
    attrMap.set("type", "string");
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        for (var attr in node) {
            if (node.hasOwnProperty(attr)) {
                if (nodeAttr.indexOf(attr) === -1) {
                    // not already in the attribute list
                    if (attr !== 'x' && attr !== 'y' && node[attr] !== "") {
                        nodeAttr.push(attr);
                        if (!attrMap.has(attr)) {
                            attrMap.set(attr, _typeof(node[attr]));
                        }
                    }
                }
            }
        }
    }
    return [nodeAttr, attrMap];
}

/*
 The headings for the node table computed from the node attributes.
 */
function nodeHeadings(nodeAttr) {
    var headings = [];
    headings.push("Name");
    headings.push("Type");
    for (var i = 2; i < nodeAttr.length; i++) {
        headings.push(capitalize(nodeAttr[i]));
    }
    return headings;
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function prepData(nodes, attrs, attrMap) {
    var data = nodes.map(function (n) {
        var nodeData = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = attrs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var attr = _step.value;

                if (!n[attr]) {
                    nodeData[attr] = null;
                    continue;
                }
                switch (attrMap.get(attr)) {
                    case 'object':
                        nodeData[attr] = JSON.stringify(n[attr]);
                        break;
                    case 'number':
                    case 'string':
                    default:
                        nodeData[attr] = n[attr];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return nodeData;
    });
    return data;
}

function colSize(attr) {
    switch (attr) {
        case "id":
            return "50";
        case "type":
            return "50";
        case "layer":
            return "60";
        case "ipv4":
            return "75";
        case "mac":
            return "115";
        default:
            return "80";
    }
}

function sortFuncs(attr) {
    switch (attr) {
        case "ipv4":
            return function (a, b, order) {
                if (order === 'asc') {
                    return ipStringToInt(a.ipv4) - ipStringToInt(b.ipv4);
                } else {
                    return ipStringToInt(b.ipv4) - ipStringToInt(a.ipv4);
                }
            };
        case "mac":
            return function (a, b, order) {
                if (order === 'asc') {
                    return macStringToNum(a.mac) - macStringToNum(b.mac);
                } else {
                    return macStringToNum(b.mac) - macStringToNum(a.mac);
                }
            };
        default:
            return null;
    }
}

function ipStringToInt(ipString) {
    if (!ipString || ipString === "") {
        return 0;
    }
    var numStrings = ipString.split(".");
    var ipInt = 0;
    macInt |= parseInt(numStrings[0]) << 24;
    macInt |= parseInt(numStrings[1]) << 16;
    macInt |= parseInt(numStrings[2]) << 8;
    macInt |= parseInt(numStrings[3]);
    return macInt;
}

function macStringToNum(macString) {
    if (!macString || macString === "") {
        return 0;
    }
    var numStrings = macString.split(":");
    var macNum = 0;
    for (var i = 0; i < numStrings.length; i++) {
        macNum += parseInt(numStrings[i], 16) * Math.pow(16, i);
    }
    return macNum;
}

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PathInfoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_pathValid__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Created by Greg on 4/26/2016.
 */







var PathInfo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'PathInfo',
    getInitialState: function getInitialState() {
        return { groupsSelected: new Set(), view: "collection", groupIndex: null,
            pathsSelected: new Set(), exportString: "", showExportDialog: false };
    },
    onCollectionRowSelect: function onCollectionRowSelect(row, isSelected) {
        var groupsSelected = this.state.groupsSelected;
        if (isSelected) {
            groupsSelected.add(row.listId);
            this.setState({ groupsSelected: groupsSelected });
        } else {
            groupsSelected.delete(row.listId);
            this.setState({ groupsSelected: groupsSelected });
        }
    },
    onCollectionSelectAll: function onCollectionSelectAll(isSelected) {
        // console.log("is select all: " + isSelected);
        var groupsSelected = this.state.groupsSelected;
        if (isSelected) {
            for (var i = 0; i < this.props.paths.length; i++) {
                groupsSelected.add(i);
            }
        } else {
            groupsSelected.clear();
        }
        this.setState({ groupsSelected: groupsSelected });
    },
    onPathSelected: function onPathSelected(row, isSelected) {
        var pathsSelected = this.state.pathsSelected;

        if (isSelected) {
            pathsSelected.add(row.id);
            this.setState({ pathsSelected: pathsSelected });
        } else {
            pathsSelected.delete(row.id);
            this.setState({ pathsSelected: pathsSelected });
        }
        this.props.linkSelect(this.selectedLinks());
    },
    onPathSelectAll: function onPathSelectAll(isSelected) {
        var pathsSelected = this.state.pathsSelected;
        if (!isSelected) {
            pathsSelected.clear();
            this.setState({ pathsSelected: pathsSelected });
            this.props.linkSelect(this.selectedLinks());
            return;
        }
        // Have to handle the all paths case separate from the specific paths case
        if (this.state.groupIndex === null) {
            for (var i = 0; i < this.props.paths.length; i++) {
                for (var j = 0; j < this.props.paths[i].pathList.length; j++) {
                    pathsSelected.add(i.toString() + "." + j.toString());
                }
            }
        } else {
            for (var _j = 0; _j < this.props.paths[this.state.groupIndex].pathList.length; _j++) {
                pathsSelected.add(_j);
            }
        }
        this.setState({ pathsSelected: pathsSelected });
        this.props.linkSelect(this.selectedLinks());
    },


    // Returns a list of selected links based on the currently selected paths
    selectedLinks: function selectedLinks() {
        var links = this.props.net.links;
        var selLinks = [];
        var pathObjs = this.getSelectedPaths();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = pathObjs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var p = _step.value;

                var _loop = function _loop(i) {
                    // Check if link is in network, if so add it to selection
                    var a = p.nodeList[i];
                    var b = p.nodeList[i + 1];
                    if (links.find(function (l) {
                        return l.source === a && l.target === b;
                    })) {
                        selLinks.push([a, b]);
                    }
                    if (links.find(function (l) {
                        return l.source === b && l.target === a;
                    })) {
                        selLinks.push([b, a]);
                    }
                };

                for (var i = 0; i < p.nodeList.length - 1; i++) {
                    _loop(i);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return selLinks;
    },


    // Returns a list of selected path objects, for use in highlighting
    getSelectedPaths: function getSelectedPaths() {
        var that = this;
        var selPathObjs = [];
        var pathsSelected = this.state.pathsSelected; // The set of indices from the GUI
        if (this.state.groupIndex === null) {
            // Working with "all paths"
            pathsSelected.forEach(function (iString) {
                // iString has the form "1.2"
                var parts = iString.split(".");
                var gIndex = parseInt(parts[0]);
                var pIndex = parseInt(parts[1]);
                selPathObjs.push(that.props.paths[gIndex].pathList[pIndex]);
            });
        } else {
            pathsSelected.forEach(function (i) {
                selPathObjs.push(that.props.paths[that.state.groupIndex].pathList[i]);
            });
        }
        return selPathObjs;
    },
    removeSelected: function removeSelected() {
        var groupsSelected = this.state.groupsSelected;
        var newPaths = this.props.paths.filter(function (p, i) {
            return !groupsSelected.has(i);
        });
        groupsSelected.clear();
        this.props.pathsUpdate(newPaths);
        this.setState({ groupsSelected: groupsSelected });
    },
    exportSelected: function exportSelected() {
        var groupsSelected = this.state.groupsSelected;
        var exportPaths = this.props.paths.filter(function (p, i) {
            return groupsSelected.has(i);
        });
        if (exportPaths.length === 0) {
            this.setState({ exportString: "", showExportDialog: false });
            return; // Nothing to export
        }
        if (exportPaths.length === 1) {
            this.setState({ exportString: JSON.stringify(exportPaths[0], null, 2), showExportDialog: true });
        } else {
            var pathGroup = { id: "Multi-Export", desc: "", pathList: [] };
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = exportPaths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _pathGroup$pathList;

                    var pg = _step2.value;

                    pathGroup.desc += pg.id + ", ";
                    (_pathGroup$pathList = pathGroup.pathList).push.apply(_pathGroup$pathList, _toConsumableArray(pg.pathList));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.setState({ exportString: JSON.stringify(pathGroup, null, 2), showExportDialog: true });
        }
    },
    closeExportDialog: function closeExportDialog() {
        this.setState({ showExportDialog: false });
    },
    handleTabSelect: function handleTabSelect(eventKey, event) {
        // console.log('Tab handler selected eventKey ' + eventKey);
        // console.log(eventKey);
        var items = eventKey.split(".");
        var pathsSelected = this.state.pathsSelected;
        pathsSelected.clear();
        this.setState({ view: items[0], groupIndex: items[1] ? parseInt(items[1]) : null, pathsSelected: pathsSelected });
        this.props.linkSelect(this.selectedLinks());
    },


    render: function render() {
        var hOffsetCollection = 135;
        var hOffsetPathTables = 110;
        var menuItems = this.props.paths.map(function (p, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["MenuItem"],
                { key: "specific." + i, eventKey: "specific." + i },
                p.id
            );
        });
        var content = null;
        switch (this.state.view) {
            case 'collection':
                var data = prepPathCollections(this.props.paths, this.props.net);
                content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PathCollectionsTable, { data: data, height: this.props.height - hOffsetCollection,
                        sel: this.onCollectionRowSelect, selAll: this.onCollectionSelectAll,
                        gSelected: [].concat(_toConsumableArray(this.state.groupsSelected)) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Button"],
                        { bsStyle: 'info', bsSize: 'xsmall', onClick: this.removeSelected },
                        'Remove Selected'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Button"],
                        { bsStyle: 'primary', bsSize: 'xsmall', onClick: this.exportSelected },
                        'Export Selected'
                    )
                );
                break;
            case 'allPaths':
                content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllPathsTable, { paths: this.props.paths, net: this.props.net,
                    pSelected: [].concat(_toConsumableArray(this.state.pathsSelected)),
                    selAll: this.onPathSelectAll,
                    sel: this.onPathSelected, height: this.props.height - hOffsetPathTables });
                break;
            case 'specific':
                content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PathGroupTable, { pathGroup: this.props.paths[this.state.groupIndex],
                    pSelected: [].concat(_toConsumableArray(this.state.pathsSelected)),
                    selAll: this.onPathSelectAll,
                    sel: this.onPathSelected,
                    net: this.props.net, height: this.props.height - hOffsetPathTables });
                break;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'PathInfo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Nav"],
                { bsStyle: 'tabs', activeKey: this.state.view, onSelect: this.handleTabSelect },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["NavItem"],
                    { eventKey: 'collection', href: '/home' },
                    'Manage Path Groups'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["NavItem"],
                    { eventKey: 'allPaths', title: 'Item' },
                    'All Paths'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["NavDropdown"],
                    { eventKey: 'specific', title: 'Specific Group', id: 'nav-dropdown' },
                    menuItems
                )
            ),
            content,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"],
                { show: this.state.showExportDialog, onHide: this.closeExportDialog, dialogClassName: 'export-path-modal' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Header,
                    { closeButton: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Title,
                        null,
                        'Selected Path Groups JSON'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Body,
                    { style: { paddingBottom: 0 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true, value: this.state.exportString, rows: 10, style: { resize: "none" } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Footer,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Button"],
                        { onClick: this.closeExportDialog },
                        'Close'
                    )
                )
            )
        );
    }

});

var AllPathsTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'AllPathsTable',

    // Create the data to show in the table.
    createData: function createData(paths, net) {
        var data = [];
        var groupIndex = 0;
        var attrs = ["nodeList"];
        var attrMap = new Map();
        // Get the attributes of all the path groups
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = paths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var group = _step3.value;

                var _pathAttr = pathAttr(group.pathList, attrs, attrMap);

                var _pathAttr2 = _slicedToArray(_pathAttr, 2);

                attrs = _pathAttr2[0];
                attrMap = _pathAttr2[1];
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = paths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _group = _step4.value;

                var groupName = _group.id;
                var pathIndex = 0;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = _group.pathList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var path = _step5.value;

                        var p = { id: groupIndex.toString() + "." + pathIndex.toString(),
                            src: path.nodeList[0], trg: path.nodeList[path.nodeList.length - 1],
                            nodeList: path.nodeList.join(", "),
                            compat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validation_pathValid__["b" /* pathValidate */])(path, net).valid, gName: groupName };
                        for (var i = 1; i < attrs.length; i++) {
                            p[attrs[i]] = path[attrs[i]];
                        }
                        data.push(p);
                        pathIndex++;
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                groupIndex++;
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return [data, attrs];
    },


    render: function render() {
        var _createData = this.createData(this.props.paths, this.props.net),
            _createData2 = _slicedToArray(_createData, 2),
            data = _createData2[0],
            attrs = _createData2[1];

        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.pSelected
        };

        var extraCols = [];
        for (var i = 1; i < attrs.length; i++) {
            extraCols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: attrs[i], key: attrs[i], dataSort: true,
                    dataFormat: cellFormater, width: '60' },
                capitalize(attrs[i])
            ));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
            { data: data, striped: true, keyField: 'id',
                trClassName: function trClassName(row) {
                    if (!row.compat) return "nonCompatible";
                },
                condensed: true, selectRow: selectRowProp,
                height: this.props.height.toString() },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'gName', key: "gName", dataSort: true,
                    width: '80' },
                'Group'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'src', key: "src", dataSort: true,
                    width: '60' },
                'Start'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'trg', key: "trg", dataSort: true,
                    width: '60' },
                'End'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'nodeList', key: "nodeList",
                    dataSort: true,
                    columnClassName: 'multiLineTableEntry',
                    width: '150' },
                'Node List'
            ),
            extraCols
        );
    }
});

var PathGroupTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'PathGroupTable',

    // Create the data to show in the table.
    createData: function createData(pathGroup, net) {
        var data = [];
        var index = 0;
        var attrs = void 0,
            attrMap = void 0;

        var _pathAttr3 = pathAttr(pathGroup.pathList);

        var _pathAttr4 = _slicedToArray(_pathAttr3, 2);

        attrs = _pathAttr4[0];
        attrMap = _pathAttr4[1];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = pathGroup.pathList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var path = _step6.value;

                var p = { id: index, src: path.nodeList[0], trg: path.nodeList[path.nodeList.length - 1],
                    nodeList: path.nodeList.join(", "), compat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validation_pathValid__["b" /* pathValidate */])(path, net).valid };
                for (var i = 1; i < attrs.length; i++) {
                    p[attrs[i]] = path[attrs[i]];
                }
                data.push(p);
                index++;
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        return [data, attrs];
    },


    render: function render() {
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.pSelected
        };

        var _createData3 = this.createData(this.props.pathGroup, this.props.net),
            _createData4 = _slicedToArray(_createData3, 2),
            data = _createData4[0],
            attrs = _createData4[1];
        // console.log(this.props.pSelected);


        var extraCols = [];
        for (var i = 1; i < attrs.length; i++) {
            extraCols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: attrs[i], key: attrs[i], dataSort: true,
                    dataFormat: cellFormater, width: '60' },
                capitalize(attrs[i])
            ));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
            { data: data, striped: true, keyField: 'id',
                condensed: true, selectRow: selectRowProp,
                trClassName: function trClassName(row) {
                    if (!row.compat) return "nonCompatible";
                },
                height: this.props.height.toString() },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'src', key: "src", dataSort: true,
                    width: '60' },
                'Start'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'trg', key: "trg", dataSort: true,
                    width: '60' },
                'End'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'nodeList', key: "nodeList",
                    dataSort: true,
                    columnClassName: 'multiLineTableEntry',
                    width: '150' },
                'Node List'
            ),
            extraCols
        );
    }
});

/*
 Extracts the path attributes in addition to nodeList.
 paths is an array of path objects.
 */
function pathAttr(paths) {
    var pathAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["nodeList"];
    var attrMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!attrMap) {
        attrMap = new Map(); // Set up a map to take us from attribute to formating type.
    }
    // Get all the link attributes used on paths other than nodeList
    var path = void 0,
        attr = void 0;
    for (var i = 0; i < paths.length; i++) {
        path = paths[i];
        for (attr in path) {
            if (path.hasOwnProperty(attr)) {
                if (pathAttr.indexOf(attr) === -1) {
                    // not already in the attribute list
                    pathAttr.push(attr);
                    if (!attrMap.has(attr)) {
                        attrMap.set(attr, _typeof(path[attr]));
                    }
                }
            }
        }
    }
    return [pathAttr, attrMap];
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function cellFormater(cell, row) {
    if (typeof cell === 'number') {
        return cell.toPrecision(4);
    } else {
        return cell;
    }
}

var PathCollectionsTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'PathCollectionsTable',


    render: function render() {
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            bgColor: "rgb(238, 193, 213)",
            onSelect: this.props.sel,
            onSelectAll: this.props.selAll,
            selected: this.props.gSelected
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
            { data: this.props.data, striped: true, keyField: 'listId',
                condensed: true, selectRow: selectRowProp,
                height: this.props.height.toString() },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', key: "id", dataSort: true, width: '100' },
                'Name'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'desc', key: "desc", dataSort: true, columnClassName: 'multiLineTableEntry', width: '150' },
                'Description'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'num', key: "num", dataSort: true, width: '75' },
                'Number'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
                { className: 'multiLineTableEntry', dataField: 'numCompat', key: "numCompat", dataSort: true },
                'Number Compatible'
            )
        );
    }

});

// Paths is a list of path collection objects
function prepPathCollections(paths, net) {
    if (paths.length === 0) {
        return [];
    }
    var data = paths.map(function (pc, i) {
        var pcData = { listId: i, id: pc.id, desc: pc.desc, num: pc.pathList.length };
        // Compute how many paths in the collection are compatible with the network
        var compatible = 0;
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = pc.pathList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var path = _step7.value;

                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__validation_pathValid__["b" /* pathValidate */])(path, net).valid) {
                    compatible++;
                }
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }

        pcData.numCompat = compatible;
        return pcData;
    });
    return data;
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        net: state.net,
        paths: state.paths,
        netVisInteract: state.netVisInteract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        pathsUpdate: function pathsUpdate(paths) {
            dispatch({ type: 'PATHS_UPDATE', paths: paths });
        },
        linkSelect: function linkSelect(selectedLinks) {
            dispatch({ type: 'BULK_LINK_SELECT', selectedLinks: selectedLinks });
        }
    };
};

var PathInfoContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PathInfo);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_netValid__ = __webpack_require__(75);
/**
 * Created by Greg on 3/30/2016.
 */





var ExportNetDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'ExportNetDialog',
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'exportNetHelpPopover', title: 'Export Network Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This is the a JSON based representation of the current network suitable for saving in a plain text file. This format is compatible with the',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { target: '_blank', href: 'https://networkx.github.io/' },
                    'NetworkX'
                ),
                ' Python graph library.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Examples of working with such JSON networks are given at ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { target: '_blank',
                        href: 'http://grotto-networking.com/SDNfun.html#NetworkX' },
                    'Grotto Networking'
                ),
                '.'
            )
        );
    },
    render: function render() {
        var netString = JSON.stringify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validation_netValid__["b" /* net2NetworkXJSON */])(this.props.net), __WEBPACK_IMPORTED_MODULE_3__validation_netValid__["c" /* netJSONreduce */], 2);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'export-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Current Network JSON'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true, value: netString, rows: 10, style: { resize: "none" } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showNetExportModal,
        net: state.net
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_NET_EXPORT_DIALOG' });
        }

    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ExportNetDialog));

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_demandValid__ = __webpack_require__(108);
/**
 * Created by Greg on 5/09/2016.
 */





var LoadDemandDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LoadDemandDialog',
    getInitialState: function getInitialState() {
        return { value: "", demandObj: null, errors: null };
    },


    handleChange: function handleChange(event) {
        var temp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validation_demandValid__["a" /* demandCollectionValidate */])(event.target.value);
        this.setState({ value: event.target.value, demandObj: temp.demandObj, errors: temp.errors });
    },

    loadHandler: function loadHandler() {
        if (!this.state.errors && this.state.demandObj) {
            this.props.loadDemand(this.state.demandObj);
        }
    },
    validationState: function validationState() {
        if (this.state.errors) {
            return 'error';
        } else {
            return 'success';
        }
    },
    helpState: function helpState() {
        if (this.state.errors) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'loadDemandHelpPopover', title: 'Load Demand Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This is where I\'ll give you some help and/or show you the errors if any.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Errors:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                JSON.stringify(this.state.errors)
            )
        );
    },
    render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'load-demand-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Load Demands JSON'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                    { validationState: this.validationState() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { value: this.state.value, onChange: this.handleChange, componentClass: 'textarea',
                        placeholder: 'paste JSON here', rows: 10 }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"].Feedback, null)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary', onClick: this.loadHandler },
                    'Load '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showDemandLoadModal
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_DEMAND_LOAD_DIALOG' });
        },
        loadDemand: function loadDemand(demandObj) {
            dispatch({ type: "CLOSE_DEMAND_LOAD_DIALOG" });
            dispatch({ type: 'DEMANDS_LOAD', demandObj: demandObj });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LoadDemandDialog));

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_netValid__ = __webpack_require__(75);
/**
 * Created by Greg on 3/30/2016.
 */





var LoadNetDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LoadNetDialog',
    getInitialState: function getInitialState() {
        return { value: "", netObj: null, errors: null };
    },


    handleChange: function handleChange(event) {
        var temp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validation_netValid__["a" /* netValidate */])(event.target.value);
        this.setState({ value: event.target.value, netObj: temp.netObj, errors: temp.errors });
    },

    loadHandler: function loadHandler() {
        if (!this.state.errors && this.state.netObj) {
            this.props.loadNetwork(this.state.netObj);
        }
    },
    validationState: function validationState() {
        if (this.state.errors) {
            return 'error';
        } else {
            return 'success';
        }
    },
    helpState: function helpState() {
        if (this.state.errors) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'loadNetHelpPopover', title: 'Load Network Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This is where I\'ll give you some help and/or show you the errors if any.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Errors:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                JSON.stringify(this.state.errors)
            )
        );
    },
    render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'load-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Load Network JSON'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                    { validationState: this.validationState() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { value: this.state.value, onChange: this.handleChange, componentClass: 'textarea',
                        placeholder: 'paste JSON here', rows: 10 }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"].Feedback, null)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary', onClick: this.loadHandler },
                    'Load '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showNetLoadModal
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_NET_LOAD_DIALOG' });
        },

        loadNetwork: function loadNetwork(net) {
            dispatch({ type: 'LOAD_NET', net: net });
            dispatch({ type: "GOOD_NET_LOAD_CLOSE" }); // Different from a cancel close
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LoadNetDialog));

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_pathValid__ = __webpack_require__(76);
/**
 * Created by Greg on 3/30/2016.
 */





var LoadPathDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LoadPathDialog',
    getInitialState: function getInitialState() {
        return { value: "", pathObj: null, errors: null };
    },


    handleChange: function handleChange(event) {
        var temp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__validation_pathValid__["a" /* pathCollectionValidate */])(event.target.value);
        this.setState({ value: event.target.value, pathObj: temp.pathObj, errors: temp.errors });
    },

    loadHandler: function loadHandler() {
        if (!this.state.errors && this.state.pathObj) {
            this.props.loadPath(this.state.pathObj);
        }
    },
    validationState: function validationState() {
        if (this.state.errors) {
            return 'error';
        } else {
            return 'success';
        }
    },
    helpState: function helpState() {
        if (this.state.errors) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'loadPathHelpPopover', title: 'Load Path Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This is where I\'ll give you some help and/or show you the errors if any.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Errors:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                JSON.stringify(this.state.errors)
            )
        );
    },
    render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'load-path-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Load Path Group JSON'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                    { validationState: this.validationState() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { value: this.state.value, onChange: this.handleChange, componentClass: 'textarea',
                        placeholder: 'paste JSON here', rows: 10 }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"].Feedback, null)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary', onClick: this.loadHandler },
                    'Load '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showPathLoadModal
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_PATH_LOAD_DIALOG' });
        },
        loadPath: function loadPath(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
            dispatch({ type: "CLOSE_PATH_LOAD_DIALOG" }); // Different from a cancel close
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LoadPathDialog));

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var LinkAddDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LinkAddDialog',
    getInitialState: function getInitialState() {
        return {
            weight: "", capacity: "", srcPort: "", trgPort: "",
            portOpen: false,
            wtError: null,
            capError: null,
            srcPortError: null,
            trgPortError: null
        };
    },
    wtChange: function wtChange(e) {
        var newWt = e.target.value;
        this.setState(Object.assign({}, this.state, {
            weight: newWt,
            wtError: numValidator(newWt, "Weight")
        }));
    },
    wtStatus: function wtStatus() {
        if (this.state.wtError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    capChange: function capChange(e) {
        var newCap = e.target.value;
        this.setState(Object.assign({}, this.state, {
            capacity: newCap,
            capError: numValidator(newCap, "Capacity")
        }));
    },
    capStatus: function capStatus() {
        if (this.state.capError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    srcPortChange: function srcPortChange(e) {
        var newSrcPort = e.target.value;
        // They can set the source port to nothing if the target port is also nothing
        if (newSrcPort === '' && this.state.trgPort === '') {
            this.setState(Object.assign({}, this.state, {
                srcPort: newSrcPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        this.setState(Object.assign({}, this.state, {
            srcPort: newSrcPort,
            srcPortError: portValidator(newSrcPort, this.props.netVisInteract.linkInfo.source, this.props.net),
            trgPortError: portValidator(this.state.trgPort, this.props.netVisInteract.linkInfo.target, this.props.net)
        }));
    },
    srcPortStatus: function srcPortStatus() {
        if (this.state.srcPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    trgPortChange: function trgPortChange(e) {
        var newTrgPort = e.target.value;
        if (newTrgPort === '' && this.state.srcPort === '') {
            this.setState(Object.assign({}, this.state, {
                trgPort: newTrgPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        this.setState(Object.assign({}, this.state, {
            trgPort: newTrgPort,
            trgPortError: portValidator(newTrgPort, this.props.netVisInteract.linkInfo.target, this.props.net),
            srcPortError: portValidator(this.state.srcPort, this.props.netVisInteract.linkInfo.source, this.props.net)
        }));
    },
    trgPortStatus: function trgPortStatus() {
        if (this.state.trgPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    linkError: function linkError() {
        return Boolean(this.state.wtError || this.state.capError || this.state.srcPortError || this.state.trgPortError);
    },
    addHandler: function addHandler() {
        // console.log("Entering link add handler ");
        if (this.linkError()) {
            return;
        }
        var link = {
            source: this.props.netVisInteract.linkInfo.source,
            target: this.props.netVisInteract.linkInfo.target,
            weight: parseFloat(this.state.weight),
            capacity: parseFloat(this.state.capacity)
        };
        if (this.state.srcPort !== "" && this.state.srcPort) {
            link.ports = {};
            link.ports[link.source] = parseInt(this.state.srcPort);
            link.ports[link.target] = parseInt(this.state.trgPort);
        }
        this.props.addLink(link);
    },
    togglePort: function togglePort() {
        this.setState(Object.assign({}, this.state, { portOpen: !this.state.portOpen }));
    },
    helpState: function helpState() {
        if (this.linkError()) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {
        var errorHeader = null;
        var wtErrorP = null;
        var capErrorP = null;
        var srcPErrorP = null;
        var trgPErrorP = null;
        if (this.linkError()) {
            errorHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h5',
                null,
                'Errors:'
            );
        }
        if (this.state.wtError) {
            wtErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.wtError
            );
        }
        if (this.state.capError) {
            capErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.capError
            );
        }
        if (this.state.srcPortError) {
            srcPErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.srcPortError
            );
        }
        if (this.state.trgPortError) {
            trgPErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.trgPortError
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'addLinkHelpPopover', title: 'Add Link Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Links must be assigned non-negative weights and capacities.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'If port numbers are given for a link end they must not be alread used by another link.'
            ),
            errorHeader,
            wtErrorP,
            capErrorP,
            srcPErrorP,
            trgPErrorP
        );
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState(Object.assign({}, this.state, {
            srcPort: null,
            trgPort: null,
            srcPortError: null,
            trgPortError: null
        }));
    },
    render: function render() {

        var source = this.props.netVisInteract.linkInfo.source;
        var target = this.props.netVisInteract.linkInfo.target;
        var layerInfo = null;
        var layer = this.props.netVisInteract.linkInfo.layer;
        if (layer) {
            layerInfo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'Layer: ',
                    layer
                )
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false, show: this.props.open, onHide: this.props.close,
                dialogClassName: 'add-node-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Add a Network Link: ',
                    source,
                    '-',
                    target,
                    ' ',
                    layerInfo
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Required Link Attributes'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.wtStatus() },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Weight'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.weight,
                                    onChange: this.wtChange,
                                    className: 'form-control' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                {
                                    className: 'control-label' },
                                'Capacity'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.capStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.capacity,
                                    onChange: this.capChange,
                                    className: 'form-control' })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                    onClick: this.togglePort },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Optional Link Ports'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Collapse"],
                        { 'in': this.state.portOpen },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.srcPortStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            { className: 'control-label' },
                                            source,
                                            ' Port'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                            value: this.state.srcPort,
                                            className: 'form-control', onChange: this.srcPortChange })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.trgPortStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            {
                                                className: 'control-label' },
                                            target,
                                            ' Port'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: this.trgPortChange,
                                            value: this.state.trgPort,
                                            className: 'form-control' })
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.addHandler, disabled: this.linkError() },
                    'Add '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

function numValidator(numString, name) {
    var value = parseFloat(numString);
    if (isNaN(value)) {
        return name + ": must be a valid number.";
    }
    if (value < 0.0) {
        return name + ": must be non-negative.";
    }
    return null;
}

function portValidator(portNumString, nodeID, net) {
    var portNum = parseInt(portNumString);
    if (isNaN(portNum)) {
        return nodeID + " port number is not a valid number";
    }
    var valid = true;
    var links = net.links;
    var usedPorts = new Set();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var link = _step.value;

            if (link.ports) {
                if (link.source === nodeID) {
                    usedPorts.add(link.ports[link.source]);
                    if (link.ports[link.source] === portNum) {
                        valid = false;
                    }
                }
                if (link.target === nodeID) {
                    usedPorts.add(link.ports[link.target]);
                    if (link.ports[link.target] === portNum) {
                        valid = false;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (valid) {
        return null;
    }
    return nodeID + " port number " + portNum + " is already used, (used ports: " + Array.from(usedPorts).toString() + ")";
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showLinkAddModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_LINK_ADD_DIALOG' });
        },
        addLink: function addLink(link) {
            dispatch({ type: 'NET_LINK_ADD', link: link });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LinkAddDialog));

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var LinkEditDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'LinkEditDialog',
    getInitialState: function getInitialState() {
        return {
            weight: "", capacity: "", srcPort: "", trgPort: "",
            portOpen: false,
            wtError: null,
            capError: null,
            srcPortError: null,
            trgPortError: null,
            link: {}
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var linkInfo = nextProps.netVisInteract.linkInfo;
        if (!linkInfo) {
            linkInfo = {};
        }

        this.setState(Object.assign({}, this.state, {
            weight: linkInfo.weight ? linkInfo.weight.toPrecision(4) : "",
            capacity: linkInfo.capacity ? linkInfo.capacity.toPrecision(4) : "",
            srcPort: linkInfo.ports ? linkInfo.ports[linkInfo.source] : "",
            trgPort: linkInfo.ports ? linkInfo.ports[linkInfo.target] : "",
            srcPortError: null,
            trgPortError: null,
            link: linkInfo
        }));
    },
    wtChange: function wtChange(e) {
        var newWt = e.target.value;
        this.setState(Object.assign({}, this.state, {
            weight: newWt,
            wtError: numValidator(newWt, "Weight")
        }));
    },
    wtStatus: function wtStatus() {
        if (this.state.wtError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    capChange: function capChange(e) {
        var newCap = e.target.value;
        this.setState(Object.assign({}, this.state, {
            capacity: newCap,
            capError: numValidator(newCap, "Capacity")
        }));
    },
    capStatus: function capStatus() {
        if (this.state.capError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    srcPortChange: function srcPortChange(e) {
        var newSrcPort = e.target.value;
        // They can set the source port to nothing if the target port is also nothing
        if (newSrcPort === '' && this.state.trgPort === '') {
            this.setState(Object.assign({}, this.state, {
                srcPort: newSrcPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        var link = this.props.netVisInteract.linkInfo;
        this.setState(Object.assign({}, this.state, {
            srcPort: newSrcPort,
            srcPortError: portValidator(newSrcPort, link.source, this.props.net, link),
            trgPortError: portValidator(this.state.trgPort, link.target, this.props.net, link)
        }));
    },
    srcPortStatus: function srcPortStatus() {
        if (this.state.srcPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    trgPortChange: function trgPortChange(e) {
        var newTrgPort = e.target.value;
        if (newTrgPort === '' && this.state.srcPort === '') {
            this.setState(Object.assign({}, this.state, {
                trgPort: newTrgPort,
                srcPortError: null, trgPortError: null
            }));
            return;
        }
        var link = this.props.netVisInteract.linkInfo;
        this.setState(Object.assign({}, this.state, {
            trgPort: newTrgPort,
            trgPortError: portValidator(newTrgPort, link.target, this.props.net, link),
            srcPortError: portValidator(this.state.srcPort, link.source, this.props.net, link)
        }));
    },
    trgPortStatus: function trgPortStatus() {
        if (this.state.trgPortError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    linkError: function linkError() {
        return Boolean(this.state.wtError || this.state.capError || this.state.srcPortError || this.state.trgPortError);
    },
    editHandler: function editHandler() {
        var _this = this;

        // console.log("Entering link edit handler ");
        if (this.linkError()) {
            return;
        }
        var link = {
            source: this.state.link.source,
            target: this.state.link.target,
            weight: parseFloat(this.state.weight),
            capacity: parseFloat(this.state.capacity)
        };
        if (this.state.srcPort !== "" && this.state.srcPort) {
            link.ports = {};
            link.ports[link.source] = parseInt(this.state.srcPort);
            link.ports[link.target] = parseInt(this.state.trgPort);
        }
        var newLinks = this.props.net.links.filter(function (l) {
            return l !== _this.state.link;
        });
        newLinks = newLinks.concat(link);
        this.props.editLink(Object.assign({}, this.props.net, { links: newLinks }));
    },
    togglePort: function togglePort() {
        this.setState(Object.assign({}, this.state, { portOpen: !this.state.portOpen }));
    },
    helpState: function helpState() {
        if (this.linkError()) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {
        var errorHeader = null;
        var wtErrorP = null;
        var capErrorP = null;
        var srcPErrorP = null;
        var trgPErrorP = null;
        if (this.linkError()) {
            errorHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h5',
                null,
                'Errors:'
            );
        }
        if (this.state.wtError) {
            wtErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.wtError
            );
        }
        if (this.state.capError) {
            capErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.capError
            );
        }
        if (this.state.srcPortError) {
            srcPErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.srcPortError
            );
        }
        if (this.state.trgPortError) {
            trgPErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.trgPortError
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'addNodeHelpPopover', title: 'Edit Link Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Links must be assigned non-negative weights and capacities.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'If port numbers are given for a link end they must not be alread used by another link.'
            ),
            errorHeader,
            wtErrorP,
            capErrorP,
            srcPErrorP,
            trgPErrorP
        );
    },
    render: function render() {

        var source = this.props.netVisInteract.linkInfo.source;
        var target = this.props.netVisInteract.linkInfo.target;
        var layerInfo = null;
        var layer = this.props.netVisInteract.linkInfo.layer;
        if (layer) {
            layerInfo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'Layer: ',
                    layer
                )
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false, show: this.props.open, onHide: this.props.close,
                dialogClassName: 'add-node-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Edit Network Link: ',
                    source,
                    '-',
                    target,
                    ' ',
                    layerInfo
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Required Link Attributes'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.wtStatus() },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Weight'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.weight,
                                    onChange: this.wtChange,
                                    className: 'form-control' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                {
                                    className: 'control-label' },
                                'Capacity'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.capStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.capacity,
                                    onChange: this.capChange,
                                    className: 'form-control' })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                    onClick: this.togglePort },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Optional Link Ports'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Collapse"],
                        { 'in': this.state.portOpen },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.srcPortStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            { className: 'control-label' },
                                            source,
                                            ' Port'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                            value: this.state.srcPort,
                                            className: 'form-control', onChange: this.srcPortChange })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.trgPortStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            {
                                                className: 'control-label' },
                                            target,
                                            ' Port'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: this.trgPortChange,
                                            value: this.state.trgPort,
                                            className: 'form-control' })
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.editHandler, disabled: this.linkError() },
                    'Apply '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

function numValidator(numString, name) {
    var value = parseFloat(numString);
    if (isNaN(value)) {
        return name + ": must be a valid number.";
    }
    if (value < 0.0) {
        return name + ": must be non-negative.";
    }
    return null;
}

function portValidator(portNumString, nodeID, net, link) {
    var portNum = parseInt(portNumString);
    if (isNaN(portNum)) {
        return nodeID + " port number is not a valid number";
    }
    var valid = true;
    var links = net.links.filter(function (l) {
        return l !== link;
    }); // Don't include this link
    var usedPorts = new Set();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _link = _step.value;

            if (_link.ports) {
                if (_link.source === nodeID) {
                    usedPorts.add(_link.ports[_link.source]);
                    if (_link.ports[_link.source] === portNum) {
                        valid = false;
                    }
                }
                if (_link.target === nodeID) {
                    usedPorts.add(_link.ports[_link.target]);
                    if (_link.ports[_link.target] === portNum) {
                        valid = false;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (valid) {
        return null;
    }
    return nodeID + " port number " + portNum + " is already used, (used ports: " + Array.from(usedPorts).toString() + ")";
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showLinkEditModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_LINK_EDIT_DIALOG' });
        },
        editLink: function editLink(net) {
            dispatch({ type: 'NET_LINK_EDIT', net: net });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LinkEditDialog));

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var nodeTypes = [{ name: "Switch", id: "switch" }, { name: "Host", id: "host" }, { name: "Data Center", id: "data_center" }, { name: "User Region", id: "user_region" }];

var nodeLayerTypes = [{ name: "None", id: "none" }, { name: "IP", id: "ip" }, { name: "Ethernet", id: "ether" }, { name: "SONET/SDH", id: "sdh" }, { name: "G.709", id: "g709" }, { name: "Wavelength", id: "wavelength" }];

var NodeAddDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NodeAddDialog',
    getInitialState: function getInitialState() {
        return {
            id: "", type: "switch", layer: "none", ipv4: null, mac: null,
            vnid: "",
            addrOpen: false,
            idError: "Must specify a node ID",
            ipv4Error: null,
            macError: null
        };
    },
    idChange: function idChange(e) {
        var newId = e.target.value;
        this.setState(Object.assign({}, this.state, {
            id: newId,
            idError: idValidator(newId, this.props.net.nodes)
        }));
    },
    idStatus: function idStatus() {
        if (this.state.idError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    vnidChange: function vnidChange(e) {
        var newVnid = e.target.value;
        this.setState(Object.assign({}, this.state, {
            vnid: newVnid
        }));
    },
    ipv4Change: function ipv4Change(e) {
        var newIpv4 = e.target.value;
        if (newIpv4 === "") {
            this.setState(Object.assign({}, this.state, {
                ipv4: undefined,
                ipv4Error: null
            }));
        } else {
            this.setState(Object.assign({}, this.state, {
                ipv4: newIpv4,
                ipv4Error: ipv4Validator(newIpv4, this.props.net.nodes)
            }));
        }
    },
    ipv4Status: function ipv4Status() {
        if (this.state.ipv4Error) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    macChange: function macChange(e) {
        var newMac = e.target.value;
        if (newMac === "") {
            this.setState(Object.assign({}, this.state, {
                mac: undefined,
                macError: null
            }));
        } else {
            this.setState(Object.assign({}, this.state, {
                mac: newMac,
                macError: macValidator(newMac, this.props.net.nodes)
            }));
        }
    },
    macStatus: function macStatus() {
        if (this.state.macError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    nodeError: function nodeError() {
        return Boolean(this.state.idError || this.state.ipv4Error || this.state.macError);
    },
    addHandler: function addHandler() {
        // console.log("Entering add handler, nodeError: ");
        if (this.nodeError()) {
            return;
        }
        var node = { id: this.state.id, type: this.state.type,
            x: Math.floor(this.props.netVisInteract.coords.x),
            y: Math.floor(this.props.netVisInteract.coords.y) };
        if (this.state.layer !== "none") {
            node.layer = this.state.layer;
        }
        if (this.state.ipv4) {
            node.ipv4 = this.state.ipv4;
        }
        if (this.state.mac) {
            node.mac = this.state.mac;
        }
        if (this.state.vnid) {
            node.vnid = this.state.vnid;
        }
        // console.log("About to dispatch new node");
        // console.log(node);
        this.props.addNode(node);
    },
    toggleAddr: function toggleAddr() {
        this.setState(Object.assign({}, this.state, { addrOpen: !this.state.addrOpen }));
    },
    helpState: function helpState() {
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {
        var errorHeader = null;
        var idErrorP = null;
        var ipv4ErrorP = null;
        var macErrorP = null;
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            errorHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Errors:'
            );
        }
        if (this.state.idError) {
            idErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.idError
            );
        }
        if (this.state.ipv4Error) {
            ipv4ErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.ipv4Error
            );
        }
        if (this.state.macError) {
            macErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.macError
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'addNodeHelpPopover', title: 'Add Node Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Nodes must have unique IDs and the IDs can only consist of letters and numbers.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Virtual Network ID (VNID) can be any number or characters you\'d like. Typically used to model VLAN and such.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'If IPv4 or MAC addresses are given they must be in the proper format and not be already in use by another node in the network.'
            ),
            errorHeader,
            idErrorP,
            ipv4ErrorP,
            macErrorP
        );
    },
    nodeTypeChange: function nodeTypeChange(e) {
        this.setState(Object.assign({}, this.state, { type: e.target.value }));
    },
    nodeLayerChange: function nodeLayerChange(e) {
        this.setState(Object.assign({}, this.state, { layer: e.target.value }));
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState(Object.assign({}, this.state, {
            idError: idValidator(this.state.id, nextProps.net.nodes),
            ipv4Error: ipv4Validator(this.state.ipv4, nextProps.net.nodes),
            macError: macValidator(this.state.mac, nextProps.net.nodes)
        }));
    },
    render: function render() {
        var nodeTypeOptions = nodeTypes.map(function (ntype) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: ntype.id,
                    key: "nType-" + ntype.id },
                ntype.name
            );
        });
        var nodeLayerOptions = nodeLayerTypes.map(function (nlayer) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: nlayer.id,
                    key: "nLayer" + nlayer.id },
                nlayer.name
            );
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false, show: this.props.open, onHide: this.props.close,
                dialogClassName: 'add-node-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Add a Network Node'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Required Node Attributes'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.idStatus() },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 2 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'ID'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.id,
                                    onChange: this.idChange,
                                    className: 'form-control'
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                {
                                    className: 'control-label' },
                                'Type'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'select',
                                { value: this.state.type,
                                    className: 'form-control',
                                    onChange: this.nodeTypeChange },
                                nodeTypeOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Optional Node Attribute'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Layer'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'select',
                                { value: this.state.layer,
                                    className: 'form-control',
                                    onChange: this.nodeLayerChange },
                                nodeLayerOptions
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'VNID'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.vnid,
                                onChange: this.vnidChange,
                                className: 'form-control'
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                    onClick: this.toggleAddr },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Optional Node Addresses'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Collapse"],
                        { 'in': this.state.addrOpen },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.ipv4Status() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            { className: 'control-label' },
                                            'IPv4'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 9 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                            value: this.state.ipv4,
                                            className: 'form-control', onChange: this.ipv4Change })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.macStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            {
                                                className: 'control-label' },
                                            'Ethernet'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 9 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: this.macChange,
                                            value: this.state.mac,
                                            className: 'form-control' })
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.addHandler, disabled: this.nodeError() },
                    'Add '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

function idValidator(id, nodes) {
    var myReg = /^[A-Za-z0-9]+$/; //Only letters and numbers no special characters
    if (!myReg.test(id)) {
        return "Node IDs can only contain letters and numbers";
    }
    if (nodes.find(function (n) {
        return n.id === id;
    })) {
        return "Node Id is already used, must be unique";
    }
    return null;
}

function ipv4Validator(ipv4, nodes) {
    if (!ipv4) return null;
    var ipv4Reg = /^(([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)\.){3}([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)$/;
    if (!ipv4Reg.test(ipv4)) {
        return "Bad IPv4 address";
    }
    if (nodes.find(function (n) {
        return n.ipv4 === ipv4;
    })) {
        return "This IPv4 address is already used, must be unique";
    }
}

function macValidator(mac, nodes) {
    // RegEx for Ethernet address validation check
    if (!mac) return null;
    var ethReg = /^[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}$/;
    if (!ethReg.test(mac)) {
        return "Bad Ethernet address";
    }
    if (nodes.find(function (n) {
        return n.mac === mac;
    })) {
        return "This Ethernet address is already used, must be unique";
    }
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showNodeAddModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_NODE_ADD_DIALOG' });
        },
        addNode: function addNode(node) {
            dispatch({ type: 'NET_NODE_ADD', node: node });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(NodeAddDialog));

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 4/20/2016.
 */





var nodeTypes = [{ name: "Switch", id: "switch" }, { name: "Host", id: "host" }, { name: "Data Center", id: "data_center" }, { name: "User Region", id: "user_region" }];

var nodeLayerTypes = [{ name: "None", id: "none" }, { name: "IP", id: "ip" }, { name: "Ethernet", id: "ether" }, { name: "SONET/SDH", id: "sdh" }, { name: "G.709", id: "g709" }, { name: "Wavelength", id: "wavelength" }];

var NodeEditDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'NodeEditDialog',
    getInitialState: function getInitialState() {
        return {
            id: null, type: null, layer: null, ipv4: null,
            mac: null,
            vnid: "",
            addrOpen: false,
            idError: null,
            ipv4Error: null,
            macError: null,
            node: {}
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var nodeId = nextProps.netVisInteract.selectedNodes[0];
        var node = nextProps.net.nodes.find(function (n) {
            return n.id === nodeId;
        });
        if (!node) {
            node = {};
        }
        this.setState(Object.assign({}, this.state, {
            id: node.id, type: node.type, layer: node.layer, ipv4: node.ipv4,
            mac: node.mac,
            vnid: node.vnid,
            addrOpen: false,
            idError: null,
            ipv4Error: null,
            macError: null,
            node: node
        }));
    },
    idChange: function idChange(e) {
        var newId = e.target.value;
        this.setState(Object.assign({}, this.state, {
            id: newId,
            idError: idValidator(newId, this.props.net.nodes, this.state.node)
        }));
    },
    idStatus: function idStatus() {
        if (this.state.idError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    vnidChange: function vnidChange(e) {
        var newVnid = e.target.value;
        this.setState(Object.assign({}, this.state, {
            vnid: newVnid
        }));
    },
    ipv4Change: function ipv4Change(e) {
        var newIpv4 = e.target.value;
        if (newIpv4 === "") {
            this.setState(Object.assign({}, this.state, {
                ipv4: undefined,
                ipv4Error: null
            }));
        } else {
            this.setState(Object.assign({}, this.state, {
                ipv4: newIpv4,
                ipv4Error: ipv4Validator(newIpv4, this.props.net.nodes, this.state.node)
            }));
        }
    },
    ipv4Status: function ipv4Status() {
        if (this.state.ipv4Error) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    macChange: function macChange(e) {
        var newMac = e.target.value;
        if (newMac === "") {
            this.setState(Object.assign({}, this.state, {
                mac: undefined,
                macError: null
            }));
        } else {
            this.setState(Object.assign({}, this.state, {
                mac: newMac,
                macError: macValidator(newMac, this.props.net.nodes, this.state.node)
            }));
        }
    },
    macStatus: function macStatus() {
        if (this.state.macError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    nodeError: function nodeError() {
        return Boolean(this.state.idError || this.state.ipv4Error || this.state.macError);
    },
    editHandler: function editHandler() {
        // console.log("Entering edit handler");
        if (this.nodeError()) {
            return;
        }
        var node = { id: this.state.id, type: this.state.type,
            x: this.state.node.x,
            y: this.state.node.y };
        if (this.state.layer !== "none") {
            node.layer = this.state.layer;
        }
        if (this.state.ipv4) {
            node.ipv4 = this.state.ipv4;
        }
        if (this.state.mac) {
            node.mac = this.state.mac;
        }
        if (this.state.vnid) {
            node.vnid = this.state.vnid;
        }
        // console.log("About to dispatch edit node");
        // console.log(node);
        // Create a new network with the old node swapped out with the edited node
        // Need to update links that may have referenced the old node
        var oldId = this.state.node.id;
        var nodes = this.props.net.nodes.filter(function (n) {
            return n.id !== oldId;
        });
        nodes = nodes.concat(node);
        var links = this.props.net.links.map(function (l) {
            return Object.assign({}, l);
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var link = _step.value;

                if (link.source === oldId) {
                    link.source = node.id;
                }
                if (link.target === oldId) {
                    link.target = node.id;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        this.props.editNode(Object.assign({}, this.props.net, { nodes: nodes, links: links }));
    },
    toggleAddr: function toggleAddr() {
        this.setState(Object.assign({}, this.state, { addrOpen: !this.state.addrOpen }));
    },
    helpState: function helpState() {
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            return 'danger';
        } else {
            return 'info';
        }
    },
    helpPopover: function helpPopover() {
        var errorHeader = null;
        var idErrorP = null;
        var ipv4ErrorP = null;
        var macErrorP = null;
        if (this.state.idError || this.state.ipv4Error || this.state.macError) {
            errorHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Errors:'
            );
        }
        if (this.state.idError) {
            idErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.idError
            );
        }
        if (this.state.ipv4Error) {
            ipv4ErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.ipv4Error
            );
        }
        if (this.state.macError) {
            macErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.state.macError
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'editNodeHelpPopover', title: 'Edit Node Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Nodes must have unique IDs and the IDs can only consist of letters and numbers.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Virtual Network ID (VNID) can be any number or characters you\'d like. Typically used to model VLAN and such.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'If IPv4 or MAC addresses are given they must be in the proper format and not be already in use by another node in the network.'
            ),
            errorHeader,
            idErrorP,
            ipv4ErrorP,
            macErrorP
        );
    },
    nodeTypeChange: function nodeTypeChange(e) {
        this.setState(Object.assign({}, this.state, { type: e.target.value }));
    },
    nodeLayerChange: function nodeLayerChange(e) {
        this.setState(Object.assign({}, this.state, { layer: e.target.value }));
    },
    render: function render() {
        var nodeTypeOptions = nodeTypes.map(function (ntype) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: ntype.id,
                    key: "nType-" + ntype.id },
                ntype.name
            );
        });
        var nodeLayerOptions = nodeLayerTypes.map(function (nlayer) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: nlayer.id,
                    key: "nLayer" + nlayer.id },
                nlayer.name
            );
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false, show: this.props.open, onHide: this.props.close,
                dialogClassName: 'add-node-net-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Network Node Edit: ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'em',
                        null,
                        this.state.node.id
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Required Node Attributes'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.idStatus() },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 2 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'ID'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.id,
                                    onChange: this.idChange,
                                    className: 'form-control' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                {
                                    className: 'control-label' },
                                'Type'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'select',
                                { value: this.state.type,
                                    className: 'form-control',
                                    onChange: this.nodeTypeChange },
                                nodeTypeOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'em',
                                null,
                                'Optional Node Attribute'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Layer'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'select',
                                { value: this.state.layer,
                                    className: 'form-control',
                                    onChange: this.nodeLayerChange },
                                nodeLayerOptions
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'VNID'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.vnid,
                                onChange: this.vnidChange,
                                className: 'form-control'
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 10, xsOffset: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                    onClick: this.toggleAddr },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Optional Node Addresses'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Collapse"],
                        { 'in': this.state.addrOpen },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.ipv4Status() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            { className: 'control-label' },
                                            'IPv4'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 9 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                            value: this.state.ipv4,
                                            className: 'form-control', onChange: this.ipv4Change })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: this.macStatus() },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 3 },
                                        ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            {
                                                className: 'control-label' },
                                            'Ethernet'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                        { xs: 9 },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: this.macChange,
                                            value: this.state.mac,
                                            className: 'form-control' })
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.editHandler, disabled: this.nodeError() },
                    'Apply '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: this.helpState() },
                        'Help'
                    )
                )
            )
        );
    }
});

function idValidator(id, nodes, node) {
    var myReg = /^[A-Za-z0-9]+$/; //Only letters and numbers no special characters
    if (!myReg.test(id)) {
        return "Node IDs can only contain letters and numbers";
    }
    if (id === node.id) {
        return null;
    }
    if (nodes.find(function (n) {
        return n.id === id;
    })) {
        return "Node Id is already used, must be unique";
    }
    return null;
}

function ipv4Validator(ipv4, nodes, node) {
    var otherNodes = nodes.filter(function (n) {
        return n.id !== node.id;
    });
    if (!ipv4) return null;
    var ipv4Reg = /^(([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)\.){3}([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)$/;
    if (!ipv4Reg.test(ipv4)) {
        return "Bad IPv4 address";
    }
    if (otherNodes.find(function (n) {
        return n.ipv4 === ipv4;
    })) {
        return "This IPv4 address is already used, must be unique";
    }
}

function macValidator(mac, nodes, node) {
    var otherNodes = nodes.filter(function (n) {
        return n.id !== node.id;
    });
    if (!mac) return null;
    var ethReg = /^[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}$/;
    if (!ethReg.test(mac)) {
        return "Bad Ethernet address";
    }
    if (otherNodes.find(function (n) {
        return n.mac === mac;
    })) {
        return "This Ethernet address is already used, must be unique";
    }
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showNodeEditModal,
        net: state.net,
        netVisInteract: state.netVisInteract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_NODE_EDIT_DIALOG' });
        },
        editNode: function editNode(net) {
            dispatch({ type: 'NET_NODE_EDIT', net: net });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(NodeEditDialog));

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var DistanceWeightsDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'DistanceWeightsDialog',
    getInitialState: function getInitialState() {
        var r = getLinkMinMax(this.props.net);
        var scale = 1.0;
        var offset = 0.0;
        return {
            minDist: r.pmin,
            maxDist: r.pmax,
            strScale: scale.toPrecision(4),
            strOffset: offset.toPrecision(4),
            scaleMinDist: scale * r.pmin + offset,
            scaleMaxDist: scale * r.pmax + offset,
            linkLengthMap: r.linkLengthMap
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var r = getLinkMinMax(this.props.net);
        var scale = parseFloat(this.state.strScale);
        var offset = parseFloat(this.state.strOffset);
        this.setState(Object.assign({}, this.state, {
            minDist: r.pmin,
            maxDist: r.pmax,
            scaleMinDist: scale * r.pmin + offset,
            scaleMaxDist: scale * r.pmax + offset,
            linkLengthMap: r.linkLengthMap
        }));
    },
    scaleChange: function scaleChange(e) {
        var scale = parseFloat(e.target.value);
        var offset = parseFloat(this.state.strOffset);

        this.setState(Object.assign({}, this.state, {
            strScale: e.target.value,
            scaleMinDist: scale * this.state.minDist + offset,
            scaleMaxDist: scale * this.state.maxDist + offset
        }));
    },
    scaleStatus: function scaleStatus() {
        if (isNaN(parseFloat(this.state.strScale))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    offsetChange: function offsetChange(e) {
        var scale = parseFloat(this.state.strScale);
        var offset = parseFloat(e.target.value);
        this.setState(Object.assign({}, this.state, {
            strOffset: e.target.value,
            scaleMinDist: scale * this.state.minDist + offset,
            scaleMaxDist: scale * this.state.maxDist + offset
        }));
    },
    offsetStatus: function offsetStatus() {
        if (isNaN(parseFloat(this.state.strOffset))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    badTransform: function badTransform() {
        return isNaN(parseFloat(this.state.strScale)) || isNaN(parseFloat(this.state.strOffset));
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'DistanceWeightsHelpPopover', title: 'Port Numbering Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command allows you to assign distance based weights to all links in the network.'
            )
        );
    },
    applyHandler: function applyHandler() {
        if (this.badTransform()) {
            return;
        }
        var links = this.props.net.links;
        var newLinks = [];
        var scale = parseFloat(this.state.strScale);
        var offset = parseFloat(this.state.strOffset);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var link = _step.value;

                var newLink = Object.assign({}, link);
                var linkKey = link.source + "-" + link.target;
                newLink.weight = this.state.linkLengthMap.get(linkKey) * scale + offset;
                newLinks.push(newLink);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var newNet = Object.assign({}, this.props.net, { links: newLinks });
        this.props.updateWeights(newNet);
    },
    render: function render() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'dist-wt-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Distance Based Weights'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                'Link Pixel Distances'
                            ),
                            ' '
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2, xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Min'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.minDist.toPrecision(4),
                                readOnly: true, className: 'form-control' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2, xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Max'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.maxDist.toPrecision(4),
                                readOnly: true, className: 'form-control' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Scaled'
                                ),
                                ' Distances'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2, xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Min'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.scaleMinDist.toPrecision(4),
                                readOnly: true, className: 'form-control' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 2, xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                { className: 'control-label' },
                                'Max'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 3 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.scaleMaxDist.toPrecision(4),
                                readOnly: true, className: 'form-control' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Parameters'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.scaleStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 2, xsOffset: 1 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Scale'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.strScale,
                                    onChange: this.scaleChange, className: 'form-control' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.offsetStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 2, xsOffset: 1 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Offset'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.strOffset,
                                    onChange: this.offsetChange, className: 'form-control' })
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.applyHandler, disabled: this.badTransform() },
                    'Apply '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

function getLinkMinMax(net) {
    var links = net.links;
    var nodes = net.nodes;
    var linkLengthMap = new Map();
    var pmin = Infinity;
    var pmax = 0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        var _loop = function _loop() {
            var link = _step2.value;

            var srcNode = nodes.find(function (n) {
                return link.source === n.id;
            });
            var trgNode = nodes.find(function (n) {
                return link.target === n.id;
            });
            var linkKey = link.source + "-" + link.target;
            var euclid = Math.sqrt(Math.pow(srcNode.x - trgNode.x, 2) + Math.pow(srcNode.y - trgNode.y, 2));
            linkLengthMap.set(linkKey, euclid);
            pmin = euclid < pmin ? euclid : pmin;
            pmax = euclid > pmax ? euclid : pmax;
        };

        for (var _iterator2 = links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return { pmin: pmin, pmax: pmax, linkLengthMap: linkLengthMap };
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showDistanceWeightsModal,
        net: state.net
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_DIST_WEIGHT_DIALOG' });
        },
        updateWeights: function updateWeights(net) {
            dispatch({ type: 'UPDATE_LINK_WEIGHTS', net: net });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(DistanceWeightsDialog));

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var nodeTypes = [{ name: "Host", id: "host" }, { name: "All", id: "all" }, { name: "None", id: "none" }];

var IPAddressDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'IPAddressDialog',
    getInitialState: function getInitialState() {
        return {
            nodeTypes: "host",
            ipv4: "",
            ipv4Error: ipv4Validator(null),
            ipFlag: true,
            mac: "",
            macError: macValidator(null),
            macFlag: true
        };
    },
    helpPopover: function helpPopover() {
        var addressErrorP = [];
        if (this.state.ipv4Error && this.state.ipFlag) {
            addressErrorP.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { key: 'ipError' },
                this.state.ipv4Error
            ));
        }
        if (this.state.macError && this.state.macFlag) {
            addressErrorP.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { key: 'macError' },
                this.state.macError
            ));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'IPAddressHelpPopover', title: 'IP/MAC Address Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command allows you to assign IP/MAC addresses to nodes based on a specified starting IPv4/MAC address. If ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'none'
                ),
                ' is selected IPv4/MAC addresses will be removed from all nodes.'
            ),
            addressErrorP
        );
    },
    ipv4Change: function ipv4Change(e) {
        var newIpv4 = e.target.value;
        this.setState(Object.assign({}, this.state, {
            ipv4: newIpv4,
            ipv4Error: ipv4Validator(newIpv4)
        }));
    },
    ipv4Status: function ipv4Status() {
        if (this.state.ipv4Error && this.state.ipFlag) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    nodeTypeChange: function nodeTypeChange(e) {
        this.setState(Object.assign({}, this.state, { nodeTypes: e.target.value }));
    },
    applyHandler: function applyHandler() {
        if (this.addressError()) {
            return;
        }
        var newNet = null;
        if (this.state.ipFlag) {
            newNet = assignIPs(this.state.ipv4, this.state.nodeTypes, this.props.net);
        }
        if (this.state.macFlag) {
            if (newNet) {
                newNet = assignMACs(this.state.mac, this.state.nodeTypes, newNet);
            } else {
                newNet = assignMACs(this.state.mac, this.state.nodeTypes, this.props.net);
            }
        }
        this.props.updateIPv4Address(newNet);
    },
    addressError: function addressError() {
        if (this.state.nodeTypes === 'none') {
            return false;
        } else {
            return this.state.ipFlag && Boolean(this.state.ipv4Error) || this.state.macFlag && Boolean(this.state.macError);
        }
    },
    ipSelectChange: function ipSelectChange() {
        this.setState(Object.assign({}, this.state, { ipFlag: !this.state.ipFlag }));
    },
    macSelectChange: function macSelectChange() {
        this.setState(Object.assign({}, this.state, { macFlag: !this.state.macFlag }));
    },
    macChange: function macChange(e) {
        var newMac = e.target.value;
        this.setState(Object.assign({}, this.state, {
            mac: newMac,
            macError: macValidator(newMac)
        }));
    },
    macStatus: function macStatus() {
        if (this.state.macError && this.state.macFlag) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    render: function render() {
        var nodeTypeOptions = nodeTypes.map(function (ntype) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: ntype.id,
                    key: "nType-" + ntype.id },
                ntype.name
            );
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'ipv4-addr-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'IPv4/MAC Address Assignment'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 7 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                {
                                    className: 'control-label' },
                                'Which Nodes?'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xs: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'select',
                                { value: this.state.nodeTypes,
                                    className: 'form-control',
                                    onChange: this.nodeTypeChange },
                                nodeTypeOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.ipv4Status() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 7 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Checkbox"],
                                    { checked: this.state.ipFlag, onChange: this.ipSelectChange },
                                    ' IPv4 Addresses (start)'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 5 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                    value: this.state.ipv4,
                                    className: 'form-control', onChange: this.ipv4Change })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.macStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 7 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Checkbox"],
                                    { checked: this.state.macFlag, onChange: this.macSelectChange },
                                    ' MAC Addresses (start)'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 5 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
                                    value: this.state.mac,
                                    className: 'form-control', onChange: this.macChange })
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.applyHandler, disabled: this.addressError() },
                    'Add '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

function ipv4Validator(ipv4) {
    var ipv4Reg = /^(([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)\.){3}([1-9]?\d|1\d\d|2[0-5][0-5]|2[0-4]\d)$/;
    if (!ipv4Reg.test(ipv4)) {
        return "Bad IPv4 address";
    }
}

function macValidator(mac) {
    // RegEx for Ethernet address validation check
    var ethReg = /^[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}:[0-9a-fA-F]{2}$/;
    if (!ethReg.test(mac)) {
        return "Bad Ethernet address";
    }
}

function assignIPs(ipString, whichNodes, net) {
    // Make an array containing a copy of every node
    var nodes = net.nodes.map(function (n) {
        return Object.assign({}, n);
    });
    var ipAddr = ipStringToInt(ipString);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var node = _step.value;

            delete node.ipv4;
            if (whichNodes === "all") {
                node.ipv4 = ipIntToString(ipAddr);
                ipAddr++;
            } else if (node.type === "host" && whichNodes === "host") {
                node.ipv4 = ipIntToString(ipAddr);
                ipAddr++;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return Object.assign({}, net, { nodes: nodes });
}

function ipStringToInt(ipString) {
    var numStrings = ipString.split(".");
    var ipInt = 0;
    ipInt |= parseInt(numStrings[0]) << 24;
    ipInt |= parseInt(numStrings[1]) << 16;
    ipInt |= parseInt(numStrings[2]) << 8;
    ipInt |= parseInt(numStrings[3]);
    return ipInt;
}

function ipIntToString(ipInt) {
    var numStrings = [];
    numStrings.push(((ipInt & 0xFF000000) >>> 24).toString());
    numStrings.push(((ipInt & 0x00FF0000) >>> 16).toString());
    numStrings.push(((ipInt & 0x0000FF00) >>> 8).toString());
    numStrings.push((ipInt & 0x000000FF).toString());
    return numStrings.join(".");
}

function assignMACs(macString, whichNodes, net) {
    // Make an array containing a copy of every node
    var nodes = net.nodes.map(function (n) {
        return Object.assign({}, n);
    });
    var macAddr = macStringToInt(macString);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var node = _step2.value;

            delete node.mac;
            if (whichNodes === "all") {
                node.mac = macIntToString(macAddr);
                macAddr++;
            } else if (node.type === "host" && whichNodes === "host") {
                node.mac = macIntToString(macAddr);
                macAddr++;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return Object.assign({}, net, { nodes: nodes });
}

function macStringToInt(macString) {
    var numStrings = macString.split(":");
    var macInt = 0;
    macInt += parseInt(numStrings[0], 16) * Math.pow(16, 10);
    macInt += parseInt(numStrings[1], 16) * Math.pow(16, 8);
    macInt += parseInt(numStrings[2], 16) * Math.pow(16, 6);
    macInt += parseInt(numStrings[3], 16) * Math.pow(16, 4);
    macInt += parseInt(numStrings[4], 16) * Math.pow(16, 2);
    macInt += parseInt(numStrings[5], 16);
    return macInt;
}

function macIntToString(macInt) {
    var temp = macInt;
    var numStrings = [];
    for (var i = 10; i >= 0; i = i - 2) {
        var factor = Math.floor(temp / Math.pow(16, i));
        temp -= factor * Math.pow(16, i);
        var fstring = factor.toString(16);
        if (fstring.length < 2) {
            fstring = "0" + fstring;
        }
        numStrings.push(fstring);
    }
    return numStrings.join(":").toUpperCase();
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showIPAddressModal,
        net: state.net
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_IP_ADDRESS_DIALOG' });
        },
        updateIPv4Address: function updateIPv4Address(net) {
            dispatch({ type: 'IPV4_ADDRESS_UPDATE', net: net });
        }

    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(IPAddressDialog));

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var PortNumberDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'PortNumberDialog',
    getInitialState: function getInitialState() {
        return { startPort: 1,
            portError: null };
    },
    ptChange: function ptChange(e) {
        var startPort = e.target.value;
        this.setState(Object.assign({}, this.state, {
            startPort: startPort,
            portError: portValidator(startPort)
        }));
    },
    ptStatus: function ptStatus() {
        if (this.state.portError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    applyHandler: function applyHandler() {
        if (this.state.portError) {
            return;
        }
        var newNet = assignPorts(parseInt(this.state.startPort), this.props.net);
        this.props.updatePortNumbers(newNet);
    },
    removeHandler: function removeHandler() {
        var newNet = removePorts(this.props.net);
        this.props.updatePortNumbers(newNet);
    },
    helpPopover: function helpPopover() {
        var portErrorP = void 0;
        if (this.state.portError) {
            portErrorP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Label"],
                    { bsStyle: 'danger' },
                    'Error: '
                ),
                this.state.portError
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'PortNumberHelpPopover', title: 'Port Numbering Help', bsSize: 'lg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This function will assign node port numbers to each end of a link in the network. It may ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'change'
                ),
                ' any existing port assignments.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Such functionality is needed if forwarding or switching tables will be computed for the network nodes. You can specify the starting (lowest) port number used on the switches.'
            ),
            portErrorP
        );
    },
    render: function render() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'port-num-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Port Numbering'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.ptStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 6, xsOffset: 1 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Starting Port Number'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.startPort,
                                    onChange: this.ptChange,
                                    className: 'form-control' })
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.applyHandler, disabled: Boolean(this.state.portError) },
                    'Add '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'warning', onClick: this.removeHandler },
                    'Remove'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'bottom', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

function portValidator(pString) {
    var value = parseInt(pString);
    if (isNaN(value)) {
        return "Starting port number: must be a valid number.";
    }
    if (value < 0) {
        return "Starting port number: must be non-negative.";
    }
    return null;
}

function assignPorts(startPort, net) {
    var links = net.links.map(function (l) {
        return Object.assign({}, l);
    }); // Make a copy of the link array
    var nodes = net.nodes;
    var nodePortMap = new Map();
    // Initialize the node port counters
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var node = _step.value;

            nodePortMap.set(node.id, startPort);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var link = _step2.value;

            var srcPort = nodePortMap.get(link.source);
            nodePortMap.set(link.source, srcPort + 1);
            var trgPort = nodePortMap.get(link.target);
            nodePortMap.set(link.target, trgPort + 1);
            link.ports = {};
            link.ports[link.source] = srcPort;
            link.ports[link.target] = trgPort;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return Object.assign({}, net, { links: links });
}

function removePorts(net) {
    var links = net.links.map(function (l) {
        return Object.assign({}, l);
    }); // Make a copy of the link array
    var nodes = net.nodes;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = links[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var link = _step3.value;

            delete link.ports;
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return Object.assign({}, net, { links: links });
}

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showPortNumberModal,
        net: state.net
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_PORT_NUMBER_DIALOG' });
        },
        updatePortNumbers: function updatePortNumbers(net) {
            dispatch({ type: 'UPDATE_PORT_NUMBERS', net: net });
        }

    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PortNumberDialog));

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/**
 * Created by Greg on 3/30/2016.
 */





var RandomCapsDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'RandomCapsDialog',
    getInitialState: function getInitialState() {
        return {
            strLowCap: "10",
            strUpCap: "100"
        };
    },
    lowCapChange: function lowCapChange(e) {
        this.setState(Object.assign({}, this.state, {
            strLowCap: e.target.value
        }));
    },
    lowCapStatus: function lowCapStatus() {
        if (isNaN(parseFloat(this.state.strLowCap))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    upCapChange: function upCapChange(e) {
        this.setState(Object.assign({}, this.state, {
            strUpCap: e.target.value
        }));
    },
    upCapStatus: function upCapStatus() {
        if (isNaN(parseFloat(this.state.strUpCap))) {
            return "has-error";
        } else {
            return "has-success";
        }
    },
    badRange: function badRange() {
        return isNaN(parseFloat(this.state.strLowCap)) || isNaN(parseFloat(this.state.strUpCap));
    },
    applyHandler: function applyHandler() {
        if (this.badRange()) {
            return;
        }
        var links = this.props.net.links;
        var newLinks = [];
        var lowCap = parseFloat(this.state.strLowCap);
        var upCap = parseFloat(this.state.strUpCap);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var link = _step.value;

                var newLink = Object.assign({}, link);
                newLink.capacity = lowCap + Math.random() * (upCap - lowCap);
                newLinks.push(newLink);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var newNet = Object.assign({}, this.props.net, { links: newLinks });
        this.props.updateCapacities(newNet);
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'RandomCapsHelpPopover', title: 'Randomize Capacities Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command allows you to assign random capacities to all links in the network.'
            )
        );
    },
    render: function render() {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'rand-cap-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Randomize Link Capacities'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { xsOffset: 1 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'em',
                                    null,
                                    'Parameters'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.lowCapStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 6, xsOffset: 1 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Lower Capacity Bound'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.strLowCap,
                                    onChange: this.lowCapChange, className: 'form-control' })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Row"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.upCapStatus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 6, xsOffset: 1 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label' },
                                    'Upper Capacity Bound'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                                { xs: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.strUpCap,
                                    onChange: this.upCapChange, className: 'form-control' })
                            )
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.applyHandler, disabled: this.badRange() },
                    'Apply '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.props.close },
                    'Close'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showRandomCapsModal,
        net: state.net
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_RAND_CAP_DIALOG' });
        },
        updateCapacities: function updateCapacities(net) {
            dispatch({ type: 'UPDATE_LINK_CAPACITIES', net: net });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(RandomCapsDialog));

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathComputations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_netValid__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_pathValid__ = __webpack_require__(76);
/**
 * Created by Greg on 3/30/2016.
 */








var KShortestPathsDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'KShortestPathsDialog',
    getInitialState: function getInitialState() {
        var node1 = void 0,
            node2 = void 0,
            nodes = this.props.net.nodes;
        if (nodes.length < 2) {
            node1 = null;
            node2 = null;
        } else {
            node1 = nodes[0].id;
            node2 = nodes[1].id;
        }
        var node = this.props.net.nodes[0];
        return {
            pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(this.props.net), k: 2,
            src: node1, dst: node2
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var node1 = void 0,
            node2 = void 0,
            nodes = nextProps.net.nodes;
        if (nodes.length < 2) {
            node1 = null;
            node2 = null;
        } else {
            node1 = nodes[0].id;
            node2 = nodes[1].id;
        }
        var node = this.props.net.nodes[0];
        this.setState({ pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(this.props.net), k: 2,
            src: node1, dst: node2, errorMsg: null });
    },
    srcChange: function srcChange(e) {
        this.setState({ src: e.target.value });
    },
    dstChange: function dstChange(e) {
        this.setState({ dst: e.target.value });
    },
    kChange: function kChange(e) {
        this.setState({ k: e.target.value });
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'KShortestPathsHelpPopover',
                title: 'K-Shortest Paths Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command uses a server to compute the k-shortest paths between the selected nodes for a ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'connected'
                ),
                ' network.'
            )
        );
    },
    isError: function isError() {
        if (!this.state.connected) {
            return true;
        }
        if (this.state.src === this.state.dst) {
            return true;
        }
        if (!this.state.src || !this.state.dst) {
            // Empty network
            return true;
        }
        if (isNaN(parseInt(this.state.k)) || parseInt(this.state.k) < 1) {
            return true;
        }
        return false;
    },
    computeHandler: function computeHandler() {
        if (this.isError()) {
            return;
        }
        var net = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__validation_netValid__["b" /* net2NetworkXJSON */])(this.props.net),
            k = parseInt(this.state.k);
        var computeRequest = {
            net: net,
            srcNode: this.state.src,
            dstNode: this.state.dst,
            k: k
        };
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var myInit = {
            method: 'POST',
            body: JSON.stringify(computeRequest),
            headers: myHeaders,
            mode: 'cors',
            cache: 'default'
        };
        var that = this;
        this.setState({ errorMsg: "Sending request to server" });
        fetch("http://" + this.props.namePort + "/kShortestPaths", myInit).then(function (response) {
            // console.log(response);
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return response.json().then(function (json) {
                    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validation_pathValid__["a" /* pathCollectionValidate */])(JSON.stringify(json));
                    if (result.errors) {
                        that.setState({ errorMsg: JSON.stringify(result.errors) });
                        return;
                    } else {
                        // console.log("Got the JSON");
                        // console.log(result.pathObj);
                        that.setState({ pathObj: result.pathObj, errorMsg: null });
                        return;
                    }
                });
            } else {
                // console.log("not json");
                that.setState({ errorMsg: "Server didn't return valid JSON" });
                return;
            }
        }).catch(function (error) {
            that.setState({ errorMsg: "Server Error: " + error });
        });
    },
    applyHandler: function applyHandler() {
        // console.log(this.state);
        if (this.state.pathObj) {
            this.props.pathCollectionAdd(this.state.pathObj);
        }
        this.setState({ pathObj: null });
    },
    textAreaValue: function textAreaValue() {
        if (!this.state.connected) {
            return "Network is not connected";
        }
        if (this.state.src === this.state.dst) {
            return "Source and Destination cannot be the same";
        }
        if (!this.state.src || !this.state.dst) {
            // Empty network
            return "Must have at least two nodes in the network";
        }
        if (isNaN(parseInt(this.state.k)) || parseInt(this.state.k) < 1) {
            return "K must be an integer greater than or equal to 1";
        }
        if (this.state.errorMsg) {
            return this.state.errorMsg;
        } else {
            if (this.state.pathObj) {
                return JSON.stringify(this.state.pathObj, null, 2);
            }
        }
        return "";
    },
    render: function render() {
        var nodes = this.props.net.nodes.map(function (n) {
            return n.id;
        }).sort(); // Nodes as a array of strings
        var srcOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "src_" + nstr,
                    value: nstr },
                nstr
            );
        });
        var destOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "dst_" + nstr,
                    value: nstr },
                nstr
            );
        });
        destOptions.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: '_ALL_', key: 'dst_ALL' },
            'All'
        ));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close,
                dialogClassName: 'min-span-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'K-Shortest Paths via Server'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Form"],
                    { horizontal: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        { controlId: 'srcDstNodes' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Source'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select',
                                    onChange: this.srcChange,
                                    value: this.state.src },
                                srcOptions
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Dest'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select',
                                    onChange: this.dstChange,
                                    value: this.state.dst },
                                destOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        { controlId: 'srcDstNodes' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'K'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { type: 'text', onChange: this.kChange,
                                value: this.state.k })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true,
                        value: this.textAreaValue(),
                        rows: 5, style: { resize: "none" } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.computeHandler,
                        disabled: this.isError() },
                    'Compute '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.applyHandler },
                    'Apply'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top',
                        overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showKShortPathsModal,
        net: state.net,
        paths: state.paths,
        namePort: state.compServe.namePort
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_KSHORT_PATHS_DIALOG' });
        },
        pathCollectionAdd: function pathCollectionAdd(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(KShortestPathsDialog));

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathComputations__ = __webpack_require__(74);
/**
 * Created by Greg on 3/30/2016.
 */






var MinSpanTreeDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'MinSpanTreeDialog',
    getInitialState: function getInitialState() {
        return { pathGroup: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(this.props.net) };
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'MinSpanTreeHelpPopover', title: 'Minimum Spanning Tree Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command computes the minimum spanning tree for a ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'connected'
                ),
                'network and returns the result as a set of single link paths for easy visualization. Use the ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'Add'
                ),
                ' button to add this group of paths to the application, then you can examine the tree via the Paths Info panel.'
            )
        );
    },
    applyHandler: function applyHandler() {
        if (this.state.pathGroup) {
            this.props.pathCollectionAdd(this.state.pathGroup);
        }
    },
    computeHandler: function computeHandler() {
        var net = this.props.net;
        // console.log("Is network connected: " + depthFirstConnected(net));
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(net)) {
            return;
        };
        var tree = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["f" /* minSpanTree */])(net);
        // Create a path group from the tree branches
        var pathGroup = { id: "MinSpanTree", desc: "Minimum spanning tree as a set of link-paths" };
        var pathList = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var t = _step.value;

                var pathObj = { nodeList: t, cost: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["g" /* linkParm */])(net, t[0], t[1], 'weight'),
                    capacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["g" /* linkParm */])(net, t[0], t[1], 'capacity') };
                pathList.push(pathObj);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        pathGroup.pathList = pathList;
        this.setState({ pathGroup: pathGroup });
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({ pathGroup: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(nextProps.net) });
    },
    textAreaValue: function textAreaValue() {
        if (this.state.pathGroup) {
            return JSON.stringify(this.state.pathGroup, null, 2);
        }
        if (!this.state.connected) {
            return "Cannot compute tree, Network is disconnected";
        }
        return "";
    },
    render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'min-span-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Minimum Spanning Tree'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true,
                        value: this.textAreaValue(),
                        rows: 5, style: { resize: "none" } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.computeHandler, disabled: !this.state.connected },
                    'Compute '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.applyHandler, disabled: !Boolean(this.state.pathGroup) },
                    'Add'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showMinTreeModal,
        net: state.net,
        paths: state.paths
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_MIN_TREE_DIALOG' });
        },
        pathCollectionAdd: function pathCollectionAdd(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
        }

    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MinSpanTreeDialog));

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathComputations__ = __webpack_require__(74);
/**
 * Created by Greg on 3/30/2016.
 */






var ShortestPathDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'ShortestPathDialog',
    getInitialState: function getInitialState() {
        var node = this.props.net.nodes[0];
        return { pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(this.props.net),
            src: node ? node.id : null, dst: '_ALL_' };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var node = nextProps.net.nodes[0];
        this.setState({ pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(nextProps.net),
            src: node ? node.id : null, dst: '_ALL_' });
    },
    srcChange: function srcChange(e) {
        this.setState({ src: e.target.value });
    },
    dstChange: function dstChange(e) {
        this.setState({ dst: e.target.value });
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'ShortestPathHelpPopover', title: 'Shortest Path Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command computes the shortest paths for a ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'connected'
                ),
                ' network.'
            )
        );
    },
    isError: function isError() {
        if (!this.state.connected) {
            return true;
        }
        if (this.state.src === this.state.dst) {
            return true;
        }
        if (!this.state.src) {
            // Empty network
            return true;
        }
        return false;
    },
    computeHandler: function computeHandler() {
        var net = this.props.net;
        var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["e" /* basicDijkstra */])(net, this.state.src);
        var pathList = void 0,
            id = void 0,
            desc = void 0;
        if (this.state.dst === "_ALL_") {
            pathList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["c" /* getPaths */])(this.state.src, result.previous, net);
            id = "Shortest_" + this.state.src + "_All";
            desc = "Shortest paths from node " + this.state.src;
        } else {
            pathList = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["d" /* getPath */])(this.state.src, this.state.dst, result.previous, net)];
            id = "Shortest_" + this.state.src + "_" + this.state.dst;
            desc = "Shortest path from node " + this.state.src + " to node " + this.state.dst;
        }
        var pathGroup = { id: id, desc: desc, pathList: pathList };
        this.setState({ pathGroup: pathGroup });
    },
    applyHandler: function applyHandler() {
        if (this.state.pathGroup) {
            this.props.pathCollectionAdd(this.state.pathGroup);
        }
        this.setState({ pathGroup: null });
    },
    textAreaValue: function textAreaValue() {
        if (!this.state.connected) {
            return "Cannot compute tree, Network is disconnected";
        }
        if (this.state.src === this.state.dst) {
            return "Source and destination must be different";
        }
        if (!this.state.src) {
            return "You must choose a source node";
        }
        if (this.state.pathGroup) {
            return JSON.stringify(this.state.pathGroup, null, 2);
        }
        return "";
    },
    render: function render() {
        var nodes = this.props.net.nodes.map(function (n) {
            return n.id;
        }).sort(); // Nodes as a array of strings
        var srcOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "src_" + nstr, value: nstr },
                nstr
            );
        });
        var destOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "dst_" + nstr, value: nstr },
                nstr
            );
        });
        destOptions.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: '_ALL_', key: 'dst_ALL' },
            'All'
        ));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'min-span-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Shortest Paths'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Form"],
                    { horizontal: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        { controlId: 'srcDstNodes' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Source'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select', onChange: this.srcChange, value: this.state.src },
                                srcOptions
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Dest'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select', onChange: this.dstChange, value: this.state.dst },
                                destOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true,
                        value: this.textAreaValue(),
                        rows: 5, style: { resize: "none" } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.computeHandler, disabled: this.isError() },
                    'Compute '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.applyHandler },
                    'Apply'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showShortPathModal,
        net: state.net,
        paths: state.paths
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_SHORT_PATH_DIALOG' });
        },
        pathCollectionAdd: function pathCollectionAdd(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ShortestPathDialog));

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableModal__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathComputations__ = __webpack_require__(74);
/**
 * Created by Greg on 3/30/2016.
 */






var WidestPathDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({
    displayName: 'WidestPathDialog',
    getInitialState: function getInitialState() {
        var node = this.props.net.nodes[0];
        return { pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(this.props.net),
            src: node ? node.id : null, dst: '_ALL_' };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var node = nextProps.net.nodes[0];
        this.setState({ pathObj: null, connected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["a" /* depthFirstConnected */])(nextProps.net),
            src: node ? node.id : null, dst: '_ALL_' });
    },
    srcChange: function srcChange(e) {
        this.setState({ src: e.target.value });
    },
    dstChange: function dstChange(e) {
        this.setState({ dst: e.target.value });
    },
    helpPopover: function helpPopover() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Popover"],
            { id: 'WidestPathHelpPopover', title: 'Widest Path Help' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'This command computes the widest paths for a ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'em',
                    null,
                    'connected'
                ),
                ' network.'
            )
        );
    },
    isError: function isError() {
        if (!this.state.connected) {
            return true;
        }
        if (this.state.src === this.state.dst) {
            return true;
        }
        if (!this.state.src) {
            // Empty network
            return true;
        }
        return false;
    },
    computeHandler: function computeHandler() {
        var net = this.props.net;
        var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["b" /* widestDijkstra */])(net, this.state.src);
        var pathList = void 0,
            id = void 0,
            desc = void 0;
        if (this.state.dst === "_ALL_") {
            pathList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["c" /* getPaths */])(this.state.src, result.previous, net);
            id = "Widest" + this.state.src + "_All";
            desc = "Widest paths from node " + this.state.src;
        } else {
            pathList = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PathComputations__["d" /* getPath */])(this.state.src, this.state.dst, result.previous, net)];
            id = "Widest_" + this.state.src + "_" + this.state.dst;
            desc = "Widest path from node " + this.state.src + " to node " + this.state.dst;
        }
        var pathGroup = { id: id, desc: desc, pathList: pathList };
        this.setState({ pathGroup: pathGroup });
    },
    applyHandler: function applyHandler() {
        if (this.state.pathGroup) {
            this.props.pathCollectionAdd(this.state.pathGroup);
        }
        this.setState({ pathGroup: null });
    },
    textAreaValue: function textAreaValue() {
        if (!this.state.connected) {
            return "Cannot compute tree, Network is disconnected";
        }
        if (this.state.src === this.state.dst) {
            return "Source and destination must be different";
        }
        if (!this.state.src) {
            return "You must choose a source node";
        }
        if (this.state.pathGroup) {
            return JSON.stringify(this.state.pathGroup, null, 2);
        }
        return "";
    },
    render: function render() {
        var nodes = this.props.net.nodes.map(function (n) {
            return n.id;
        }).sort(); // Nodes as a array of strings
        var srcOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "src_" + nstr, value: nstr },
                nstr
            );
        });
        var destOptions = nodes.map(function (nstr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: "dst_" + nstr, value: nstr },
                nstr
            );
        });
        destOptions.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: '_ALL_', key: 'dst_ALL' },
            'All'
        ));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"],
            { show: this.props.open, onHide: this.props.close, dialogClassName: 'min-span-modal',
                dialogComponentClass: __WEBPACK_IMPORTED_MODULE_2__DraggableModal__["a" /* default */],
                enforceFocus: false, backdrop: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Header,
                { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Title,
                    null,
                    'Widest Paths'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Body,
                { style: { paddingBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Form"],
                    { horizontal: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormGroup"],
                        { controlId: 'srcDstNodes' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Source'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select', onChange: this.srcChange, value: this.state.src },
                                srcOptions
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 2 },
                            'Dest'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Col"],
                            { sm: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"],
                                { componentClass: 'select', onChange: this.dstChange, value: this.state.dst },
                                destOptions
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["FormControl"], { componentClass: 'textarea', readOnly: true,
                        value: this.textAreaValue(),
                        rows: 5, style: { resize: "none" } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Modal"].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { bsStyle: 'primary',
                        onClick: this.computeHandler, disabled: this.isError() },
                    'Compute '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                    { onClick: this.applyHandler },
                    'Apply'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["OverlayTrigger"],
                    { trigger: 'click', placement: 'top', overlay: this.helpPopover() },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["Button"],
                        { bsStyle: 'info' },
                        'Help'
                    )
                )
            )
        );
    }
});

var mapStateToProps = function mapStateToProps(state) {
    return {
        open: state.uiState.showWidePathModal,
        net: state.net,
        paths: state.paths
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        close: function close() {
            dispatch({ type: 'CLOSE_WIDE_PATH_DIALOG' });
        },
        pathCollectionAdd: function pathCollectionAdd(pathObj) {
            dispatch({ type: 'PATH_COLLECTION_ADD', pathObj: pathObj });
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(WidestPathDialog));

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = netAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__ = __webpack_require__(169);
/**
 * Created by Greg on 4/4/2016.
 */



function netAction() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NEW };
    var action = arguments[1];

    // First test for strange actions
    var myRegExp = /^[A-Za-z]/;
    if (!myRegExp.test(action.type)) {
        return state;
    }
    // console.log("In net action reducer, type: " + action.type);
    switch (action.type) {

        case 'UPDATE_LINK_CAPACITIES':
        case 'NODE_LINK_DEL':
        case 'CHANGE_NET':
        case 'LOAD_NET':
        case 'NEW_NET':
        case 'GOOD_NET_LOAD_CLOSE':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NEW };
        case 'DEMANDS_LOAD':
        case 'DEMANDS_CLEAR':
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
        case 'NET_NODE_ADD':
        case 'NET_LINK_ADD':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NET_CHANGE };
        case 'NODE_CLICK':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NODE_SELECT };
        case 'LINK_CLICK':
        case 'BULK_LINK_SELECT':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].LINK_SELECT };
        case 'PANEL_CLICK':
        case 'PRE_NET_NODE_ADD':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NODE_LINK_SELECT };
        case 'SHOW_DEMAND_CHANGE':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].SHOW_DEMANDS };
        case 'SHOW_CAP_CHANGE':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].SHOW_CAPACITY };
        case 'MODE_CHANGE':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].MODE_CHANGE };
        case 'NET_DRAW_RESIZE':
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NET_RESIZE };
        default:
            // In general we don't need to do anything for general UI stuff
            return { type: __WEBPACK_IMPORTED_MODULE_0__netDraw_NetDraw__["b" /* NET_ACTION */].NONE };
    }
}

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = netVisInteract;
/**
 * Created by Greg on 4/4/2016.
 */

var initialInteract = {
    mouseMode: "edit", showDemands: true,
    linkWidth: 2, demandWidth: 4,
    capVis: {
        showCap: true, minWidth: 4, maxWidth: 20, updateCap: 0
    },
    selectedNodes: [],
    selectedLinks: [],
    coords: { x: 0.0, y: 0.0 }, // Used when adding nodes
    linkInfo: { source: null, target: null, layer: null // Used when adding/editing links
    } };

function netVisInteract() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialInteract;
    var action = arguments[1];

    switch (action.type) {
        case 'NODE_LINK_DEL':
            return action.netVisInteract;
        case 'CHANGE_NET':
            return initialInteract;
        case 'LOAD_NET':
            return Object.assign({}, initialInteract, { mouseMode: "view" });
        case 'NEW_NET':
            return Object.assign({}, initialInteract, { mouseMode: "edit" });
        case 'NODE_CLICK':
            return nodeSelect(state, action.node);
        case 'LINK_CLICK':
            return linkSelect(state, action.link);
        case 'BULK_LINK_SELECT':
            return Object.assign({}, state, { selectedLinks: action.selectedLinks });
        case 'PANEL_CLICK':
        case 'PRE_NET_NODE_ADD':
            return netPanelClick(state, action.coords);
        case 'SHOW_DEMAND_CHANGE':
            return showDemandChange(state);
        case 'SHOW_CAP_CHANGE':
            return showCapacityChange(state);
        case 'MODE_CHANGE':
            return modeChange(state, action);
        case 'PRE_NET_LINK_ADD':
            return Object.assign({}, state, { linkInfo: action.linkInfo, selectedNodes: [], selectedLinks: [] });
        case 'PRE_LINK_EDIT':
            return Object.assign({}, state, { linkInfo: action.link, selectedNodes: [], selectedLinks: [] });
        case 'PRE_NODE_EDIT':
            return Object.assign({}, state, { selectedNodes: [action.node.id], selectedLinks: [] });
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
            return Object.assign({}, state, { selectedNodes: [], selectedLinks: [] });
        default:
            return state;
    }
}

/**
 * Handles raw click events on network nodes, i.e., controls their selection
 * and any further actions depending on editor state.
 * @method nodeSelect
 * @param nodeInfo
 */
function nodeSelect(state, nodeInfo) {
    // console.log("in nodeSelect node: " + nodeInfo.id);
    var nodeId = nodeInfo.id;
    var selectedNodes = state.selectedNodes;
    var stateUpdate = Object.assign({}, state);

    if (selectedNodes.indexOf(nodeId) !== -1) {
        stateUpdate.selectedNodes = selectedNodes.filter(function (n) {
            return n !== nodeId;
        });
    } else {
        stateUpdate.selectedNodes = selectedNodes.concat(nodeId);
    }
    // Check for consistency
    if (state.mouseMode === 'edit' && stateUpdate.selectedNodes.length >= 2) {
        stateUpdate.selectedNodes = [];
    }
    return stateUpdate;
}

function linkSelect(state, linkInfo) {
    // console.log("in linkSelect");
    var linkId = [linkInfo.source, linkInfo.target];
    var selectedLinks = state.selectedLinks;
    var stateUpdate = Object.assign({}, state);
    var link = selectedLinks.find(function (sl) {
        return sl[0] === linkInfo.source && sl[1] === linkInfo.target;
    });
    if (link) {
        stateUpdate.selectedLinks = selectedLinks.filter(function (sl) {
            return sl[0] !== linkInfo.source || sl[1] !== linkInfo.target;
        });
    } else {
        stateUpdate.selectedLinks = selectedLinks.concat([linkId]);
    }
    return stateUpdate;
}

function netPanelClick(state, coords) {
    // console.log("Panel click at x: " + coords.x.toPrecision(4) + " y: " + coords.y.toPrecision(4))
    // Clear any selected nodes or links
    var stateUpdate = Object.assign({}, state);
    stateUpdate.selectedLinks = [];
    stateUpdate.selectedNodes = [];
    stateUpdate.coords = coords;
    return stateUpdate;
}

function showDemandChange(state) {
    // console.log("In Change handler for demands");
    var stateUpdate = Object.assign({}, state);
    stateUpdate.showDemands = !state.showDemands;
    return stateUpdate;
}

function showCapacityChange(state) {
    // console.log("Change handler for capacity");
    var stateUpdate = Object.assign({}, state);
    stateUpdate.capVis.showCap = !state.capVis.showCap;
    return stateUpdate;
}

function modeChange(state, action) {
    return Object.assign({}, state, { mouseMode: action.mouseMode,
        selectedNodes: [], selectedLinks: [] });
}

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = net;
/**
 * Created by Greg on 4/4/2016.
 */
// import {netValidate} from './../../validation/netValid';
// import * as myNet from '../../netSamples/ExNetwithLoops1B.json';

var initialNet = { nodes: [], links: [], graph: { name: "", desc: "" }, directed: false, multigraph: false };
//netValidate(JSON.stringify(myNet)).netObj;

function net() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialNet;
    var action = arguments[1];

    switch (action.type) {
        case 'NET_LINK_EDIT':
        case 'NET_NODE_EDIT':
        case 'UPDATE_LINK_CAPACITIES':
        case 'UPDATE_LINK_WEIGHTS':
        case 'UPDATE_PORT_NUMBERS':
        case 'IPV4_ADDRESS_UPDATE':
        case 'NODE_LINK_DEL':
        case 'CHANGE_NET':
        case 'LOAD_NET':
            return Object.assign({}, action.net);
        case 'NET_NODE_ADD':
            return Object.assign({}, state, { nodes: state.nodes.concat(action.node) });
        case 'NET_LINK_ADD':
            return Object.assign({}, state, { links: state.links.concat(action.link) });
        case 'NEW_NET':
            return { nodes: [], links: [], graph: { name: "", desc: "" }, directed: false, multigraph: false };
        case 'NAME_DESC_CHANGE':
            return Object.assign({}, state, { graph: { name: action.name, desc: action.desc } });
        default:
            return state;
    }
};

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__netInteractReducer__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__netReducer__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__netActionReducer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uiStateReducer__ = __webpack_require__(342);
/**
 * Created by Greg on 4/1/2016. No Joke.
 */







/*
 My application state looks something like this
 */
// export const initialState = {
//     net: netValidate(JSON.stringify(smallExNet)).netObj,
//     demands: {id: null, desc: null, demandList: []},
//     paths: [],  // a list of path collections of the form: {id: null, desc: null, pathList: []}
//     netAction: {type: NET_ACTION.NEW},
//     netVisInteract: {
//         mouseMode: "view", showDemands: true,
//         linkWidth: 2, demandWidth: 4,
//         capVis: {
//             showCap: true, minWidth: 4, maxWidth: 20, updateCap: 0
//         },
//         selectedNodes: [],
//         selectedLinks: [],
//     },
//     uiState: { // We need to keep track of lots of dialogs here
//         showComputeServeModal: false
//     }
//     compServe: { namePort }
// };

function compServe() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { namePort: "localhost:1517" };
    var action = arguments[1];

    switch (action.type) {
        case 'ASSIGN_SERVER':
            return { namePort: action.namePort };
        default:
            return state;
    }
}

function demands() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { id: null, desc: null, demandList: [] };
    var action = arguments[1];

    switch (action.type) {
        case 'DEMANDS_LOAD':
            return action.demandObj;
        case 'DEMANDS_CLEAR':
            return { id: null, desc: null, demandList: [] };
        default:
            return state;
    }
}

function paths() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case 'PATH_COLLECTION_ADD':
            return state.concat([action.pathObj]);
        case 'PATHS_UPDATE':
            return action.paths;
        default:
            return state;
    }
}

var netVizApp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    net: __WEBPACK_IMPORTED_MODULE_2__netReducer__["a" /* default */], demands: demands, paths: paths, netAction: __WEBPACK_IMPORTED_MODULE_3__netActionReducer__["a" /* default */], netVisInteract: __WEBPACK_IMPORTED_MODULE_1__netInteractReducer__["a" /* default */], uiState: __WEBPACK_IMPORTED_MODULE_4__uiStateReducer__["a" /* default */], compServe: compServe
});

/* harmony default export */ __webpack_exports__["a"] = (netVizApp);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uiState;
/**
 * Created by Greg on 4/4/2016.
 */

var initialUIState = { // We need to keep track of lots of dialogs here
    showComputeServeModal: false,
    showNetLoadModal: false,
    showNodeAddModal: false,
    showNodeEditModal: false,
    showLinkAddModal: false,
    showLinkEditModal: false,
    showNetExportModal: false,
    showIPAddressModal: false,
    showPortNumberModal: false,
    showDistanceWeightsModal: false,
    showRandomCapsModal: false,
    showShortPathModal: false,
    showWidePathModal: false,
    showMinTreeModal: false,
    showNetInfo: false,
    showPathInfo: false,
    showHelp: true,
    showPathLoadModal: false,
    showDemandLoadModal: false,
    showKShortPathsModal: false
};

function uiState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialUIState;
    var action = arguments[1];

    switch (action.type) {
        case 'CLOSE_RAND_CAP_DIALOG':
            return Object.assign({}, state, { showRandomCapsModal: false });
        case 'SHOW_RAND_CAP_DIALOG':
            return Object.assign({}, state, { showRandomCapsModal: true });
        case 'CLOSE_DIST_WEIGHT_DIALOG':
            return Object.assign({}, state, { showDistanceWeightsModal: false });
        case 'SHOW_DIST_WEIGHT_DIALOG':
            return Object.assign({}, state, { showDistanceWeightsModal: true });
        case 'CLOSE_PORT_NUMBER_DIALOG':
            return Object.assign({}, state, { showPortNumberModal: false });
        case 'SHOW_PORT_NUMBER_DIALOG':
            return Object.assign({}, state, { showPortNumberModal: true });
        case 'CLOSE_IP_ADDRESS_DIALOG':
            return Object.assign({}, state, { showIPAddressModal: false });
        case 'SHOW_IP_ADDRESS_DIALOG':
            return Object.assign({}, state, { showIPAddressModal: true });
        case 'SHOW_COMPUTE_SERVE_DIALOG':
            return Object.assign({}, state, { showComputeServeModal: true });
        case 'CLOSE_COMPUTE_SERVE_DIALOG':
            return Object.assign({}, state, { showComputeServeModal: false });
        case 'SHOW_NET_LOAD_DIALOG':
            return Object.assign({}, state, { showNetLoadModal: true });
        case 'SHOW_NET_EXPORT_DIALOG':
            return Object.assign({}, state, { showNetExportModal: true });
        case 'CLOSE_NET_EXPORT_DIALOG':
            return Object.assign({}, state, { showNetExportModal: false });
        case 'PRE_NET_NODE_ADD':
            return Object.assign({}, state, { showNodeAddModal: true });
        case 'NET_NODE_ADD':
        case 'CLOSE_NODE_ADD_DIALOG':
            return Object.assign({}, state, { showNodeAddModal: false });
        case 'CLOSE_NET_LOAD_DIALOG':
        case 'GOOD_NET_LOAD_CLOSE':
            return Object.assign({}, state, { showNetLoadModal: false });
        case 'PRE_NET_LINK_ADD':
            return Object.assign({}, state, { showLinkAddModal: true });
        case 'CLOSE_LINK_ADD_DIALOG':
        case 'NET_LINK_ADD':
            return Object.assign({}, state, { showLinkAddModal: false });
        case 'NET_NODE_EDIT':
        case 'CLOSE_NODE_EDIT_DIALOG':
            return Object.assign({}, state, { showNodeEditModal: false });
        case 'PRE_NODE_EDIT':
            return Object.assign({}, state, { showNodeEditModal: true });
        case 'NET_LINK_EDIT':
        case 'CLOSE_LINK_EDIT_DIALOG':
            return Object.assign({}, state, { showLinkEditModal: false });
        case 'PRE_LINK_EDIT':
            return Object.assign({}, state, { showLinkEditModal: true });
        case 'SHOW_HELP':
            return Object.assign({}, state, { showHelp: action.flag });
        case 'SHOW_NET_INFO':
            return Object.assign({}, state, { showNetInfo: action.flag });
        case 'SHOW_PATH_INFO':
            return Object.assign({}, state, { showPathInfo: action.flag });
        case 'CLOSE_MIN_TREE_DIALOG':
            return Object.assign({}, state, { showMinTreeModal: false });
        case 'SHOW_MIN_TREE_DIALOG':
            return Object.assign({}, state, { showMinTreeModal: true });
        case 'CLOSE_SHORT_PATH_DIALOG':
            return Object.assign({}, state, { showShortPathModal: false });
        case 'SHOW_SHORT_PATH_DIALOG':
            return Object.assign({}, state, { showShortPathModal: true });
        case 'CLOSE_WIDE_PATH_DIALOG':
            return Object.assign({}, state, { showWidePathModal: false });
        case 'SHOW_WIDE_PATH_DIALOG':
            return Object.assign({}, state, { showWidePathModal: true });
        case 'CLOSE_PATH_LOAD_DIALOG':
            return Object.assign({}, state, { showPathLoadModal: false });
        case 'SHOW_PATH_LOAD_DIALOG':
            return Object.assign({}, state, { showPathLoadModal: true });
        case 'CLOSE_DEMAND_LOAD_DIALOG':
            return Object.assign({}, state, { showDemandLoadModal: false });
        case 'SHOW_DEMAND_LOAD_DIALOG':
            return Object.assign({}, state, { showDemandLoadModal: true });
        case 'CLOSE_KSHORT_PATHS_DIALOG':
            return Object.assign({}, state, { showKShortPathsModal: false });
        case 'SHOW_KSHORT_PATHS_DIALOG':
            return Object.assign({}, state, { showKShortPathsModal: true });
        default:
            return state;
    }
}

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(56)();
// imports


// module
exports.push([module.i, ".react-bs-table-container .react-bs-table-search-form{margin-bottom:0}.react-bs-table{border:1px solid #ddd;border-radius:5px}.react-bs-table table{margin-bottom:0;table-layout:fixed}.react-bs-table table td,.react-bs-table table th{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.react-bs-table{margin:5px 10px}.react-bs-table-pagination{margin:10px}.react-bs-table-tool-bar{margin:10px 10px 0}.react-bs-container-header{overflow:hidden;width:100%}.react-bs-container-body{overflow:auto;width:100%}.react-bs-table .table-bordered{border:0}.react-bs-table .table-bordered>thead>tr>td,.react-bs-table .table-bordered>thead>tr>th{border-bottom-width:2px}.react-bs-table .table-bordered>tfoot>tr>td,.react-bs-table .table-bordered>tfoot>tr>th{border-top-width:2px;border-bottom-width:0}.react-bs-table .table-bordered>tbody>tr>td:first-child,.react-bs-table .table-bordered>tbody>tr>th:first-child,.react-bs-table .table-bordered>tfoot>tr>td:first-child,.react-bs-table .table-bordered>tfoot>tr>th:first-child,.react-bs-table .table-bordered>thead>tr>td:first-child,.react-bs-table .table-bordered>thead>tr>th:first-child{border-left-width:0}.react-bs-table .table-bordered>tbody>tr>td:last-child,.react-bs-table .table-bordered>tbody>tr>th:last-child,.react-bs-table .table-bordered>tfoot>tr>td:last-child,.react-bs-table .table-bordered>tfoot>tr>th:last-child,.react-bs-table .table-bordered>thead>tr>td:last-child,.react-bs-table .table-bordered>thead>tr>th:last-child{border-right-width:0}.react-bs-table .table-bordered>thead>tr:first-child>td,.react-bs-table .table-bordered>thead>tr:first-child>th{border-top-width:0}.react-bs-table .table-bordered>tfoot>tr:last-child>td,.react-bs-table .table-bordered>tfoot>tr:last-child>th{border-bottom-width:0}.react-bs-table .react-bs-container-header>table>thead>tr>th{vertical-align:middle}.react-bs-table .react-bs-container-header>table>thead>tr>th .filter{font-weight:400}.react-bs-table .react-bs-container-header>table>thead>tr>th .filter::-webkit-input-placeholder,.react-bs-table .react-bs-container-header>table>thead>tr>th .number-filter-input::-webkit-input-placeholder,.react-bs-table .react-bs-container-header>table>thead>tr>th .select-filter.placeholder-selected,.react-bs-table .react-bs-container-header>table>thead>tr>th .select-filter option[value=\"\"]{color:#d3d3d3;font-style:italic}.react-bs-table .react-bs-container-header>table>thead>tr>th .select-filter.placeholder-selected option:not([value=\"\"]){color:initial;font-style:normal}.react-bs-table .react-bs-container-header>table>thead>tr>th .date-filter,.react-bs-table .react-bs-container-header>table>thead>tr>th .number-filter{display:flex}.react-bs-table .react-bs-container-header>table>thead>tr>th .date-filter-input,.react-bs-table .react-bs-container-header>table>thead>tr>th .number-filter-input{margin-left:5px;float:left;width:calc(100% - 67px - 5px)}.react-bs-table .react-bs-container-header>table>thead>tr>th .date-filter-comparator,.react-bs-table .react-bs-container-header>table>thead>tr>th .number-filter-comparator{width:67px;float:left}.react-bs-table .react-bs-container-header .sort-column{cursor:pointer}.react-bs-container .textarea-save-btn{position:absolute;z-index:100;right:0;top:-21px}.react-bs-table-no-data{text-align:center}.animated{animation-fill-mode:both}.animated.bounceIn,.animated.bounceOut{animation-duration:.75s}.animated.shake{animation-duration:.3s}@keyframes shake{0%,to{transform:translateZ(0)}10%,50%,90%{transform:translate3d(-10px,0,0)}30%,70%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes bounceIn{0%,20%,40%,60%,80%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-name:bounceIn}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-name:bounceOut}", ""]);

// exports


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(56)();
// imports


// module
exports.push([module.i, ".react-grid-layout{position:relative;transition:height .2s ease}.react-grid-item{transition:all .2s ease;transition-property:left,top}.react-grid-item.cssTransforms{transition-property:transform}.react-grid-item.resizing{z-index:1}.react-grid-item.react-draggable-dragging{transition:none;z-index:3}.react-grid-item.react-grid-placeholder{background:red;opacity:.2;transition-duration:.1s;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.react-grid-item>.react-resizable-handle{position:absolute;width:20px;height:20px;bottom:0;right:0;background:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=\");background-position:100% 100%;padding:0 3px 3px 0;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;cursor:se-resize}", ""]);

// exports


/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(56)();
// imports


// module
exports.push([module.i, ".react-resizable{position:relative}.react-resizable-handle{position:absolute;width:20px;height:20px;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+\");background-position:100% 100%;padding:0 3px 3px 0}.react-resizable-handle-sw{bottom:0;left:0;cursor:sw-resize;transform:rotate(90deg)}.react-resizable-handle-se{bottom:0;right:0;cursor:se-resize}.react-resizable-handle-nw{top:0;left:0;cursor:nw-resize;transform:rotate(180deg)}.react-resizable-handle-ne{top:0;right:0;cursor:ne-resize;transform:rotate(270deg)}.react-resizable-handle-e,.react-resizable-handle-w{top:50%;margin-top:-10px;cursor:ew-resize}.react-resizable-handle-w{left:0;transform:rotate(135deg)}.react-resizable-handle-e{right:0;transform:rotate(315deg)}.react-resizable-handle-n,.react-resizable-handle-s{left:50%;margin-left:-10px;cursor:ns-resize}.react-resizable-handle-n{top:0;transform:rotate(225deg)}.react-resizable-handle-s{bottom:0;transform:rotate(45deg)}", ""]);

// exports


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(56)();
// imports


// module
exports.push([module.i, "#HelpContents h1{font-size:30px}#HelpContents h2{font-size:24px}a.navbar-brand{width:195px}nav.navbar.navbar-static-top{position:relative;z-index:0}nav.navbar.navbar-static-top:hover{position:relative;z-index:5}a.navbar-brand img{position:absolute;z-index:-100;top:0;left:0;background-color:#fff;margin-right:10px;padding:3px;border-bottom-color:#d4d4d4;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom-style:solid;border-bottom-width:1px;border-right-color:#d4d4d4;border-right-style:solid;border-right-width:1px;box-shadow:0 1px 4px rgba(0,0,0,.067);width:199px;height:auto}#DemandIdLabel{margin-top:10px;margin-left:10px}#PathInfo .react-bs-table{margin:5px 0}.nonCompatible{background:repeating-linear-gradient(45deg,transparent,transparent 10px,hsla(320,1%,45%,.15) 0,hsla(320,1%,45%,.15) 20px)}#DrawPanel{overflow:hidden}#fileInput,#pathFileInput{display:none}.react-bs-table table td.multiLineTableEntry,.react-bs-table table th.multiLineTableEntry{white-space:normal}.add-node-net-modal,.comp-serve-modal,.dist-wt-modal,.ipv4-addr-modal,.min-span-modal,.port-num-modal,.rand-cap-modal{width:400px}#PortNumberHelpPopover{max-width:450px}.add-node-net-modal .modal-body{padding:5px 30px}.add-node-net-modal .row{margin-bottom:10px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{line-height:1;font-size:12px}img.navbar-brand{padding:5px 0}.node_shape.switch{stroke:blue;stroke-width:2px;fill:#efefef}.highlight .node_shape.switch{stroke:red;fill:#fff}.node_shape.switch.layerE{stroke:blue;stroke-width:2px;fill:#d9ef39}.highlight .node_shape.switch.layerE{stroke:red;fill:#fff}.node_shape.switch.layerW{stroke:#922828;stroke-width:2px;fill:#fce886}.highlight .node_shape.switch.layerW{stroke:red;fill:#fff}.node_shape.data_center{stroke:maroon;stroke-width:2px;fill:#fffcd0}.highlight .node_shape.data_center{stroke:red;fill:#fff}.node_shape.user_region{stroke:#000;stroke-width:2px;fill:#d7fff3}.highlight .node_shape.user_region{stroke:red;fill:#fff}.node_shape.host{stroke:maroon;stroke-width:2px;fill:#fffcd0}.highlight .node_shape.host{stroke:red;fill:#fff}line.netDemand{stroke:hsla(0,0%,50%,.51);stroke-width:4px}line.netDemand.hidden{stroke:hsla(0,0%,50%,0);stroke-width:4px}line.netLink{stroke:green;stroke-width:3px}line.netLink.highlight{stroke:red}line.netLink.ether{stroke:#317280}line.netLink.ether.highlight{stroke:red}line.netLink.wavelength{stroke:#802818}line.netLink.wavelength.highlight{stroke:red}line.netLink.adaptation{stroke:rgba(17,5,3,.91);stroke-dasharray:10,5;opacity:.5}line.netLink.adaptation.highlight{stroke:red}text.node_label{font-size:12px;font-family:sans-serif}line.demand{stroke:grey;stroke-width:5px;stroke-opacity:.2}#infoDialog{font-size:smaller}div.ui-dialog div.ui-dialog-titlebar{padding-top:.3em;padding-bottom:.1em}.ui-dialog .ui-dialog-title{margin-top:0;margin-bottom:0}", ""]);

// exports


/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports = "<h1 id=overview>Overview</h1> <p><strong>ComNetVis</strong> is a single page web application designed to help students and researchers model and visualize <em>communications</em> networks and related concepts such as network paths, forwarding trees, and network demands.</p> <p>ComNetVis supports the import/export of JSON strings or files that represent networks, collections of paths, and network demands. ComNetVis is a stand alone HTML/Javascript application <em>none of your information is saved or sent to our server!</em> You must save any network models or path collections you want to keep into a plain text file on your computer.</p> <p>Questions/Comments/Bugs: Send an email to <a href=mailto:gregb@grotto-networking.com>mailto:gregb@grotto-networking.com</a>.</p> <h1 id=working-with-networks>Working with Networks</h1> <p>We use a highly portable and extensible JSON format to model networks. This format has <strong>changed</strong> from the 1.0.x version of this software to the 1.1.x version. The model versions are documented <a href=../NetworkGraphVisualization.html#jsonNetwork target=_blank>here</a> along with Python based format conversion utilities. <em>ComNetViz</em> currently works with one network model at a time.</p> <p>To work with a network you can:</p> <ul> <li>Use the <code>Net/LoadNetwork</code> menu item to import a JSON string.</li> <li>Use the <code>Net/Open Net File</code> menu item to open a file containing a JSON network model that you've previously saved.</li> <li>Use the <code>Net/Example Networks</code> submenu to load one of our examples.</li> <li>Use the <code>Net/New Network</code> menu item to start editing with a new empty network.</li> </ul> <p>By default when you load or open a network file the application will be in <em>view</em> mode. If you create a new network the application will be in <em>edit</em> mode. To change the mode use the <code>Mode</code> menu.</p> <p>If you create or edit a network with this app you <em>need to save it on your computer</em>. This can be done by clicking on the <code>Net/Export Network</code> menu item. This will bring up a dialog that contains the JSON representation of the current network model. You need to copy this text and save it in order to preserve your work! If you save this text to a plain text file you can later open it with the <code>Net/Open Net File</code> menu item.</p> <h2 id=network-information>Network Information</h2> <p>The <code>Net/Info</code> menu item brings up a panel (that is usually displayed) that shows information on the network links, nodes, general properties, and demands (if any have been loaded). You can close this panel and reopen it at any time. Other panels such as this <em>Help panel</em> may push the <em>network info panel</em> out of view so scroll down if you don't see it.</p> <h2 id=network-editing>Network Editing</h2> <p>When you initially open the app web page you will start with an empty network model in the <code>edit</code> mode which allows you to add nodes and links and alter their properties. If your starting from an existing network model that you have loaded you need to check the <code>Mode/Edit</code> radio button to enable editing.</p> <p>To add a <strong>node</strong> <em>left click</em> on a portion of the drawing area where there isn't already a node.</p> <p>To <strong>move</strong> a node left click and drag it.</p> <p>To add a <strong>link</strong> between two nodes left click to select the first node, then left click to select the second node. You can unselect a link or node with another left click.</p> <p>To <strong>delete</strong> a link or node: first select the node or link by left clicking on it. Once selected press the <em>delete key</em>.</p> <p>To <strong>change</strong> the properties of an existing link or node: <em>double click</em> on the link or node.</p> <p>To change or give a network a <em>name</em> and <em>description</em> go to the <em>network information panel's</em> <strong>General Info</strong> tab (in <em>edit</em> mode). Don't forget to hit the <em>apply changes</em> button.</p> <h2 id=additional-network-editing-functionality>Additional Network Editing Functionality</h2> <p>The following commands can be used to modify your network model. They are not reversible, i.e., there is <strong>no undo</strong> so save your work as necessary.</p> <ul> <li><p>To assign IPv4/MAC addresses to some or all the nodes click the <code>Net/IP/MAC Address</code> menu item.</p></li> <li><p>To assign port numbers to each end of a link in the network click on the <code>Net/Port Numbers</code> menu item.</p></li> <li><p>To assign <em>weights</em> to links that are proportional to the actual distance between nodes click on the <code>Net/Distance based Weights</code> menu item.</p></li> <li><p>To assign random capacities (or the same capacity) to all links click on the <code>Randomize Capacities</code> menu item.</p></li> </ul> <h1 id=paths>Paths</h1> <p>We deal with paths in groups where each group can have a name and a description and can contain one or more paths. For example a path group might contain all the shortest paths from a particular node to every other node in the network, or a path group could contain a single widest path between two nodes in a network.</p> <p><em>ComNetViz</em> can work with multiple path groups at a time which is useful when comparing paths generated by different algorithms. The JSON format for paths we use is extensible and is documented <a href=../NetworkGraphVisualization.html#jsonPath target=_blank>here</a>.</p> <p>To see information on the paths groups currently loaded in the application use the <code>Path/Path Info</code> menu item to bring up the <strong>path info panel</strong>. From this panel you can:</p> <ul> <li><strong>Manage Path Groups</strong>: get information on currently loaded path groups including name, description, number of paths and number of compatible paths. Remove or export selected path groups.</li> <li><strong>All Paths</strong>: See a table of all paths currently loaded. Selecting a path in this table will display it highlighted on the network.</li> <li><strong>Specific Group</strong>: Choose a specific path group to show in tabular form. Selecting a path from this table will display it highlighted on the network.</li> </ul> <h2 id=loadingcomputing-paths>Loading/Computing Paths</h2> <p>There are multiple ways to add a path group to <em>ComNetViz</em>:</p> <ul> <li>Load a JSON string describing a group of paths using the <code>Path/Load Paths</code> menu item.</li> <li>Open a JSON file contain a description of a group of paths with the <code>Path/Open Path File</code> menu item.</li> <li>Shortest Paths Computation: Have <em>ComNetViz</em> compute the shortest path between two nodes or between a given node and all other nodes in the network and put the results into a JSON path group that you can save and/or add to the application.</li> <li>Widest Paths Computation: Have <em>ComNetViz</em> compute the <strong>widest</strong> path between two nodes or between a given node and all other nodes in the network and put the results into a JSON path group that you can save and/or add to the application. This is a bit different from what one usually encounters in classes that cover routing protocols!</li> <li>Minimum weight Spanning Tree Computation: <em>ComNetViz</em> can compute the minimum weight spanning tree for the network and return the tree links as a set of individual paths within a path group. This allows for easy tree visualization with the existing path capabilities of <em>ComNetViz</em>.</li> </ul> <p><em>Note</em> the aforementioned computations performed by <em>ComNetViz</em> can only be applied to <em>connected</em> networks.</p> <h1 id=demands>Demands</h1> <p><em>ComNetViz</em> can aid you in visualizing <em>demands</em> place on a network. <em>Demands</em> are an amount of flow between two nodes and <em>ComNetViz</em> will display these as a special kind of link. You can load demands into the application with the <code>Net/Load Demands</code> menu item. The JSON format for network demands and paths we use is extensible and is documented <a href=../NetworkGraphVisualization.html#jsonDemand target=_blank>here</a>.</p> <p><em>ComNetViz</em> allows you to work with one set of demands at a time. If demands are present in the application a tab containing a table of demands will appear in the <em>network info panel</em>. An individual <em>demand</em> is considered <em>incompatible</em> with the network if either its source or destination node is not in the network. Incompatible demands are shown with a special background in the demand table and cannot be displayed on the network drawing.</p> <h1 id=network-visualization>Network Visualization</h1> <h2 id=pan-and-zoom>Pan and Zoom</h2> <p>To <strong>pan</strong> the network graph left click and drag on the graph background (not on a node). To <strong>zoom</strong> the network graph use either your scroll wheel or appropriate &quot;touch pad gesture&quot; - on my laptop two fingers swiped vertically - with the mouse pointer over the drawing area.</p> <h2 id=node-link-path-and-demand-information>Node, Link, Path, and Demand Information</h2> <p>Click on the <code>Net/Info</code> menu item to bring up a panel with tables of nodes and links in the network. In addition, this dialog will also show any demands that have been loaded.</p> <h2 id=display-options>Display Options</h2> <p>Currently there are options for displaying or hiding network demands (if these are specified) and for representing link capacities in terms of line thickness.</p> <p><strong>Tip:</strong> displaying demands may make it hard or impossible to select nodes or links. If this happens just disable the display of demands while you edit the graph and re-enable the display of demands when you are done editing.</p> <h1 id=computation-server>Computation Server</h1> <p>Although <strong>none</strong> of your information is sent to our server, you can configure a compute server to perform various network related computations for you. We provide an example server implemented in Python that can compute the <em>k-shortest paths</em> between two nodes (thanks to the folks at <a href=https://networkx.github.io/ target=_blank>NetworkX</a>):</p> <p>If you want to use this functionality you can get the Python file and instructions at <a href=../NetworkGraphVisualization.html#a-simple-computation-server target=_blank>simple compute server</a>. You will be running this on your computer not our sever. The results of this computation is returned as a list of paths (path group) that can be applied to the network and viewed via the paths panel.</p> ";

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(361);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(70)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./react-bootstrap-table.css", function() {
			var newContent = require("!!../../css-loader/index.js!./react-bootstrap-table.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(362);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(70)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(363);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(70)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return basicDijkstra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return widestDijkstra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return minSpanTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return linkParm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return depthFirstConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPaths; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Going to try implementing some basic path computation algorithms in
 * Javascript to package with the app. No effort will be made to optimize these
 * algorithms.  I'll be mostly translating from some simple Python implementations.
 *
 * Created by Greg on 5/1/2016.
 */

// TEST CODE:
// import * as medExNet from '../netSamples/KShortTest2Net.json';
// import {netValidate} from './netValid';
// var testNet = netValidate(JSON.stringify(medExNet)).netObj;
// console.log("Path compute test");
// var result = basicDijkstra(testNet, "A4");
// console.log(result.distance);
// console.log(result.previous);
// console.log(getPaths("A4", result.previous, testNet));
// console.log(getPath("A4", "B9", result.previous, testNet));
// var result2 = widestDijkstra(testNet, "B9");
// console.log(result2.capacities);
// console.log(result.previous);
// console.log(getPaths("B9", result2.previous, testNet));
// console.log(getPath("B9", "C29", result2.previous, testNet));
// var tree1 = minSpanTree(testNet);
// console.log(tree1);

/*
    We'll work with string node IDs and such...
 */
function basicDijkstra(net, src) {
    var wt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "weight";

    var previous = new Map(); //   previous hops
    var T = new Set();
    var V = new Set(net.nodes.map(function (n) {
        return n.id;
    })); // Initially set of all nodes
    T.add(src);
    V.delete(src);
    var distance = new Map(); // distance between nodes
    distance.set(src, 0.0);
    // Initialize distances
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = V[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _v2 = _step.value;

            if (hasEdge(net, src, _v2)) {
                distance.set(_v2, linkParm(net, src, _v2, wt));
                previous.set(_v2, src);
            } else {
                distance.set(_v2, Infinity);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    while (V.size > 0) {
        // Find the node with the smallest distance in the set V
        var smallDist = Infinity;
        var u = null; // Smallest distance node
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = V[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var v = _step2.value;

                if (distance.get(v) <= smallDist) {
                    smallDist = distance.get(v);
                    u = v;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        T.add(u);
        V.delete(u);
        // update distances
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = V[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _v = _step3.value;

                if (hasEdge(net, u, _v)) {
                    if (distance.get(_v) > distance.get(u) + linkParm(net, u, _v, wt)) {
                        distance.set(_v, distance.get(u) + linkParm(net, u, _v, wt));
                        previous.set(_v, u);
                    }
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
    return { distance: distance, previous: previous };
}

function widestDijkstra(net, src) {
    var bw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "capacity";

    var previous = new Map(); //   previous hops
    var T = new Set();
    var V = new Set(net.nodes.map(function (n) {
        return n.id;
    })); // Initially set of all nodes
    T.add(src);
    V.delete(src);
    var cap = new Map(); // capacities between nodes
    cap.set(src, Infinity);
    // Initialize capacity
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = V[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _v4 = _step4.value;

            if (hasEdge(net, src, _v4)) {
                cap.set(_v4, linkParm(net, src, _v4, bw));
                previous.set(_v4, src);
            } else {
                cap.set(_v4, 0.0);
            }
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    while (V.size > 0) {
        // Find the node with the maximum capacity in the set V
        var maxCap = 0.0;
        var u = null; // Max cap node
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = V[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var v = _step5.value;

                if (cap.get(v) >= maxCap) {
                    maxCap = cap.get(v);
                    u = v;
                }
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        T.add(u);
        V.delete(u);
        // update capacities
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = V[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _v3 = _step6.value;

                if (hasEdge(net, u, _v3)) {
                    if (cap.get(_v3) < Math.min(cap.get(u), linkParm(net, u, _v3, bw))) {
                        cap.set(_v3, Math.min(cap.get(u), linkParm(net, u, _v3, bw)));
                        previous.set(_v3, u);
                    }
                }
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }
    }
    return { capacities: cap, previous: previous };
}

/*
    Based on Prim's algorithm as described on page 41 of Gibbons "Algorithmic
    Graph Theory".
    Or just as good see https://en.wikipedia.org/wiki/Prim's_algorithm
 */
function minSpanTree(net) {
    var wt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "weight";

    var tree = [];
    var Vprime = new Set();
    var V = new Set(net.nodes.map(function (n) {
        return n.id;
    })); // Initially set of all nodes
    var u = net.nodes[0].id; // We can use any node to start
    V.delete(u);
    Vprime.add(u);
    // Initialize labels
    var label = new Map();
    var connLink = new Map(); // Used to keep track of which links connects this node to tree
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
        for (var _iterator7 = V[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _v6 = _step7.value;

            if (hasEdge(net, u, _v6)) {
                label.set(_v6, linkParm(net, u, _v6, wt));
                connLink.set(_v6, [u, _v6]);
            } else {
                label.set(_v6, Infinity);
                connLink.set(_v6, null);
            }
        }
    } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
            }
        } finally {
            if (_didIteratorError7) {
                throw _iteratorError7;
            }
        }
    }

    while (V.size > 0) {
        var smallDist = Infinity;
        u = null; // Smallest label node
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = V[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var v = _step8.value;

                if (label.get(v) < smallDist) {
                    smallDist = label.get(v);
                    u = v;
                }
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        tree.push(connLink.get(u));
        V.delete(u);
        Vprime.add(u);
        // Update labels and connecting links
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
            for (var _iterator9 = V[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var _v5 = _step9.value;

                if (hasEdge(net, _v5, u)) {
                    if (linkParm(net, _v5, u, wt) < label.get(_v5)) {
                        label.set(_v5, linkParm(net, _v5, u, wt));
                        connLink.set(_v5, [_v5, u]);
                    }
                }
            }
        } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                }
            } finally {
                if (_didIteratorError9) {
                    throw _iteratorError9;
                }
            }
        }
    }
    return tree;
}

// Get's a nice list of path objects from a previous hop map.
function getPaths(s, previous, net) {
    var wt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "weight";
    var cap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "capacity";

    var pathList = [];
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
        for (var _iterator10 = previous.keys()[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var t = _step10.value;

            var pathObj = {};
            var nodeList = [];
            if (t !== s) {
                var v = t;
                var cost = 0.0;
                var capacity = Infinity;
                while (v !== s) {
                    nodeList.push(v);
                    var v_old = v;
                    v = previous.get(v);
                    cost += linkParm(net, v, v_old, wt);
                    capacity = Math.min(capacity, linkParm(net, v, v_old, cap));
                }
                nodeList.push(s);
                nodeList.reverse();
                pathObj = { cost: cost, capacity: capacity, nodeList: nodeList };
                pathList.push(pathObj);
            }
        }
    } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
            }
        } finally {
            if (_didIteratorError10) {
                throw _iteratorError10;
            }
        }
    }

    return pathList;
}

// Get's a single path object between s and t based on a previous hop map.
function getPath(s, t, previous, net) {
    var wt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "weight";
    var cap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "capacity";

    var pathObj = {};
    var nodeList = [];
    if (t !== s) {
        var v = t;
        var cost = 0.0;
        var capacity = Infinity;
        while (v !== s) {
            nodeList.push(v);
            var v_old = v;
            v = previous.get(v);
            cost += linkParm(net, v, v_old, wt);
            capacity = Math.min(capacity, linkParm(net, v, v_old, cap));
        }
        nodeList.push(s);
        nodeList.reverse();
        pathObj = { cost: cost, capacity: capacity, nodeList: nodeList };
    }
    return pathObj;
}

function hasEdge(net, s, v) {
    var links = net.links;
    if (links.find(function (l) {
        return l.source === s && l.target === v;
    })) {
        return true;
    }
    if (links.find(function (l) {
        return l.source === v && l.target === s;
    })) {
        return true;
    }
    return false;
}

/*
    Returns the value of the parameter "parm" for the link between nodes
    u and v.
 */
function linkParm(net, u, v, parm) {
    var links = net.links;
    var link = links.find(function (l) {
        return l.source === u && l.target === v;
    });
    if (link) {
        return link[parm];
    }
    link = links.find(function (l) {
        return l.source === v && l.target === u;
    });
    if (link) {
        return link[parm];
    }
    return null;
}

/* Need a check for connectedness. Will start with a depth first graph
    traversal. This is based on the non-recursive algorithm from:
    https://en.wikipedia.org/wiki/Depth-first_search

 */
function depthFirstConnected(net) {
    var nodes = net.nodes;
    if (nodes.length === 0) {
        return false;
    }
    var v = net.nodes[0].id; // Choose a starting node
    var treeNodes = new Set();
    var nodeStack = [v];
    var adjMap = genAdjs(net);

    var unvisited = new Set(nodes.map(function (n) {
        return n.id;
    }));
    unvisited.delete(v);
    var descendents = [];
    while (nodeStack.length > 0) {
        v = nodeStack.pop();
        if (!treeNodes.has(v)) {
            treeNodes.add(v);
            descendents = [].concat(_toConsumableArray(adjMap.get(v)));
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = descendents[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var node = _step11.value;

                    nodeStack.push(node);
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }
        }
    }
    return treeNodes.size === nodes.length;
}

/*
    Create an adjacency map for the network. We'll map a node id to
    a set of adjacent nodes.
 */
function genAdjs(net) {
    var adjMap = new Map();
    // For each node add a set to hold adjaciencies
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
        for (var _iterator12 = net.nodes[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var node = _step12.value;

            adjMap.set(node.id, new Set());
        }
    } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
            }
        } finally {
            if (_didIteratorError12) {
                throw _iteratorError12;
            }
        }
    }

    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
        for (var _iterator13 = net.links[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var link = _step13.value;

            adjMap.get(link.source).add(link.target);
            adjMap.get(link.target).add(link.source);
        }
    } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
            }
        } finally {
            if (_didIteratorError13) {
                throw _iteratorError13;
            }
        }
    }

    return adjMap;
}



/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "324225320862e5f2bb30c3115509aaab.png";

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(302);


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return netValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return net2NetworkXJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return netJSONreduce; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jjv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__netSchema_json__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__netSchema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__netSchema_json__);
/**
 * Created by Greg on 3/30/2016.
 */



function netValidate(netString) {
    var netObj = null,
        errors = null;
    try {
        netObj = JSON.parse(netString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (netObj) {
        var env = __WEBPACK_IMPORTED_MODULE_0_jjv___default()();
        env.checkRequired = true;
        errors = env.validate(__WEBPACK_IMPORTED_MODULE_1__netSchema_json__, netObj);
    }
    var nodeNames = [];
    if (!errors) {
        // Check node uniqueness
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = netObj.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var node = _step.value;

                if (nodeNames.indexOf(node.id) !== -1) {
                    errors = "Node IDs are not unique. Multiple nodes with id: " + node.id;
                    break;
                } else {
                    nodeNames.push(node.id);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (!errors) {
        // Check for links referencing nodes not in graph,
        var nodeMax = netObj.nodes.length;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = netObj.links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var link = _step2.value;

                if (!nodeNames.includes(link.source)) {
                    errors = "A link references a node not in the graph. Node name: " + link.source;
                    break;
                }
                if (!nodeNames.includes(link.target)) {
                    errors = "A link references a node not in the graph. Node name: " + link.target;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    if (!errors) {
        // Check for parallel links
        // We need to keep ids in both directions
        var linkIds = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = netObj.links[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _link = _step3.value;

                if (linkIds.indexOf(_link.source + "-" + _link.target) !== -1) {
                    errors = "Parallel links are not supported, All links are considered bi-directional";
                } else {
                    linkIds.push(_link.source + "-" + _link.target);
                    linkIds.push(_link.target + "-" + _link.source);
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
    if (!errors) {
        // Check for self links
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = netObj.links[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _link2 = _step4.value;

                if (_link2.source === _link2.target) {
                    errors = "Self links are not supported; Self link on node index: " + _link2.source;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }
    return { errors: errors, netObj: netObj };
}

/**
 * Converts from our internal format (node names for link source and target)
 * to NetworkX 2.0 format with node names for link source and target.
 * @param net Javascript network object in our internal format
 * @returns Javascript network object compatible with NetworkX
 */
function net2NetworkXJSON(net) {
    var tmp_graph = {};
    tmp_graph.directed = false;
    tmp_graph.multigraph = false;
    // NetworkX switched from keeping the "graph" attribute in an array to an object
    // we convert over for any old graphs.
    if (Array.isArray(net.graph)) {
        tmp_graph.graph = {};
    } else {
        tmp_graph.graph = net.graph;
    }
    tmp_graph.nodes = net.nodes;
    tmp_graph.links = net.links;

    // Convert links back to NetworkX compatible JSON format
    // let nodeMap = new Map();
    // for (let i = 0; i < tmp_graph.nodes.length; i++) {
    //     nodeMap.set(tmp_graph.nodes[i].id, i);
    // }
    // let links = net.links;
    // for (let link of links) {
    //     let tempLink = Object.assign({}, link); // Creates a copy of the link
    //     if (link.ports) {
    //         let tmp = {};
    //         tmp[link.source] = link.ports.srcPort;
    //         tmp[link.target] = link.ports.trgPort;
    //         link.ports = tmp;
    //     }
    //     tmp_graph.links.push(tempLink);
    // }
    return tmp_graph;
}

function netJSONreduce(key, val) {
    switch (key) {
        case 'x':
        case 'y':
            return Number(val.toFixed(0));
        case 'capacity':
        case 'weight':
            if (isNaN(parseFloat(val))) {
                return val;
            } else {
                return Number(val.toPrecision(5));
            }
        default:
            return val;
    }
}



/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pathCollectionValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pathValidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jjv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jjv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pathSchema_json__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pathSchema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pathSchema_json__);
/**
 * Created by Greg on 4/26/2016.
 */



/**
 * Path validator checks for valid JSON, schema compliance. We do not check
 * for compatibility of the path with the current network. See the *pathValidate*
 * function for that functionality.
 *
 * @param pathString The JSON string of paths to validate
 * @returns {boolean}
 */
function pathCollectionValidate(pathString) {
    var pathObj = null,
        errors = null;
    try {
        pathObj = JSON.parse(pathString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (pathObj) {
        var env = __WEBPACK_IMPORTED_MODULE_0_jjv___default()();
        env.checkRequired = true;
        errors = env.validate(__WEBPACK_IMPORTED_MODULE_1__pathSchema_json__, pathObj);
    }
    return { errors: errors, pathObj: pathObj };
}

/*  For reliability studies it is useful to know if a path is invalid due to
    nodes, links, or both. The path is an object that must contain a nodeList
    all other properties are ignored.
 */
function pathValidate(path, net) {
    var links = net.links;
    var nodes = net.nodes;
    var nodeList = path.nodeList;
    var valid = true;
    // Check nodes
    var missingNodes = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop2 = function _loop2() {
            var node = _step.value;

            if (!nodes.find(function (n) {
                return n.id === node;
            })) {
                missingNodes.push(node);
                valid = false;
            }
        };

        for (var _iterator = nodeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop2();
        }
        // Check links
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var missingLinks = [];

    var _loop = function _loop(j) {
        var linkFwd = links.find(function (l) {
            return l.source === nodeList[j] && l.target === nodeList[j + 1];
        });
        var linkBwd = links.find(function (l) {
            return l.source === nodeList[j + 1] && l.target === nodeList[j];
        });
        if (!(linkFwd || linkBwd)) {
            missingLinks.push(nodeList[j] + "-" + nodeList[j + 1]);
            valid = false;
        }
    };

    for (var j = 0; j < nodeList.length - 1; j++) {
        _loop(j);
    }
    return { valid: valid, missingNodes: missingNodes, missingLinks: missingLinks };
}



/***/ })

},[747]);


// WEBPACK FOOTER //
// app.bundle.js